// src/pages/WelcomePage.js - Mobile-Optimized Version
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useCallback, useRef, useMemo, startTransition } from 'react';
import GuestInfoModal from '../components/Chat/GuestInfoModal';
import { /* signInWithPopup */ } from 'firebase/auth';
import { safeSignInWithPopup } from '../firebase/config';
import CartDropdown from '../components/CartDropdown';
import logo from './shop/logo512.png';
import {
  getFeaturedItemsFromCollection as getFeaturedItems,
  getFeaturedServicesFromCollection as getFeaturedServices,
  getFollowedShopsPosts,
  getPopularPostsInArea,
  getCommunityPostsForShop,
  toggleItemLike,
  toggleFollowShop,
  getMultiShopItemsEngagement,
  toggleShopLike,
  getShopsEngagement,
  queueViewIncrement,
  flushPendingViews,
} from '../firebase/firebaseService';
import KodeQR from './KodeQR.png';
import FeaturedItem from '../components/shop/FeaturedItem';
import { CategoryScrollableGrid } from '../components/shop/CategoryGridLayouts';
import { 
  Search, Package, Navigation, ChevronUp, Grid, List, Download, ChevronDown, Store, Calendar , Plus, Minus, Info, Heart, Pin, ChevronLeft, UsersIcon, CogIcon, ChevronRight, X, Eye, ShoppingCart, RefreshCw, LogOut, Cog, Mail, Instagram, Share2, Copy, Settings, Globe, UserCheck, Loader2, QrCode, Briefcase
} from 'lucide-react';
import { CheckCircle, PlusCircle, Users, Check, MapPin } from 'lucide-react';
import { getDistance } from 'geolib';
import { STORE_TYPES, JOB_TYPE_LABEL } from '../constants/categories';
import OrderChat from '../components/Chat/OrderChat';
import { collection, getDocs, doc, getDoc, query, where } from 'firebase/firestore';
import { db, auth, googleProvider } from '../firebase/config';
import { WELCOME_STYLES, getWelcomeBackground  } from '../theme/welcomeStyles';
import { getShopData, toggleCommunityPostLike, getEventPosts  } from '../firebase/firebaseService';
import { useAuth } from '../contexts/AuthContext';
import { useLocation } from '../contexts/LocationContext';
import TreasureMap from '../components/map/TreasureMap';
import RideRouteMap from '../components/map/RideRouteMap';
import { TransactionService, buildOptimisticChat } from '../services/TransactionService';
import { signOut } from 'firebase/auth';
import { isPWA } from '../utils/pwaDetection';
import { getFeedCache, setFeedCache, clearFeedCache } from '../utils/feedCache';
import { getShopQrCode, getShopPublicUrl } from '../utils/shopQrCode';
import OrderFormPanel from '../components/shop/OrderFormPanel';
import { needsOrderForm } from '../utils/orderFormConfig';
import { formatShopPrice } from '../utils/currency';
import { formatItemLocation, reverseGeocode, formatCityStateLabel } from '../utils/locationUtils';

const LOCATION_STORAGE_KEY = 'kalkode_user_location';
const LOCATION_TIMESTAMP_KEY = 'kalkode_location_timestamp';
const LOCATION_MODE_KEY = 'kalkode_location_mode'; // ADD THIS
const LOCATION_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours
// How many cards the instant, unsorted "quick preview" shows on mount.
const QUICK_PREVIEW_COUNT = 6;

const TREASURE_BACKGROUNDS = [
];

const getDeviceInfo = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // iOS detection
  const isIOS = (
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
  
  // Android detection
  const isAndroid = /android/i.test(userAgent);
  
  // Mobile detection (includes tablets)
  const isMobile = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  
  return {
    isIOS,
    isAndroid,
    isDesktop: !isMobile,
    isMobile: isMobile
  };
};


// Add these new styled components for iPhone overlay controls:

const IOSOverlayControls = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1rem;
  pointer-events: none;
  
  > * {
    pointer-events: auto;
  }
`;

const IOSQuantityControl = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.7)'}DD`};
  backdrop-filter: blur(10px);
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.2)'};
  
  .qty-label {
    font-size: 0.75rem;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    opacity: 0.8;
    font-weight: 600;
  }
  
  button {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1.5px solid ${props => props.theme?.colors?.accent || '#800000'};
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.5)'}CC`};
    color: ${props => props.theme?.colors?.accent || '#800000'};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:active:not(:disabled) {
      transform: scale(0.9);
      background: ${props => props.theme?.colors?.accent || '#800000'};
      color: white;
    }
    
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
    
    svg {
      width: 14px;
      height: 14px;
    }
  }
  
  .qty-display {
    font-size: 1rem;
    font-weight: bold;
    color: ${props => props.theme?.colors?.text || 'white'};
    min-width: 24px;
    text-align: center;
  }
`;

const IOSOrderButton = styled.button`
  background: ${props => props.theme?.colors?.accent || '#800000'};
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.4)'};
  
  &:active:not(:disabled) {
    transform: scale(0.95);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.6)'};
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  .price {
    font-weight: 700;
  }
`;



const DesktopDistanceOverlay = styled.div`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  color: white;
  font-size: 0.85rem;
  font-weight: 600;
  z-index: 3;
  
  svg {
    width: 14px;
    height: 14px;
  }
`;

// Update ZoomContent to hide on iOS:
const ZoomContent = styled.div`
  flex: 2;  // Changed from 3 to 2
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: ${props => props.theme?.colors?.background || '#000000'};
  position: relative;
  
  /* Hide on all mobile devices */
  ${props => props.$isMobile && `
    display: none;
  `}
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => `${props.theme?.colors?.accent || '#800000'}60`};
    border-radius: 2px;
    
    &:hover {
      background: ${props => props.theme?.colors?.accent || '#800000'};
    }
  }
  
  @media (max-width: 480px) {
    padding: 0.875rem;
    gap: 0.625rem;
  }
`;

const VerticalPostCard = styled.div`
  background: ${props => props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'};
  border-radius: ${props => props.theme?.styles?.borderRadius || '12px'};
  overflow: hidden;
  border: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  
  @media (hover: hover) {
    &:hover {
      transform: translateY(-2px);
      border-color: ${props => props.theme?.colors?.accent};
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    }
  }
`;

const PostTopBar = styled.div`
  height: 5%; /* 5% for top bar */
  min-height: 48px;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}70`};
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}20`};
  
  @media (min-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const ShopInfoLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
  
  .shop-pfp {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    background: ${props => props.theme?.colors?.accent};
    flex-shrink: 0;
    cursor: pointer;
    border: 2px solid ${props => `${props.theme?.colors?.accent}40`};
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    &:hover {
      opacity: 0.8;
      transform: scale(1.05);
    }
    
    @media (min-width: 768px) {
      width: 36px;
      height: 36px;
    }
  }
  
  .shop-name {
    font-weight: 700;
    color: ${props => props.theme?.colors?.accent};
    cursor: pointer;
    text-decoration: none;
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    &:hover {
      text-decoration: underline;
    }
    
    @media (min-width: 768px) {
      font-size: 0.95rem;
    }
  }
`;

const LikeButtonRight = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.isLiked ? 
    props.theme?.colors?.accent || '#800000' : 
    `${props.theme?.colors?.text}60`};
  display: flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  padding: 0.35rem 0.5rem;
  border-radius: 8px;
  flex-shrink: 0;
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (hover: hover) {
    &:hover {
      background: ${props => `${props.theme?.colors?.accent}10`};
    }
  }
  
  svg {
    width: 20px;
    height: 20px;
    fill: ${props => props.isLiked ? 'currentColor' : 'none'};
  }
  
  span {
    font-weight: 600;
  }
  
  @media (min-width: 768px) {
    gap: 0.5rem;
    font-size: 0.9rem;
    padding: 0.5rem 0.75rem;
    
    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

const VerticalMediaContainer = styled.div`
  position: relative;
  width: 100%;
  background: ${props => `${props.theme?.colors?.background || '#000000'}80`};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img, video {
    width: 100%;
    height: auto;
    max-height: 80vh;
    object-fit: contain;
    display: block;
    background: ${props => props.theme?.colors?.background || '#000000'};
  }

  video {
    background: #000;
  }
`;

const PostBottomBar = styled.div`
  min-height: 60px;
  padding: 0.75rem;
  display: flex;  // ✅ Changed to flex for caption + like button
  align-items: center;  // ✅ Vertically center items
  justify-content: space-between;  // ✅ Space between caption and like
  gap: 0.75rem;  // ✅ Gap between items
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}90`};
  border-top: 1px solid ${props => `${props.theme?.colors?.accent}20`};
  
  @media (min-width: 768px) {
    padding: 1rem;
  }
  
  .caption {
    color: ${props => props.theme?.colors?.text};
    opacity: 0.9;
    font-size: 0.9rem;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    flex: 1;  // ✅ Take remaining space
    
    @media (min-width: 768px) {
      font-size: 0.95rem;
    }
  }
  
  .no-caption {
    color: ${props => props.theme?.colors?.text};
    opacity: 0.4;
    font-size: 0.85rem;
    font-style: italic;
    flex: 1;  // ✅ Take remaining space
  }
`;

const EventTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;  // ✅ Space between like, title, and expand
  gap: 0.5rem;
  width: 100%;  // ✅ Full width
  
  .event-name {
    font-size: 1rem;
    font-weight: 700;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;  // ✅ Take remaining space between like and expand
  }
  
  .expand-icon {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    flex-shrink: 0;
    transition: transform 0.3s ease;
    transform: ${props => props.$expanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
  
  @media (min-width: 768px) {
    .event-name {
      font-size: 1.1rem;
    }
  }
`;

// Update ImageCarousel to take full height on iOS:
const ImageCarousel = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 0;
  background: ${props => `${props.theme?.colors?.background || '#000000'}80`};
  overflow: hidden;
  
  .image-track {
    display: flex;
    height: 100%;
    width: 100%;
    transition: transform 0.3s ease;
    transform: translateX(${props => props.currentIndex * -100}%);
  }
  
  .image-slide {
    min-width: 100%;
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme?.colors?.background || '#000000'};
    
    img, video {  /* ✅ ADDED: Support for both */
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: ${props => props.theme?.colors?.background || '#000000'};
      max-width: 100%;
      max-height: 100%;
    }
    
    video {  /* ✅ ADDED: Video-specific styling */
      background: #000;
    }
    
    .no-image {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.75rem;
      color: ${props => props.theme?.colors?.text || '#FFFFFF'};
      opacity: 0.3;
      
      p {
        margin: 0;
        font-size: 0.85rem;
      }
    }
  }
  
  .carousel-dots {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 0.4rem;
    z-index: 2;
    padding: 0.4rem 0.75rem;
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.6)'}CC`};
    border-radius: 20px;
    backdrop-filter: blur(8px);
  }
  
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${props => props.theme?.colors?.text || '#FFFFFF'};
    border: none;
    padding: 0;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      transform: scale(1.2);
    }
  }
  
  .carousel-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.7)'}DD`};
    border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.2)'};
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme?.colors?.text || 'white'};
    cursor: pointer;
    opacity: 0;
    transition: all 0.3s ease;
    z-index: 2;
    
    &:hover {
      opacity: 1 !important;
      background: ${props => props.theme?.colors?.accent || '#800000'};
      transform: translateY(-50%) scale(1.1);
    }
    
    &.prev {
      left: 1rem;
    }

    &.next {
      right: 1rem;
    }

    /* Cluster nav: vertical (top / bottom), always visible */
    &.cluster-prev {
      left: 50%;
      top: auto;
      bottom: 0.6rem;
      transform: translateX(-50%);
      opacity: 0.92 !important;
      &:hover { transform: translateX(-50%) scale(1.1); }
    }

    &.cluster-next {
      left: 50%;
      top: 0.6rem;
      transform: translateX(-50%);
      opacity: 0.92 !important;
      &:hover { transform: translateX(-50%) scale(1.1); }
    }

    &:disabled {
      opacity: 0 !important;
      cursor: not-allowed;
    }

    @media (max-width: 480px) {
      width: 32px;
      height: 32px;

      &.prev {
        left: 0.5rem;
      }

      &.next {
        right: 0.5rem;
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  &:hover .carousel-button {
    opacity: 0.7;
  }
  
  .close-overlay-button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
    border: 1px solid ${props => `${props.theme?.colors?.accent}60` || 'rgba(255, 255, 255, 0.3)'};
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;
    backdrop-filter: blur(8px);
    z-index: 3;
    opacity: 0.8;
    
    &:hover {
      opacity: 1;
      background: ${props => props.theme?.colors?.accent || '#800000'};
      border-color: ${props => props.theme?.colors?.accent || '#800000'};
      transform: scale(1.1);
    }
    
    &:active {
      transform: scale(0.95);
    }
    
    @media (max-width: 480px) {
      width: 32px;
      height: 32px;
      top: 0.75rem;
      right: 0.75rem;
      
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

const LocationModeIndicator = styled.div`
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
  
  svg {
    width: 16px;
    height: 16px;
    color: ${props => props.$isIPLocation ? 
      `${props.theme?.colors?.accent}80` || 'rgba(128, 0, 0, 0.5)' : 
      props.theme?.colors?.accent || '#800000'};
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
  }
  
  @media (min-width: 768px) {
    left: 0.75rem;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

// Mobile-first styled components
const PageContainer = styled.div.attrs({ className: 'page-container' })`
  min-height: 100vh;
  /* Sticky-footer layout: MainContent (flex: 1 0 auto below) absorbs any
     leftover space when a tab's content is shorter than one viewport, so
     the page never scrolls past the Footer into blank space — the Footer
     ends the document instead of trailing behind an oversized min-height. */
  display: flex;
  flex-direction: column;
  background: ${props => props.theme?.colors?.background || '#000000'};
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  position: relative;
  /* No overflow:hidden here — it silently breaks position:sticky for any
     descendant (like the tab bar below), because it makes this element count
     as a scroll-clipping ancestor even though it never actually scrolls itself
     (the real scroll happens on the window/body). Horizontal-scroll containment
     now lives on html/body in index.css instead, which doesn't have that problem. */

  /* Mobile-optimized background effects */
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${props => props.theme?.colors?.backgroundGradient || 'radial-gradient(circle at 20% 30%, rgba(128, 0, 0, 0.2) 0%, transparent 50%)'};
    opacity: 0.8;
  }

  /* Simplified stars for mobile performance */
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: radial-gradient(circle 1px, ${props => props.theme?.colors?.text || '#FFF'} 1px, transparent 1px);
    background-size: 100px 100px;
    opacity: 0.05;
    
    @media (min-width: 768px) {
      background-size: 200px 200px;
      opacity: 0.1;
    }
  }

  /* Reduced ping animations on mobile for performance */
  .ping {
    display: none;
    
    @media (min-width: 768px) {
      display: block;
      position: absolute;
      width: 2px;
      height: 2px;
      border-radius: 50%;
      background: ${props => props.theme?.colors?.accent || '#800000'};
      pointer-events: none;
      z-index: 0;
    }
  }

`;

const LocationIndicator2 = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0.15rem auto 0.1rem;
  max-width: 800px;
  width: auto;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  
  &:hover {
    transform: scale(1.02);
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    gap: 0.2rem;
    margin: 0.2rem auto 0.05rem;
  }
  
  @media (min-width: 768px) {
    gap: 0.3rem;
  }
  
  .location-input {
    background: transparent;
    border: none;
    background: ${props => props.theme?.colors?.accentGradient || 'linear-gradient(45deg, #800000, #4A0404)'};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 1.4625rem; // 1.25rem * 1.17 = 1.4625rem
    font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
    letter-spacing: 0.585px; // 0.5px * 1.17 = 0.585px
    text-align: center;
    cursor: pointer;
    width: auto;
    line-height: 1.404; // 1.2 * 1.17 = 1.404
    font-weight: 600;
    padding: 0;
    margin: 0;
    flex-shrink: 0;
    pointer-events: none;
    
    &::placeholder {
      background: ${props => props.theme?.colors?.accentGradient ? 
        `${props.theme.colors.accentGradient.replace(')', '60)')}` : 
        'linear-gradient(45deg, rgba(128, 0, 0, 0.6), rgba(74, 4, 4, 0.6))'};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
    }
    
    @media (min-width: 768px) {
      font-size: 2.6325rem; // 2.25rem * 1.17 = 2.6325rem
      line-height: 1.404; // 1.2 * 1.17 = 1.404
      letter-spacing: 1.17px; // 1px * 1.17 = 1.17px
    }
    
    @media (max-width: 768px) {
      font-size: 1.287rem; // 1.1rem * 1.17 = 1.287rem
      letter-spacing: 0.351px; // 0.3px * 1.17 = 0.351px
    }
  }
`;

const TreasureMapIconIndicator = styled.div`
  position: absolute;
  left: -0.5in;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
  width: 35.1px; /* 30px * 1.17 = 35.1px */
  height: 35.1px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: transparent;
  }
  
  @media (min-width: 768px) {
    left: -0.6in;
    width: 30.42px; /* 26px * 1.17 = 30.42px */
    height: 30.42px;
  }
  
  @media (max-width: 768px) {
    display: none; /* ✅ Hide icon on mobile */
  }
`;

const LocationUpdateToast = styled.div`
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: ${props => `${props.theme?.colors?.background}E5`};
  backdrop-filter: blur(10px);
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}60`};
  color: ${props => props.theme?.colors?.text};
  font-size: 0.9rem;
  font-weight: 600;
  z-index: 1000;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.3s ease;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    top: 70px;
    font-size: 0.85rem;
    padding: 0.6rem 1.25rem;
  }
`;

const HeaderButton = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.theme?.colors?.accent || '#800000'};
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  opacity: 0.8;
  
  &:active {
    transform: scale(0.9);
    opacity: 1;
  }
  
  @media (hover: hover) {
    &:hover {
      opacity: 1;
      background: ${props => `${props.theme?.colors?.accent}10` || 'rgba(128, 0, 0, 0.1)'};
    }
  }
  
  &.pinned {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    opacity: 1;
  }
  
  svg {
    width: 20px;
    height: 20px;
    
    @media (min-width: 768px) {
      width: 22px;
      height: 22px;
    }
  }
`;

const BorderFrame = styled.div`
  position: relative;
  border: 3px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 20px;
  margin: 2rem;
  padding: 0;
  background: ${props => props.theme?.colors?.background || '#000000'};
  box-shadow: 
    0 0 40px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'},
    inset 0 0 40px ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.1)'};
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    border: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.2)'};
    border-radius: 12px;
    pointer-events: none;
  }
`;

const MapTriggerButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center; /* ✅ NEW: Center content */
  gap: 0.5rem;
  padding-top: 70px;
  transition: all 0.3s ease;
  position: relative;
  width: fit-content;
  top: 8rem;
  gap: 0.3rem;

  flex-direction: column;
  transform: scale(1.25); /* Keep the 55% enlargement */
  
  &::before {
    content: '';
    position: absolute;
    top: -1.6rem;
    left: -2.3rem;
    right: -2.3rem;
    bottom: -1.6rem;
    background-image: url('https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?q=80&w=1000');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.15;
    border-radius: 12px;
    z-index: -1;
    filter: sepia(0.8) brightness(1) contrast(1.2);
    
    @media (min-width: 768px) {
      opacity: 0.2;
      top: -1.725rem;
      left: -3.45rem;
      right: -3.45rem;
      bottom: -1.725rem;
    }
  }
  
  &::after {
    content: '';
    position: absolute;
    top: -1.15rem;
    left: -2.3rem;
    right: -2.3rem;
    bottom: -1.15rem;
    background: 
      repeating-linear-gradient(
        90deg,
        rgba(139, 90, 43, 0.03) 0px,
        transparent 1px,
        transparent 2px,
        rgba(139, 90, 43, 0.03) 3px
      ),
      repeating-linear-gradient(
        0deg,
        rgba(139, 90, 43, 0.03) 0px,
        transparent 1px,
        transparent 2px,
        rgba(139, 90, 43, 0.03) 3px
      );
    border-radius: 12px;
    z-index: -1;
    pointer-events: none;
    
    @media (min-width: 768px) {
      top: -1.725rem;
      left: -3.45rem;
      right: -3.45rem;
      bottom: -1.725rem;
    }
  }
  
  &:hover {
    transform: scale(1.20);
    
    &::before {
      opacity: 0.25;
      filter: sepia(0.8) brightness(0.9) contrast(1.3);
    }
    
    .scroll-icon {
      animation: bounce 0.6s ease infinite;
    }
  }
  
  &:active {
    transform: scale(1.13);
  }
  
  .scroll-icon {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  }
  
  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-4px); }
  }
  
  @media (max-width: 768px) {
    margin: 0.8in auto 0.5in; /* ✅ CHANGED: Better mobile spacing */
    gap: 0.2rem;
    top: 0rem;
    bottom: 2rem;
    
    &::before {
      top: 0.8625rem;
      left: -4.725rem;
      right: -4.725rem;
      bottom: -0.8625rem;
    }
    
    &::after {
      top: -0.8625rem;
      left: -1.725rem;
      right: -1.725rem;
      bottom: -0.8625rem;
    }
  }
`;


const MainContent = styled.main`
  max-width: 100%;
  margin: 0 auto;
  padding: 60px 1rem 100px 1rem; /* ✅ Keep top padding for header clearance */
  position: relative;
  z-index: 1;
  width: 100%;
  /* Grow to fill leftover space in the flex column above (sticky-footer),
     but never shrink below its own content height. */
  flex: 1 0 auto;
  
  @media (min-width: 768px) {
    padding: clamp(50px, 8vh, 80px) 2rem 2rem 2rem;
  }
  
  @media (max-width: 768px) {
    padding: 60px 0.5rem 80px 0.5rem;
  }
`;

// UPDATE: TabContainer - Wall-to-wall mobile with minimal styling
const TabContainer = styled.div`
  display: flex;
  gap: 0;
  margin: 0;
  overflow-x: auto;
  padding: 0;
  -webkit-overflow-scrolling: touch;
  /* Pins to the top of the viewport once scrolled content pushes it there,
     instead of scrolling away — offset tracks the header's own show/hide-on-
     scroll state so the tabs sit just under it when visible and snap to the
     very top once the header slides away, with no gap either way. */
  position: ${props => props.$sticky ? 'sticky' : 'relative'};
  top: ${props => props.$sticky ? (props.$headerVisible ? '70px' : '0px') : 'auto'};
  transition: top 0.25s ease;
  z-index: 90;
  width: 100%;
  border-top: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.2)'};
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.2)'};
  background: ${props => `${props.theme?.colors?.background || '#000000'}F2`};

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    justify-content: center;
    gap: clamp(1rem, 2vw, 1.75rem);
    overflow-x: visible;
    padding: clamp(0.25rem, 0.5vh, 0.4rem) 2rem;
    margin: clamp(0.4rem, 0.8vh, 0.7rem) 0;
    top: ${props => props.$sticky ? (props.$headerVisible ? 'clamp(50px, 8vh, 80px)' : '0px') : 'auto'};
  }

  @keyframes lineShine {
    from { background-position: 0% 0; }
    to   { background-position: 100% 0; }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background-image: linear-gradient(90deg,
      transparent 0%,   transparent 12%,
      ${props => props.theme?.colors?.accent || '#800000'}50 16%, ${props => props.theme?.colors?.accent || '#800000'} 20%, ${props => props.theme?.colors?.accent || '#800000'}50 24%,
      transparent 28%,  transparent 58%,
      ${props => props.theme?.colors?.accent || '#800000'}50 62%, ${props => props.theme?.colors?.accent || '#800000'} 66%, ${props => props.theme?.colors?.accent || '#800000'}50 70%,
      transparent 74%,  transparent 100%
    );
    background-size: 200% 100%;
    background-repeat: no-repeat;
    animation: lineShine 9s ease-in-out infinite alternate;
    z-index: 5;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 1px;
    background-image: linear-gradient(90deg,
      transparent 0%,   transparent 4%,
      ${props => props.theme?.colors?.accent || '#800000'}50 8%,  ${props => props.theme?.colors?.accent || '#800000'} 12%, ${props => props.theme?.colors?.accent || '#800000'}50 16%,
      transparent 20%,  transparent 55%,
      ${props => props.theme?.colors?.accent || '#800000'}50 59%, ${props => props.theme?.colors?.accent || '#800000'} 63%, ${props => props.theme?.colors?.accent || '#800000'}50 67%,
      transparent 71%,  transparent 100%
    );
    background-size: 200% 100%;
    background-repeat: no-repeat;
    animation: lineShine 6s ease-in-out infinite alternate-reverse;
    z-index: 5;
    pointer-events: none;
  }
`;

// UPDATE: Tab - Underline style, no boxes
const Tab = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.$color || (props.theme?.colors?.accent || '#800000')} !important;

  padding: 0.75rem 0.25rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 0.75px;
  font-weight: ${props => props.active ? '900' : '500'};
  font-size: 0.7rem;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  /* Fixed share of the bar's width (not flex:1) so a 5th tab overflows
     instead of all 5 squeezing in — reveals Gigs by scrolling right. */
  flex: 0 0 25%;
  justify-content: center;
  position: relative;

  @media (min-width: 768px) {
    flex-direction: row;
    padding: clamp(0.6rem, 1vh, 0.85rem) clamp(0.9rem, 1.8vw, 1.5rem);
    font-size: clamp(0.55rem, 0.82vh, 0.68rem);
    letter-spacing: clamp(0.8px, 0.15vh, 1.5px);
    gap: clamp(0.35rem, 0.65vh, 0.55rem);
    flex: initial;
    
    ${props => props.active && `
      &::after {
        box-shadow: 
          0 0 15px ${props.theme?.colors?.accent}90,
          0 0 30px ${props.theme?.colors?.accent}50;
      }
    `}
  }

  &:active {
    transform: translateY(2px);
  }

  @media (hover: hover) {
    &:hover {
      ${props => !props.active && `
        color: ${props.theme?.colors?.accent || '#800000'};
      `}
    }
  }

  svg {
    width: 20px;
    height: 20px;
    color: currentColor;
    transition: all 0.3s ease;
    filter: none;

    @media (min-width: 768px) {
      width: clamp(13px, 1.8vh, 17px);
      height: clamp(13px, 1.8vh, 17px);
    }
  }
`;


const TreasureMapText = styled.p`
  font-size: 1.404rem;
  line-height: 1.6; /* ✅ CHANGED: Tighter line height */
  max-width: 1000px;
  margin: 0;
  font-weight: 600;
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  letter-spacing: 5.85px;
  top: -.7rem;
  position: relative;
  text-align: center; /* ✅ NEW: Center text */
  
  background: linear-gradient(
    135deg,
    #ffd700 0%,
    #ffd700 40%,
    #ffb900 60%,
    #ffd700 80%,
    #ffed4e 100%
  );
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  
  animation: shimmer 4s linear infinite;
  
  filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.5))
          drop-shadow(0 0 12px rgba(255, 215, 0, 0.3));
  
  /* ✅ NEW: Styling for multi-line text */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem; /* Small gap between lines */
  
  > span.connector {
    font-size: 0.75em;
    font-weight: 500;
    opacity: 1; /* ✅ CHANGED: Full opacity since gradient already applied */
    letter-spacing: 2px;
    margin: 0.15rem 0;
    background: linear-gradient(
      135deg,
      #ffd700 0%,
      #ffd700 40%,
      #ffb900 60%,
      #ffd700 80%,
      #ffed4e 100%
    );
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .location {
    font-size: 1em; /* Same as "Treasure Map" */
    font-weight: 600;
    letter-spacing: 5.85px;
  }
  
  @media (max-width: 768px) {
    font-size: 1.17rem;
    margin: 0;
    letter-spacing: 1.755px;
    line-height: 1.2;
    gap: 0.05rem;
    
    .connector {
      font-size: 0.7em;
      letter-spacing: 1.5px;
      margin: 0.1rem 0;
    }
    
    .location {
      letter-spacing: 1.755px;
    }
  }
  
  @keyframes shimmer {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

const OverlayDistanceInfo = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  padding: 0.5rem 0.75rem;
  border-radius: 16px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.25)'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  svg {
    color: ${props => props.theme?.colors?.accent || '#800000'};
  }
  
  span {
    font-size: 0.85rem;
    font-weight: 600;
    color: white;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  }
  
  @media (max-width: 768px) {
    padding: 0.4rem 0.65rem;
    
    svg {
      width: 12px;
      height: 12px;
    }
    
    span {
      font-size: 0.75rem;
    }
  }
`;

const OverlayOrderButton = styled.button`
  position: absolute;
  background: ${props => props.theme?.colors?.accent || '#800000'};
  border: none;
  color: white;
  padding: 0.65rem 1.25rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.4)'};
  border: 1px solid ${props => `${props.theme?.colors?.accent}60` || 'rgba(255, 255, 255, 0.25)'};
  
  &:active:not(:disabled) {
    transform: scale(0.95);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.6)'};
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  .price {
    font-weight: 700;
  }
  
  @media (max-width: 768px) {
    padding: 0.55rem 1rem;
    font-size: 0.85rem;
    
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

const ItemInfoOverlay = styled.div`
  position: absolute;
  bottom: 4rem; // Position above the bottom buttons
  left: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.8); /* ✅ SEMI-TRANSPARENT BACKGROUND */
  backdrop-filter: blur(10px); /* ✅ BLUR EFFECT */
  -webkit-backdrop-filter: blur(10px); /* ✅ SAFARI SUPPORT */
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}20` || 'rgba(255, 255, 255, 0.15)'}; /* ✅ SUBTLE BORDER */
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); /* ✅ SUBTLE SHADOW */
  text-align: center;
  
  .item-name {
    font-size: 1.1rem;
    font-weight: 900;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin: 0;
    line-height: 1.3;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); /* ✅ SUBTLE TEXT SHADOW */
  }
  
  .item-description {
    font-size: 0.85rem;
    color: ${props => props.theme?.colors?.text || 'white'};
    opacity: 0.95;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); /* ✅ SUBTLE TEXT SHADOW */
  }
  
  .no-description {
    font-size: 0.8rem;
    color: ${props => props.theme?.colors?.text || 'white'};
    opacity: 0.7;
    font-style: italic;
    margin: 0;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); /* ✅ SUBTLE TEXT SHADOW */
  }
  
  &::-webkit-scrollbar {
    width: 3px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.6)'};
    border-radius: 2px;
  }
  
  @media (max-width: 768px) {
    bottom: 3.8rem;
    padding: 0.65rem 0.85rem;
    max-height: 120px;
    
    .item-name {
      font-size: 0.9rem;
    }
    
    .item-description {
      font-size: 0.8rem;
    }
  }
`;

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 0.5rem;
  box-sizing: border-box;
  
  /* Mobile: Adjust spacing */
  @media (max-width: 768px) {
    margin: 0.5rem auto;
    padding: 0 0.75rem; /* Reduced padding */
    width: 100%;
  }
  
  @media (min-width: 600px) {
    padding: 0;
  }

  @keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to   { opacity: 1; transform: translateY(0); }
}
  @keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}
  @keyframes slideUp {
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.$cols || 3}, 1fr);
  column-gap: 0.15rem;
  row-gap: 0.35rem;
  margin-top: 1.5rem;
  padding: 0 0.25rem;

  @media (max-width: 768px) {
    padding: 0 0.5rem;
    column-gap: 0.15rem;
    row-gap: 0.3rem;
  }

  grid-auto-rows: 1fr;
  align-items: stretch;

  @media (min-width: 480px) {
    column-gap: 0.2rem;
    row-gap: 0.4rem;
    padding: 0;
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    column-gap: 0.4rem;
    row-gap: 0.75rem;
    justify-content: center;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    column-gap: 0.5rem;
    row-gap: 1rem;
  }
`;

const SectionSeparator = styled.div`
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    ${props => props.theme?.colors?.accent || '#800000'} 50%,
    transparent 100%
  );
  margin: 0;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
  
  
  &::before, &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 50%;
    background: ${props => props.theme?.colors?.background || '#000000'};
  }
  
  &::before {
    left: 20%;
  }
  
  &::after {
    right: 20%;
  }
`;

// Update CompassLine to be above the text
const CompassLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem; // Changed from margin-top to margin-bottom
  
  .compass-image {
    width: 20px;
    height: 20px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
    
    @media (max-width: 768px) {
      width: 18px;
      height: 18px;
      margin-bottom: 0.1rem; // Minimal spacing on mobile
    }
  }
`;

const KeyboardHint = styled.div`
  position: absolute;
  top: -40px;
  right: 1rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.25)'};
  border-radius: 12px;
  padding: 0.5rem 0.75rem;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 15;
  text-align: center;
  white-space: nowrap;
  
  .zoom-container:hover & {
    opacity: 0.8;
  }
  
  kbd {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    padding: 0.15rem 0.35rem;
    border-radius: 4px;
    font-family: monospace;
    font-size: 0.7rem;
    margin: 0 0.15rem;
  }
  
  /* Hide on mobile */
  @media (max-width: 768px) {
    display: none;
  }
`;

const Header = styled.header`
  width: 100%;
  height: 70px;
  padding: 0 0.5rem;
  display: flex; /* Changed from grid to flex for all */
  justify-content: space-between;
  align-items: center;
  background: ${props => `${props.theme?.colors?.background || '#000000'}F2`};
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}4D` || 'rgba(128, 0, 0, 0.3)'};
  position: fixed;
  top: 0;
  z-index: 100;
  transition: transform 0.25s ease;
  transform: ${props => props.$visible === false ? 'translateY(-100%)' : 'translateY(0)'};

  @media (min-width: 768px) {
    height: clamp(50px, 8vh, 80px);
    padding: 0 1rem;
  }
`;

const ThemeDropdownButton = styled.button`
  background: ${props => `${props.theme?.colors?.background || '#000000'}E5`};
  backdrop-filter: blur(10px);
  color: white;
  padding: 0.4rem 0.55rem;
  border-radius: 20px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.32rem;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => `${props.theme?.colors?.background || '#000000'}F5`};
    border-color: ${props => props.theme?.colors?.accent || '#800000'};
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (min-width: 768px) {
    font-size: clamp(0.7rem, 1.1vh, 0.82rem);
    padding: clamp(3px, 0.45vh, 5px) clamp(0.5rem, 0.75vh, 0.7rem);
    gap: clamp(0.25rem, 0.4vh, 0.35rem);
  }

  .refresh-btn, .pin-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
      background: ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.3)'};
    }

    &:active {
      transform: scale(0.9);
    }

    svg {
      width: 14px;
      height: 14px;

      @media (min-width: 768px) {
        width: clamp(12px, 1.5vh, 14px);
        height: clamp(12px, 1.5vh, 14px);
      }
    }
  }

  .refresh-btn {
    color: ${props => props.theme?.colors?.accent || '#800000'};
  }

  .pin-btn {
    color: ${props => props.$isPinned ? props.theme?.colors?.accent || '#800000' : 'white'};
  }

  .style-number {
    font-weight: bold;
    font-size: 1rem;
    color: ${props => props.theme?.colors?.accent || '#800000'};

    @media (min-width: 768px) {
      font-size: clamp(0.85rem, 1.3vh, 1rem);
    }
  }
  
  .style-name {
    @media (max-width: 480px) {
      display: none;
    }
  }
  
  .chevron {
    transition: transform 0.3s ease;
    transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .spinning {
    animation: spin 0.5s linear;
  }
`;

const WelcomeTitle = styled.h1`
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  font-size: 1.5rem;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  margin: 0 0 0.25rem 0;
  font-weight: 400;
  letter-spacing: 1px;
  opacity: 0.9;
  
  @media (min-width: 768px) {
    font-size: 1.8rem;
    letter-spacing: 1.5px;
    margin: 0 0 0.5rem 0;
  }
`;

const WelcomeKalKode = styled.span`
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  font-size: 2.9rem;
  background: ${props => props.theme?.colors?.accentGradient || 'linear-gradient(45deg, #800000, #4A0404)'};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
  letter-spacing: 2px;
  display: block;
  margin-bottom: 0.5rem;

  @media (min-width: 768px) {
    font-size: 4rem;
    letter-spacing: 3px;
    margin-bottom: 0.75rem;
  }
`;

const VerticalEventCard  = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  max-width: 600px;
  margin: 2rem auto 0;
  padding: 0 1rem;
  
  @media (max-width: 768px) {
    gap: 1.5rem;
    margin: 1rem auto 0;
    padding: 0 0.5rem;
  }
`;

const VerticalPostContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  max-width: 600px;
  margin: 2rem auto 0;
  padding: 0 1rem;
  
  @media (max-width: 768px) {
    gap: 1.5rem;
    margin: 1rem auto 0;
    padding: 0 0.5rem;
  }
`;

const OverlayLikeButton = styled.button`
  position: absolute;
  bottom: 1.3rem;
  right: 1.2rem; /* Changed from 4rem to 5rem to position it further right */
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.25)'};
  padding: 0.5rem 0.75rem;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${props => props.$isLiked ? 
    props.theme?.colors?.accent || '#800000' : 
    `${props.theme?.colors?.text}80`};
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 11;
  opacity: 0.8;
  font-size: 0.85rem;
  font-weight: 600;
  
  &:hover {
    opacity: 1;
    background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.9)'}F5`};
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 18px;
    height: 18px;
    fill: ${props => props.$isLiked ? 'currentColor' : 'none'};
  }
  
  @media (max-width: 768px) {
    bottom: 1rem;
    right: 1rem; /* Changed from 3.5rem to 4.5rem for mobile */
    padding: 0.4rem 0.65rem;
    font-size: 0.8rem;
    
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const OverlayShareButton = styled.button`
  position: absolute;
  bottom: 1.3rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0,0,0,0.8)'}DD`};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255,255,255,0.25)'};
  padding: 0.5rem 0.75rem;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${props => props.theme?.colors?.text || '#fff'};
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 11;
  opacity: 0.8;
  font-size: 0.85rem;
  font-weight: 600;
  &:hover { opacity: 1; transform: scale(1.05); }
  &:active { transform: scale(0.95); }
  @media (max-width: 768px) {
    bottom: 1rem;
    padding: 0.4rem 0.65rem;
    font-size: 0.8rem;
  }
`;

const SharePanel = styled.div`
  position: absolute;
  bottom: 4.5rem;
  right: 1rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(10,10,30)'}F0`};
  backdrop-filter: blur(20px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255,255,255,0.15)'};
  border-radius: 16px;
  padding: 1rem;
  z-index: 20;
  min-width: 200px;
  display: ${props => props.$open ? 'flex' : 'none'};
  flex-direction: column;
  gap: 0.5rem;
  box-shadow: 0 8px 32px rgba(0,0,0,0.5);
`;

const SharePlatformRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const SharePlatformLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${props => props.theme?.colors?.accent || '#aaa'};
  padding: 0 0.25rem;
`;

const ShareOptionRow = styled.div`
  display: flex;
  gap: 0.4rem;
`;

const ShareOptionBtn = styled.button`
  flex: 1;
  padding: 0.35rem 0.5rem;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.06);
  color: #fff;
  font-size: 0.72rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  &:hover { background: rgba(255,255,255,0.14); border-color: rgba(255,255,255,0.25); }
`;

const CopyLinkBtn = styled.button`
  width: 100%;
  padding: 0.45rem;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.15);
  background: rgba(255,255,255,0.05);
  color: #fff;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  transition: all 0.2s;
  margin-top: 0.25rem;
  &:hover { background: rgba(255,255,255,0.12); }
`;

const ItemNameOverlay = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}20` || 'rgba(255, 255, 255, 0.15)'};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 80%;
  z-index: 10;
  outline: expand 20px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};
  
  .item-name {
    font-size: 1.1rem;
    font-weight: 900;
    color:  '#ffffffff';
    margin: 0;
    line-height: 1.3;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  @media (max-width: 768px) {
    bottom: 1rem;
    padding: 0.65rem 0.85rem;
    max-width: 70%;
    
    .item-name {
      font-size: 0.9rem;
    }
  }
`;

const OverlayQuantityControl = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column; /* ✅ CHANGED: vertical layout */
  align-items: center;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  padding: 0.75rem 0.5rem; /* ✅ CHANGED: adjusted padding for vertical */
  border-radius: 20px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.25)'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  button {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(8px);
    color: ${props => props.theme?.colors?.accent || '#800000'};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:active:not(:disabled) {
      transform: scale(0.9);
      background: ${props => props.theme?.colors?.accent || '#800000'};
      color: white;
    }
    
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
    
    svg {
      width: 16px;
      height: 16px;
    }
  }
  
  .qty-display {
    font-size: 1.1rem;
    font-weight: bold;
    color: white;
    min-width: 28px; /* ✅ CHANGED: reduced width since it's vertical */
    text-align: center;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  }
  
  @media (max-width: 768px) {
    padding: 0.65rem 0.4rem; /* ✅ CHANGED: adjusted padding for mobile */
    
    button {
      width: 28px;
      height: 28px;
      
      svg {
        width: 14px;
        height: 14px;
      }
    }
    
    .qty-display {
      font-size: 1rem;
      min-width: 24px;
    }
  }
`;

const ItemDescriptionOverlay = styled.div`
  position: absolute;
  bottom: 1.5rem;
  left: 44%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}20` || 'rgba(255, 255, 255, 0.15)'};
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 95%;
  z-index: 10;
  
  .item-description {
    font-size: 0.85rem;
    color: ${props => props.theme?.colors?.text || 'white'};
    opacity: 0.95;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  .no-description {
    font-size: 0.8rem;
    color: ${props => props.theme?.colors?.text || 'white'};
    opacity: 0.7;
    font-style: italic;
    margin: 0;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  &::-webkit-scrollbar {
    width: 3px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.6)'};
    border-radius: 2px;
  }
  
  @media (max-width: 768px) {
    bottom: 0.75rem;
    padding: 0.65rem 0.85rem;
    max-height: 120px;
    max-width: 70%;
    
    .item-description {
      font-size: 0.8rem;
    }
  }
`;

const VerticalLikeButton = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.isLiked ? 
    props.theme?.colors?.accent || '#800000' : 
    `${props.theme?.colors?.text}60`};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  padding: 0.5rem;
  border-radius: 8px;
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (hover: hover) {
    &:hover {
      background: ${props => `${props.theme?.colors?.accent}10`};
    }
  }
  
  svg {
    width: 22px;
    height: 22px;
    fill: ${props => props.isLiked ? 'currentColor' : 'none'};
  }
  
  span {
    font-weight: 600;
  }
`;

const VerticalShopRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.9rem;
  
  .shop-pfp {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    background: ${props => props.theme?.colors?.accent};
    flex-shrink: 0;
    cursor: pointer;
    border: 2px solid ${props => `${props.theme?.colors?.accent}40`};
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    &:hover {
      opacity: 0.8;
      transform: scale(1.05);
    }
  }
  
  .content-wrapper {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .shop-name {
    font-weight: 700;
    color: ${props => props.theme?.colors?.accent};
    cursor: pointer;
    text-decoration: none;
    font-size: 0.95rem;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  .caption {
    color: ${props => props.theme?.colors?.text};
    opacity: 0.9;
    line-height: 1.4;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
`;

const PostDivider = styled.div`
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    ${props => props.theme?.colors?.accent || '#800000'} 50%,
    transparent 100%
  );
  margin: 0.5rem 0;
  position: relative;
  
  &::before, &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 50%;
    background: ${props => props.theme?.colors?.background || '#000000'};
  }
  
  &::before {
    left: 10%;
  }
  
  &::after {
    right: 10%;
  }
`;

const SectionLabel = styled.div`
  text-align: center;
  padding: 0.75rem 1rem;
  margin: 1.5rem 0 1rem;
  background: ${props => `${props.theme?.colors?.surface}30`};
  border-radius: 12px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}30`};
  
  h3 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: ${props => props.theme?.colors?.accent};
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  @media (max-width: 768px) {
    padding: 0.625rem 0.875rem;
    margin: 1rem 0 0.75rem;
    
    h3 {
      font-size: 0.85rem;
      letter-spacing: 0.8px;
    }
  }
`;

const ZoomOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.95)'}F5`};
  z-index: 12000; /* Higher than map (11000) */
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.5rem;
  }
`;

const DesktopStoreOverlay = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 3;
  
  &:hover {
    background: rgba(0, 0, 0, 0.7);
    transform: scale(1.02);
  }
  
  .shop-pfp {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
    background: ${props => props.theme?.colors?.accent || '#800000'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .shop-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: white;
  }
`;

const OverlayStoreInfo = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  padding: 0.4rem 0.65rem;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:active {
    transform: scale(0.95);
  }
  
  .shop-pfp {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    overflow: hidden;
    border: 1.5px solid ${props => props.theme?.colors?.accent || '#800000'};
    background: ${props => props.theme?.colors?.accent || '#800000'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .shop-name {
    font-size: 0.75rem;
    font-weight: 600;
    color: white;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  }
`;

const ZoomContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  height: calc(100vh - 5rem);
  max-height: ${props => props.$restaurantOpen ? '960px' : '700px'};
  background: ${props => props.theme?.colors?.background || '#000000'};
  border-radius: 16px;
  overflow: hidden;
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  transition: max-height 0.35s ease;

  @media (max-width: 768px) {
    max-width: 420px;
    border-radius: 12px;
    height: calc(100vh - 2rem);
    max-height: ${props => props.$restaurantOpen ? '910px' : '650px'};
  }

  @media (max-width: 480px) {
    max-width: 95%;
    border-radius: 10px;
    height: calc(100vh - 1rem);
    max-height: ${props => props.$restaurantOpen ? '860px' : '600px'};
  }
`;

// ADD LogoImage component
const LogoImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.3s ease;
  flex-shrink: 0;

  @media (min-width: 768px) {
    width: clamp(22px, 3vh, 30px);
    height: clamp(22px, 3vh, 30px);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (hover: hover) {
    &:hover {
      transform: scale(1.05);
    }
  }
`;

// UPDATE Logo component
const Logo = styled.div`
  color: ${props => props.theme?.colors?.accent || '#800000'};
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  font-size: 1rem;
  letter-spacing: 0.5px;
  cursor: pointer;
  flex-shrink: 0;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;

  @media (min-width: 768px) {
    font-size: 1.3rem;
    letter-spacing: 1px;
    max-width: 250px;
    left: 20;
  }
`;

const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: flex-end; /* ✅ NEW: Align to right */
`;

// ADD NEW: Location text within map button
const MapLocationText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  opacity: 0.85;
  font-weight: 500;
  margin-top: 0.25rem;
  
  svg {
    width: 14px;
    height: 14px;
    color: ${props => props.theme?.colors?.accent || '#800000'};
  }
  
  @media (min-width: 768px) {
    font-size: 1rem;
    gap: 0.5rem;
    
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

// ADD NEW: Header left section with logo and title
const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
  cursor: pointer;
  
  @media (min-width: 768px) {
    gap: 1rem;
  }
`;

// UPDATE: Logo styling for header context
const HeaderTitle = styled.h1`
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  font-size: 1.5rem;
  background: ${props => props.theme?.colors?.accentGradient || 'linear-gradient(45deg, #800000, #4A0404)'};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  letter-spacing: 1px;
  line-height: 1;

  @media (min-width: 768px) {
    font-size: clamp(1.1rem, 2.2vh, 1.5rem);
    letter-spacing: clamp(1px, 0.2vh, 2px);
  }
`;

// Replace MobileOverlayControls and add new components
const MobileOverlayControls = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  pointer-events: none;
  
  > * {
    pointer-events: auto;
  }
`;

// Add to styled components section in WelcomePage.js
const LocationIndicator = styled.div`
  position: fixed;
  top: 90px;
  left: 2rem;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.3)'};
  backdrop-filter: blur(4px);
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  font-size: 0.9rem;
  z-index: 10;
  cursor: pointer;
  transition: all 0.3s ease;
  max-width: 300px;
  
  /* Hide on mobile, show only on desktop for debugging */
  @media (max-width: 768px) {
  width: auto;
    padding: 1rem 2.5rem;
    font-size: 1rem;
  } 
  
  &:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: translateY(-2px);
  }
  
  .location-icon {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin-right: 0.75rem;
  }
  
  .location-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .updating {
    margin-left: 0.5rem;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(128, 0, 0, 0.2);
    border-radius: 50%;
    border-top-color: ${props => props.theme?.colors?.accent || '#800000'};
    animation: spin 1s linear infinite;
  }
`;

const CategoryGridWrapper = styled.div`
  /* Wrapper kept for structural compatibility; layout handled by CategoryScrollableGrid */
`;

const ActionButton = styled.button`
  background: ${props => {
    if (props.variant === 'outline') {
      return 'transparent';
    }
    
    const accentGradient = props.theme?.colors?.accentGradient || 'linear-gradient(45deg, #800000, #4A0404)';
    
    const darkenedGradient = accentGradient
      .replace('#800000', '#660000')
      .replace('#4A0404', '#3B0303')
      .replace('800000', '660000')
      .replace('4A0404', '3B0303');
    
    return darkenedGradient;
  }};
  
  border: ${props => props.variant === 'outline' ? 
    `2px solid ${props.theme?.colors?.accent || '#800000'}` : 'none'};
  padding: 0.875rem 1.25rem;
  border-radius: 30px;
  color: ${props => props.variant === 'outline' ?
    props.theme?.colors?.accent || '#800000' : 'white'};
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.85rem;
  width: 100%;
  white-space: nowrap;
  flex: 1;

  /* Desktop header styling */
  @media (min-width: 769px) {
    width: auto;
    padding: 0.75rem 1.5rem;
    font-size: 0.85rem;
    flex: initial;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (hover: hover) {
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px ${props => {
        const accent = props.theme?.colors?.accent || '#800000';
        return `${accent}66`;
      }};
      
      background: ${props => {
        if (props.variant === 'outline') {
          return `${props.theme?.colors?.accent}20`;
        }
        
        const accentGradient = props.theme?.colors?.accentGradient || 'linear-gradient(45deg, #800000, #4A0404)';
        
        const hoverGradient = accentGradient
          .replace('#800000', '#4D0000')
          .replace('#4A0404', '#2E0202')
          .replace('800000', '4D0000')
          .replace('4A0404', '2E0202');
        
        return hoverGradient;
      }};
    }
  }
  
  @media (max-width: 380px) {
    font-size: 0.75rem; /* ✅ Even smaller on tiny screens */
    padding: 0.75rem 1rem;
    letter-spacing: 0.5px;
  }
`;

const SignInButton = styled.button`
  padding: 0.875rem 1.25rem;
  background: transparent;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  flex: 1;
  width: 100%;

  /* Desktop header styling */
  @media (min-width: 769px) {
    padding: 0.75rem 1.5rem;
    font-size: 0.85rem;
    border: 2px solid ${props => props.theme?.colors?.accent || 'rgba(128, 0, 0, 0.3)'};
    width: auto;
    flex: initial;
  }

  @media (max-width: 768px) {
    border: 2px solid ${props => props.theme?.colors?.accent || 'rgba(128, 0, 0, 0.3)'};
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
    
    @media (min-width: 769px) {
      border-color: ${props => props.theme?.colors?.accent || '#800000'};
      background: ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  img {
    width: 16px; /* ✅ CHANGED: Smaller icon */
    height: 16px;
    flex-shrink: 0;
    
    @media (min-width: 769px) {
      width: 16px;
      height: 16px;
    }
  }
  
  @media (max-width: 380px) {
    font-size: 0.75rem;
    padding: 0.75rem 1rem;
    gap: 0.4rem;
    
    img {
      width: 14px;
      height: 14px;
    }
  }
`;

// Updated CategoryHeader styled component
const CategoryHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0 1rem;
  position: relative;
  min-height: 48px;
  
  @media (max-width: 768px) {
    padding: 0 0.75rem;
    margin-bottom: 0.5rem;
    min-height: 44px;
  }
  
  @media (min-width: 768px) {
    margin-bottom: 1rem;
    min-height: 52px;
  }
  
  h2 {
    font-family: ${props => props.theme?.fonts?.heading || 'inherit'};
    font-size: 1.3rem;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin: 0;
    text-align: center;

    @media (min-width: 768px) {
      font-size: 1.8rem;
    }
  }

  /* The count and search toggle sit at a fixed distance from center
     (calc(50% - 2in) each side) so they stay vertically aligned across
     rows. Cap the title label's own width so long category names always
     truncate before reaching them instead of overlapping — a guaranteed
     minimum gap that shrinks naturally as the label grows, rather than a
     static distance measured from the label's (variable-width) edge. */
  .category-title-label {
    @media (min-width: 768px) {
      max-width: calc(4in - 4.5rem);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      vertical-align: bottom;
    }
  }
  
  /* Count - positioned to the left */
  .item-count {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.75rem;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    opacity: 0.6;
    font-weight: 500;

    @media (max-width: 768px) {
      left: 0.75rem;
      font-size: 0.7rem;
    }

    @media (min-width: 768px) {
      font-size: 0.85rem;
      /* Fixed distance from the header's horizontal center (not the title's
         own edge, which would move with every category's text length) —
         keeps every row's count vertically aligned with the others, and
         stays out of flow so the <h2> itself is still perfectly centered,
         independent of the count's width. */
      left: calc(50% - 2in);
    }
  }

  /* Search toggle - positioned to the right */
  .mobile-search-toggle {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    /* Guarantees it's on top of (and clickable over) the centered <h2>
       whenever its rendered width happens to reach this far — the title has
       no z-index of its own, but this makes the stacking explicit instead
       of relying on default DOM-order painting. */
    z-index: 2;
    background: transparent;
    border: 1px solid ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    
    &:active {
      transform: scale(0.95);
      background: ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
    }
    
    @media (hover: hover) {
      &:hover {
        background: ${props => `${props.theme?.colors?.accent}15` || 'rgba(128, 0, 0, 0.15)'};
      }
    }
    
    @media (max-width: 768px) {
      right: 0.75rem;
      width: 34px;
      height: 34px;
      
      svg {
        width: 16px;
        height: 16px;
      }
    }
    
    @media (min-width: 768px) {
      width: 38px;
      height: 38px;
      /* Same fixed distance from center as .item-count, mirrored to the
         right, so both sit symmetrically around the centered title. */
      right: calc(50% - 2in);

      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
`;

const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(128, 0, 0, 0.2);
  border-radius: 25px;
  overflow: hidden;
  
  &:focus-within {
    border-color: rgba(128, 0, 0, 0.4);
    background: rgba(255, 255, 255, 0.08);
  }
`;

const BottomNavContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: ${props => `${props.theme?.colors?.background || '#000000'}F5`};
  backdrop-filter: blur(20px);
  border-top: 1px solid ${props => `${props.theme?.colors?.accent || '#800000'}30`};
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 1rem;
  z-index: 1000;
  
  /* Only show on mobile for unauthenticated users */
  @media (min-width: 769px) {
    display: none;
  }
`;

const NavButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: ${props => props.active ? 
    props.theme?.colors?.accent || '#800000' : 
    `${props.theme?.colors?.text || '#FFFFFF'}80`
  };
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
  min-width: 70px;
  flex: 1;
  max-width: 120px;
  
  &:active {
    transform: scale(0.95);
  }
  
  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    position: relative;
  }
  
  .label {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    opacity: ${props => props.active ? 1 : 0.8};
  }
  
  /* Active state indicator */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: ${props => props.active ? '4px' : '0'};
    height: 3px;
    background: ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 2px 2px 0 0;
    transition: width 0.3s ease;
  }
`;

const SearchInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  padding: 0.8rem 1rem;
  color: white;
  font-size: 1rem;
  -webkit-appearance: none;
  
  &:focus {
    outline: none;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

const SearchButtonGroup = styled.div`
  display: flex;
  gap: 0.25rem;
  padding: 0.4rem;
  align-items: center;
`;

const SearchButton = styled.button`
  background: ${props => props.active ? 
    'rgba(128, 0, 0, 0.3)' : 
    'rgba(128, 0, 0, 0.15)'};
  border: 1px solid ${props => props.active ?
    'rgba(128, 0, 0, 0.5)' :
    'rgba(128, 0, 0, 0.2)'};
  padding: 0.5rem;
  border-radius: 50%;
  color: white;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  
  &:active {
    transform: scale(0.95);
    background: rgba(128, 0, 0, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
  }
  
  /* Active indicator dot */
  &::after {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${props => props.theme?.colors?.accent || '#800000'};
    opacity: ${props => props.active ? 1 : 0};
    transition: opacity 0.2s ease;
  }
`;

const FilterToggle = styled.div`
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  z-index: 90;
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0.25rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0,0,0,0.85)'}EE`};
  backdrop-filter: blur(12px);
  border-radius: 20px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
  box-shadow: 0 4px 20px rgba(0,0,0,0.4);
  transition: bottom 0.3s ease;
  @media (max-width: 767px) {
    /* Clears the fixed bottom nav for logged-in users; guests have no
       bottom bar to avoid. */
    bottom: ${props => props.$isAuthenticated ? '5rem' : '1rem'};
  }
  @media (min-width: 768px) {
    bottom: clamp(0.5rem, 1vh, 0.75rem);
    left: clamp(0.5rem, 1vw, 0.75rem);
    padding: 0.2rem;
  }
`;

const FilterButton = styled.button`
  background: ${props => props.active ?
    props.theme?.colors?.accent || '#800000' :
    'transparent'};
  border: none;
  padding: 0.5rem 0.65rem;
  border-radius: 14px;
  color: ${props => props.active ?
    '#FFFFFF' :
    props.theme?.colors?.text || '#FFFFFF'};
  font-weight: ${props => props.active ? '700' : '600'};
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  white-space: nowrap;
  
  &:active {
    transform: scale(0.98);
  }
  
  @media (hover: hover) {
    &:hover {
      background: ${props => props.active ? 
        props.theme?.colors?.primary || '#4A0404' : 
        `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
    }
  }
  
  svg {
    width: 16px;
    height: 16px;
  }

  @media (max-width: 768px) {
    padding: 0.45rem 0.6rem;
  }

  @media (min-width: 769px) {
    padding: clamp(3px, 0.4vh, 5px) clamp(0.4rem, 0.6vh, 0.55rem);
    font-size: clamp(0.7rem, 1vh, 0.78rem);
    svg {
      width: clamp(12px, 1.4vh, 14px);
      height: clamp(12px, 1.4vh, 14px);
    }
  }
`;

// Small popover anchored above the Following filter button — shown instead of
// jumping straight to Google sign-in when a guest taps "Following", since
// they have no followed shops to see until they're signed in anyway.
const FollowingLoginPopover = styled.div`
  position: fixed;
  bottom: calc(1rem + 52px);
  left: 1rem;
  z-index: 91;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.65rem 0.9rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0,0,0,0.9)'}F5`};
  backdrop-filter: blur(12px);
  border-radius: 14px;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
  box-shadow: 0 8px 24px rgba(0,0,0,0.5);
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.82rem;
  font-weight: 600;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  animation: followingPromptIn 0.2s ease-out;

  @keyframes followingPromptIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }

  img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  @media (max-width: 767px) {
    bottom: calc(5rem + 52px);
  }

  @media (min-width: 768px) {
    bottom: calc(clamp(0.5rem, 1vh, 0.75rem) + 44px);
    font-size: 0.78rem;
    padding: 0.55rem 0.8rem;
  }
`;

const GridToggleBtn = styled.button`
  background: ${props => props.$active ? props.theme?.colors?.accent || '#800000' : 'transparent'};
  border: 1px solid ${props => `${props.theme?.colors?.accent || '#800000'}60`};
  border-radius: 12px;
  padding: 0.45rem 0.55rem;
  color: ${props => props.$active ? '#fff' : `${props.theme?.colors?.text || '#fff'}80`};
  font-size: 0.7rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:active { transform: scale(0.95); }

  @media (min-width: 768px) { display: none; }

  svg { width: 13px; height: 13px; }
`;

const FollowButton = styled.button`
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
  backdrop-filter: blur(10px);
  border: 1.5px solid ${props => props.$isFollowing ? 
    '#4CAF50' : 
    `${props.theme?.colors?.accent}60` || 'rgba(255, 255, 255, 0.4)'};
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.$isFollowing ? '#4CAF50' : props.theme?.colors?.accent || '#800000'};
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 5;
  opacity: ${props => props.$isLoading ? 0.5 : 0.9};
  flex-shrink: 0;  // ✅ NEW: Prevent shrinking in flexbox
  
  &:hover {
    opacity: 1;
    transform: scale(1.1);
    background: ${props => props.$isFollowing ? 
      '#4CAF50' : 
      props.theme?.colors?.accent || '#800000'};
    color: white;
    border-color: ${props => props.$isFollowing ? '#4CAF50' : props.theme?.colors?.accent};
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  
  svg {
    width: 16px;
    height: 16px;
    pointer-events: none;
  }
  
  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
    
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;


// Mobile-friendly slider with native scroll
const SliderContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  margin: 1.5rem 0;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${props => `${props.theme?.colors?.background || '#000000'}80`};
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 10px;
  }
  
  /* Hide scroll buttons on mobile */
  .scroll-button {
    display: none;
    
    @media (min-width: 768px) {
      display: flex;
    }
  }
`;

const Slider = styled.div`
  display: flex;
  width: fit-content;
  padding: 0.5rem 0;
`;

const SlideItem = styled.div`
  flex: 0 0 160px;
  margin-right: 0.75rem;
  scroll-snap-align: start;
  
  @media (min-width: 480px) {
    flex: 0 0 200px;
    margin-right: 1rem;
  }
  
  @media (min-width: 768px) {
    flex: 0 0 250px;
    margin-right: 1.5rem;
  }
  
  @media (min-width: 1024px) {
    flex: 0 0 300px;
    margin-right: 2rem;
  }
`;





// Add styles for better item display
const ItemDetailsSection = styled.div`
  margin-bottom: 1.5rem;
`;

const ItemHeader = styled.div`
  margin-bottom: 1.5rem;
  
  h3 {
    font-size: 1.5rem;
    margin: 0 0 0.5rem 0;
    font-family: ${props => props.theme?.fonts?.heading || 'inherit'};
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    
    @media (min-width: 768px) {
      font-size: 1.8rem;
    }
  }

  .price {
    font-size: 1.3rem;
    font-weight: bold;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin-bottom: 1rem;
    
    @media (min-width: 768px) {
      font-size: 1.5rem;
    }
  }
`;

const CategoryBadge = styled.div`
  display: inline-block;
  background: ${props => `${props.theme?.colors?.accent || '#800000'}20`};
  color: ${props => props.theme?.colors?.accent || '#800000'};
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
`;

const StockStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  
  .stock-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${props => props.inStock ? '#4CAF50' : '#FF5252'};
  }
  
  .stock-text {
    color: ${props => props.inStock ? '#4CAF50' : '#FF5252'};
    font-weight: 500;
  }
`;

const ItemDescription = styled.div`
  font-size: 0.95rem;
  opacity: 0.9;
  margin-bottom: 1.5rem;
  line-height: 1.6;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
`;

const ItemLocation = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  opacity: 0.8;
  margin-bottom: 1.5rem;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
`;

const InfoButton = styled.button`
  position: absolute;
  bottom: 1.5rem;
  right: 5rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.25)'};
  width: 30px;
  height: 30px;
  border-radius: 15px;

  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme?.colors?.accent || '#800000'};
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 11;
  opacity: ${props => props.$isOpen ? 1 : 0.8};
  
  
  
  
  
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    bottom: 1rem;
    right: 4.5rem;
    
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const InfoPanel = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 4.5rem;
  right: 7.5rem;
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.9)'}F5`};
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(255, 255, 255, 0.25)'};
  border-radius: 16px;
  padding: 1rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  opacity: ${props => props.$isOpen ? 1 : 0};
  transform: translateY(${props => props.$isOpen ? '0' : '20px'});
  pointer-events: ${props => props.$isOpen ? 'auto' : 'none'};
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  
  .info-content {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .description-section {
    font-size: 0.9rem;
    line-height: 1.5;
    color: ${props => props.theme?.colors?.text || 'white'};
    opacity: 0.95;
  }
  
  .engagement-section {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-top: 0.75rem;
    border-top: 1px solid ${props => `${props.theme?.colors?.accent}20` || 'rgba(255, 255, 255, 0.1)'};
  }
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.6)'};
    border-radius: 2px;
  }
  
  @media (max-width: 768px) {
    left: 3.8rem;
    right: 7rem;
    padding: 0.875rem;
    max-height: 180px;
    bottom: 1rem;
    
    .description-section {
      font-size: 0.85rem;
    }
  }
`;

const ThemeDropdownContainer = styled.div`
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 90;
  transition: bottom 0.3s ease;
  @media (max-width: 767px) {
    /* Clears the fixed bottom nav for logged-in users; guests have no
       bottom bar to avoid. */
    bottom: ${props => props.$isAuthenticated ? '5rem' : '1rem'};
  }
`;

const ThemeDropdownMenu = styled.div`
  position: absolute;
  bottom: calc(100% + 0.5rem);
  right: 0;
  background: ${props => `${props.theme?.colors?.background || '#000000'}F5`};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
  border-radius: 12px;
  padding: 0.5rem;
  max-height: 400px;
  overflow-y: auto;
  opacity: ${props => props.$isOpen ? 1 : 0};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transform: translateY(${props => props.$isOpen ? '0' : '10px'});
  transition: all 0.3s ease;
  min-width: 400px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 3px;
    
    &:hover {
      background: ${props => props.theme?.colors?.primary || '#4A0404'};
    }
  }
  
  @media (max-width: 768px) {
    max-height: 300px;
    min-width: 180px;
  }
`;

const ThemeMenuItem = styled.button`
  width: 100%;
  background: ${props => props.$isActive ? 
    `${props.theme?.colors?.accent}30` : 
    'transparent'};
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: white;
  text-align: left;
  margin-bottom: 0.25rem;
  
  &:hover {
    background: ${props => `${props.theme?.colors?.accent}20`};
    transform: translateX(2px);
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  .style-number {
    font-weight: bold;
    font-size: 0.9rem;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    min-width: 30px;
  }
  
  .style-name {
    font-size: 0.85rem;
    flex: 1;
  }
  
  .active-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${props => props.theme?.colors?.accent || '#800000'};
    opacity: ${props => props.$isActive ? 1 : 0};
  }
  
  @media (max-width: 768px) {
    padding: 0.6rem 0.85rem;
    
    .style-number {
      font-size: 0.8rem;
    }
    
    .style-name {
      font-size: 0.8rem;
    }
  }
`;

// Mobile-friendly floating controls - removed since they're now in header
const StyleIndicator = styled.div`
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  background: ${props => `${props.theme?.colors?.background || '#000000'}E5`};
  backdrop-filter: blur(10px);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
  z-index: 90;
  
  @media (min-width: 768px) {
    font-size: 0.9rem;
  }
  
  .style-number {
    font-weight: bold;
    font-size: 1rem;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    
    @media (min-width: 768px) {
      font-size: 1.2rem;
    }
  }
`;

// Quantity selector optimized for mobile
const QuantitySelector = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}50`};
  border-radius: 12px;
  padding: 1rem;
  margin: 1rem 0;
  
  .quantity-label {
    font-weight: bold;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    font-size: 0.9rem;
  }
  
  .quantity-controls {
    display: flex;
    align-items: center;
    gap: 1rem;
    
    .quantity-btn {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
      background: transparent;
      color: ${props => props.theme?.colors?.accent || '#800000'};
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;
      -webkit-tap-highlight-color: transparent;
      
      &:active:not(:disabled) {
        transform: scale(0.9);
        background: ${props => props.theme?.colors?.accent || '#800000'};
        color: white;
      }
      
      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
      
      svg {
        width: 18px;
        height: 18px;
      }
    }
    
    .quantity-display {
      font-size: 1.3rem;
      font-weight: bold;
      color: ${props => props.theme?.colors?.text || 'white'};
      min-width: 40px;
      text-align: center;
    }
  }
`;

// Other styled components remain the same but with mobile optimizations...
const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  margin: 2rem auto;
  border: 3px solid rgba(128, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #800000;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const EmptyGridMessage = styled.div`
  text-align: center;
  padding: 2rem 1rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(128, 0, 0, 0.1);
  color: rgba(255, 255, 255, 0.7);
  grid-column: 1/-1;

  h3 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    color: rgba(255, 255, 255, 0.9);
  }

  p {
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

const ProfileImage = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 1rem;
  border: 4px solid ${props => props.theme?.colors?.accent || '#800000'};
  box-shadow: 0 0 20px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.25)'};

  @media (min-width: 768px) {
    width: clamp(65px, 9.5vh, 88px);
    height: clamp(65px, 9.5vh, 88px);
    border: 3px solid ${props => props.theme?.colors?.accent || '#800000'};
    margin-bottom: clamp(0.3rem, 0.55vh, 0.45rem);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ShopName = styled.h2`
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  font-size: 1.8rem;
  background: ${props => props.theme?.colors?.accentGradient || 'linear-gradient(45deg, #800000, #4A0404)'};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: clamp(1.3rem, 2.8vh, 1.9rem);
    padding-top: clamp(0.4rem, 0.7vh, 0.6rem);
  }
`;

const WelcomeSection = styled.section`
  text-align: center;
  margin: 0;
  position: relative;
  padding-bottom: 0;
  
  @media (min-width: 769px) {
    min-height: auto;
    padding-top: clamp(0.3rem, 0.6vh, 0.5rem);
    padding-bottom: 0rem;
  }
  
  @media (max-width: 768px) {
    background: transparent;
    border: none;
    box-shadow: none;
    padding-top: 0.25in;
    padding-bottom: 0.5rem;
  }
  
  p {
    font-size: 1.2rem;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
    color: ${props => `${props.theme?.colors?.text}CC` || 'rgba(255, 255, 255, 0.8)'};
    font-weight: 300;
    font-family: ${props => props.theme?.fonts?.body || 'sans-serif'};
    
    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }
  }
`;

const ActionButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  width: 80%;
  max-width: 250px;
  margin: 1rem auto 0; /* Reduced margin */
  padding: 0 1rem;
  justify-content: center;
  
  @media (min-width: 769px) {
    max-width: 300px;
    gap: 1rem;
    margin: 1.5rem auto 0; /* Reduced margin */
  }
  
  @media (max-width: 380px) {
    gap: 0.5rem;
    padding: 0 0.75rem;
    margin: 0.75rem auto 0;
  }
`;

// Add with other styled components (around line 400)
const PWAInstallButton = styled.button`
  background: transparent;
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme?.colors?.accent || '#800000'};
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  flex-shrink: 0;
  
  &:hover {
    background: ${props => `${props.theme?.colors?.accent}15` || 'rgba(128, 0, 0, 0.15)'};
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 20px;
    height: 20px;
  }
  
  /* Pulse animation to draw attention */
  &::after {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 50%;
    opacity: 0;
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      opacity: 0;
      transform: scale(1);
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
      transform: scale(1.3);
    }
  }
  
  @media (min-width: 768px) {
    width: 44px;
    height: 44px;
    margin-left: 1rem;
    
    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

const QRCodeOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(10px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  opacity: ${props => props.isOpen ? 1 : 0};
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
  transition: opacity 0.3s ease;
`;

const QRCodeContainer = styled.div`
  background: ${props => props.theme?.colors?.background || '#000000'};
  border: 3px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 20px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  position: relative;
  transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.9)'};
  opacity: ${props => props.isOpen ? 1 : 0};
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.25s ease;

  @media (max-width: 768px) {
    padding: 1.5rem;
    border-radius: 16px;
  }
`;

const qrSpin = keyframes`
  to { transform: rotate(360deg); }
`;

const QRCodeImageWrap = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 250px;
  height: 250px;

  @media (max-width: 768px) {
    padding: 1rem;
    width: 220px;
    height: 220px;
  }
`;

const QRCodeSpinnerIcon = styled(Loader2)`
  animation: ${qrSpin} 1s linear infinite;
  color: ${props => props.theme?.colors?.accent || '#800000'};
`;

const QRCodeLinkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: ${props => `${props.theme?.colors?.accent}12` || 'rgba(128, 0, 0, 0.08)'};
  border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.3)'};
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  padding: 0.6rem 1rem;
  border-radius: 12px;
  font-size: 0.8rem;
  cursor: pointer;
  width: 100%;
  transition: all 0.2s ease;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 230px;
  }

  &:hover {
    background: ${props => `${props.theme?.colors?.accent}22` || 'rgba(128, 0, 0, 0.15)'};
    border-color: ${props => props.theme?.colors?.accent || '#800000'};
  }

  &:active {
    transform: scale(0.97);
  }
`;

const QRCodeTitle = styled.h2`
  font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
  font-size: 1.8rem;
  background: ${props => props.theme?.colors?.accentGradient || 'linear-gradient(45deg, #800000, #4A0404)'};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const QRCodeImage = styled.img`
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  display: block;
  max-width: 100%;
  height: auto;
  width: 250px;
  
  @media (max-width: 768px) {
    padding: 1rem;
    width: 220px;
  }
`;

const QRCodeSubtext = styled.p`
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  opacity: 0.8;
  text-align: center;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
  
  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

const QRCodeCloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    width: 24px;
    height: 24px;
  }
  
  @media (max-width: 768px) {
    top: 0.75rem;
    right: 0.75rem;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const PWAInstallTooltip = styled.div`
  position: absolute;
  bottom: -45px;
  left: 50%;
  transform: translateX(-50%);
  background: ${props => `${props.theme?.colors?.background || '#000000'}F5`};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => `${props.theme?.colors?.accent}60`};
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  white-space: nowrap;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 1000;
  
  ${PWAInstallButton}:hover & {
    opacity: 1;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid ${props => `${props.theme?.colors?.accent}60`};
  }
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
    padding: 0.4rem 0.6rem;
  }
`;

const PWAGuideBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  animation: pwaFadeIn 0.2s ease;
  @keyframes pwaFadeIn { from { opacity: 0 } to { opacity: 1 } }
`;

const PWAGuideCard = styled.div`
  width: 100%;
  max-width: 440px;
  background: ${props => props.theme?.colors?.background || '#141414'};
  border: 1px solid ${props => `${props.theme?.colors?.accent || '#800000'}30`};
  border-radius: 20px 20px 0 0;
  padding: 1.25rem 1.5rem 2.75rem;
  position: relative;
  animation: pwaSlideUp 0.25s cubic-bezier(0.34,1.56,0.64,1);
  @keyframes pwaSlideUp { from { transform: translateY(80px); opacity: 0 } to { transform: translateY(0); opacity: 1 } }
`;

const PWAGuideStep = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 0.9rem;
`;

const PWAGuideStepNum = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${props => props.theme?.colors?.accent || '#800000'};
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CanvasBackdrop = styled.div`
  position: relative;
  width: 100%;
  min-height: 200px; /* Reduced from 400-500px */
  
  @media (min-width: 769px) {
    min-height: clamp(130px, 20vh, 190px);
  }
  
  ${props => {
    const bg = getWelcomeBackground(props.theme?.id || 1);
    if (bg.type === 'gradient') {
      return `background: ${bg.value};`;
    } else if (bg.type === 'image') {
      return `
        background-image: url(${bg.value});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      `;
    } else {
      return `background: ${bg.value};`;
    }
  }}
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  
  @media (max-width: 768px) {
    display: none;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${props => props.theme?.colors?.backdropColor || 'rgba(0, 0, 0, 0.85)'};
    z-index: 1;
  }
`;

const ContentOverlay = styled.div`
  position: relative;
  z-index: 2;
  padding: clamp(0.75rem, 1.4vh, 1.1rem) clamp(1rem, 2vw, 1.75rem);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  
  @media (max-width: 768px) {
    padding: 1rem;
    background: transparent;
  }
`;

const ProfileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -1rem; /* Reduced from 1.5rem */
  
  @media (max-width: 768px) {
    margin-bottom: 0.5rem;
    
    > * {
      margin-bottom: 0;
    }
  }
`;

const MarketplaceSubtext = styled.p`
  font-family: ${props => props.theme?.fonts?.body || 'sans-serif'};
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  letter-spacing: 2px;
  font-weight: 400;
  text-align: center;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.4);
  text-underline-offset: 4px;
  text-decoration-thickness: 1px;

  @media (min-width: 768px) {
    font-size: 1.1rem;
    letter-spacing: 3px;
  }
`;

const MotivationalMessage = styled.p`
  font-size: 1.1rem;
  line-height: 1.5;
  max-width: 600px;
  margin: 2rem auto 0;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  font-weight: 400;
  text-align: center;
  padding: 1rem 1.5rem;
  letter-spacing: 0.3px;
  position: relative;
  
  @media (min-width: 768px) {
    font-size: 1.4rem;
    line-height: 1.6;
    max-width: 800px;
    margin: 3rem auto 0;
    padding: 1.5rem 2rem;
    letter-spacing: 0.5px;
  }
  
  &::before, &::after {
    content: '"';
    font-family: ${props => props.theme?.fonts?.heading || "'Georgia', serif"};
    font-size: 2rem;
    position: absolute;
    opacity: 0.2;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    
    @media (min-width: 768px) {
      font-size: 3rem;
    }
  }
  
  &::before {
    top: -0.5rem;
    left: 0.5rem;
    
    @media (min-width: 768px) {
      top: -1.5rem;
      left: -1rem;
    }
  }
  
  &::after {
    bottom: -1.5rem;
    right: 0.5rem;
    
    @media (min-width: 768px) {
      bottom: -2.5rem;
      right: -1rem;
    }
  }
`;

const BottomContent = styled.div`
  padding: 0;
  background: ${props => props.theme?.colors?.backdropColor || 'rgba(0, 0, 0, 0.8)'};
  border-radius: 0 0 16px 16px;

  @media (max-width: 768px) {
    padding: 0.2rem 0 1rem 0;
    border-radius: 0;
    background: transparent;
    width: 100%;
    margin: 0;
  }
`;

const TreasureMapButton = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  width: fit-content;
  margin: 0 auto;
  padding: 0.9rem 2.5rem 1.05rem;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: transform 0.15s ease;

  /* Faint map-snapshot backdrop, tinted to the current theme and faded out
     on every edge instead of a hard button boundary — no border, just a
     soft vignette the content sits on top of. */
  &::before {
    content: '';
    position: absolute;
    inset: -18px;
    z-index: -1;
    background:
      linear-gradient(
        ${props => props.theme?.colors?.accent || '#ffd700'},
        ${props => props.theme?.colors?.accent || '#ffd700'}
      ),
      url('/images/world-map-snapshot.png') center / cover no-repeat;
    background-blend-mode: color;
    opacity: 0.5;
    -webkit-mask-image: radial-gradient(ellipse 60% 70% at center, #000 30%, transparent 78%);
    mask-image: radial-gradient(ellipse 60% 70% at center, #000 30%, transparent 78%);
    transition: opacity 0.25s ease;
    pointer-events: none;
  }

  &:active {
    transform: scale(0.97);
  }
`;

// 4. Add this CSS to handle responsive display (add to your styled components section):
const GlobalStyle = styled.div`
  @media (min-width: 769px) {
    .mobile-only {
      display: none !important;
    }
    .desktop-center {
      justify-content: center !important;
    }
  }

  @media (max-width: 768px) {
    .desktop-only {
      display: none !important;
    }
  }
`;

const AmharicText = styled.span`
  /* Font will be applied via className */
`;

const ChatOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: ${props => props.isOpen ? 1 : 0};
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
  transition: opacity 0.3s ease;
`;

const SortOption = styled.button`
  width: 100%;
  padding: 0.75rem 1rem;
  background: ${props => props.active ? 
    props.theme?.colors?.accent || '#800000' : 
    'transparent'};
  border: none;
  border-radius: 8px;
  color: ${props => props.active ? 
    '#FFFFFF' : 
    props.theme?.colors?.text || '#FFFFFF'};
  font-size: 0.95rem;
  font-weight: ${props => props.active ? '600' : '500'};
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: ${props => props.theme?.fonts?.body || 'inherit'};
  min-height: 50px; /* Added for two-line content */
  
  &:hover {
    background: ${props => props.active ?
      props.theme?.colors?.primary || '#4A0404' :
      `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
    transform: translateX(2px);
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    align-self: flex-start; /* Align icon to top when two lines */
    margin-top: 2px;
  }
  
  @media (max-width: 768px) {
    padding: 0.65rem 0.85rem;
    font-size: 0.9rem;
    min-height: 46px;
    
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

const SortHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

const Footer = styled.footer`
  width: 100%;
  padding: .5rem 1rem;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}80`};
  border-top: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.3)'};
  margin-top: 2rem;
  position: relative;
  z-index: 1;
  
  /* ✅ NEW: Show on mobile */
  display: block;
  
  @media (max-width: 768px) {
    padding: .5rem 1rem;
    margin-top: 1rem;
    /* Authenticated: App.js's own wrapper already adds 80px to clear the
       fixed BottomNavigation bar, so this only needs breathing room, not a
       second helping of clearance. Guests have no such wrapper padding, and
       still need to clear the fixed FilterToggle/ThemeDropdown buttons. */
    padding-bottom: ${props => props.$isAuthenticated ? '1.5rem' : '5rem'};
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  
  /* ✅ NEW: Mobile centered stacking */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  
  h4 {
    font-size: 0.9rem;
    font-weight: 600;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin: 0 0 0.5rem 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  /* ✅ UPDATED: Mobile always centered */
  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
  }
`;

const ContactLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  a {
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    text-decoration: none;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    opacity: 0.8;
    transition: all 0.3s ease;
    
    &:hover {
      opacity: 1;
      color: ${props => props.theme?.colors?.accent || '#800000'};
      transform: translateX(2px);
    }
    
    svg {
      width: 18px;
      height: 18px;
    }
  }
  
  /* ✅ UPDATED: Mobile always centered */
  @media (max-width: 768px) {
    align-items: center;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  
  /* ✅ NEW: Center on mobile */
  @media (max-width: 768px) {
    justify-content: center;
  }
  
  a {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
    border: 1px solid ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    transition: all 0.3s ease;
    
    &:hover {
      background: ${props => props.theme?.colors?.accent || '#800000'};
      color: white;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
    }
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  
  button, a {
    background: transparent;
    border: none;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    font-size: 0.85rem;
    cursor: pointer;
    opacity: 0.7;
    transition: all 0.3s ease;
    text-decoration: none;
    padding: 0;
    font-family: inherit;
    
    &:hover {
      opacity: 1;
      color: ${props => props.theme?.colors?.accent || '#800000'};
      text-decoration: underline;
    }
  }
  
  /* ✅ UPDATED: Mobile centered column */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
    align-items: center;
  }
`;

const Copyright = styled.div`
  text-align: center;
  font-size: 0.8rem;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  opacity: 0.6;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
  
  /* ✅ NEW: Consistent on all devices */
  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin-top: 1.5rem;
  }
`;

const TermsOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  opacity: ${props => props.isOpen ? 1 : 0};
  pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
  transition: opacity 0.3s ease;
`;

const TermsContainer = styled.div`
  background: ${props => props.theme?.colors?.background || '#000000'};
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  
  @media (max-width: 768px) {
    max-width: 95%;
    max-height: 95vh;
    border-radius: 12px;
  }
`;

// Update the DesktopNavigationButton styled component

const DesktopNavigationButton = styled.button`
  position: fixed; /* Changed from absolute to fixed */
  left: 50%;
  transform: translateX(-50%);
  background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
  backdrop-filter: blur(10px);
  border: 2px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme?.colors?.accent || '#800000'};
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 12001; /* Higher than ZoomOverlay (12000) */
  opacity: 0.7; /* Changed to visible by default */
  
  &.top {
    top: calc(50vh - 350px - 0.7in); /* Position 0.5in above the card top */
  }
  
  &.bottom {
    bottom: calc(50vh - 350px - 0.7in); /* Position 0.5in below the card bottom */
  }
  
  &:hover {
    opacity: 1;
    background: ${props => props.theme?.colors?.accent || '#800000'};
    color: white;
    transform: translateX(-50%) scale(1.1);
  }
  
  &:active {
    transform: translateX(-50%) scale(0.95);
  }
  
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
    
    &:hover {
      background: ${props => `${props.theme?.colors?.background || 'rgba(0, 0, 0, 0.8)'}DD`};
      color: ${props => props.theme?.colors?.accent || '#800000'};
      transform: translateX(-50%) scale(1);
    }
  }
  
  svg {
    width: 24px;
    height: 24px;
  }
  
  /* Mobile responsive */
  @media (max-width: 768px) {
    opacity: 0.6;
    width: 40px;
    height: 40px;
    backdrop-filter: blur(8px);
    
    &.top {
      top: calc(50vh - 325px - 0.5in); /* Adjust for smaller mobile card */
    }
    
    &.bottom {
      bottom: calc(50vh - 325px - 0.5in);
    }
    
    &:active {
      opacity: 1;
      transform: translateX(-50%) scale(0.9);
    }
    
    &:disabled {
      opacity: 0.2;
    }
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
  
  @media (max-width: 480px) {
    &.top {
      top: calc(50vh - 300px - 0.5in); /* Adjust for smallest mobile card */
    }
    
    &.bottom {
      bottom: calc(50vh - 300px - 0.5in);
    }
  }
`;

const SwipeIndicator = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: ${props => props.$isVisible ? 0.8 : 0};
  transition: opacity 0.2s ease; // Changed from 0.3s for snappier feedback
  pointer-events: none;
  z-index: 15;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
  
  &.top {
    top: 1rem;
  }
  
  &.bottom {
    bottom: 1rem;
  }
  
  .arrow-icon {
    width: 24px;
    height: 24px;
    animation: ${props => props.$direction === 'up' ? 'bounceUp' : 'bounceDown'} 1.5s ease-in-out infinite;
  }
  
  @keyframes bounceUp {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-8px); }
  }
  
  @keyframes bounceDown {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(8px); }
  }
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
    
    .arrow-icon {
      width: 20px;
      height: 20px;
    }
  }
`;

const TermsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(128, 0, 0, 0.3)'};
  
  h2 {
    font-family: ${props => props.theme?.fonts?.heading || "'Impact', sans-serif"};
    font-size: 1.5rem;
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin: 0;
  }
  
  button {
    background: transparent;
    border: none;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    
    &:hover {
      background: ${props => `${props.theme?.colors?.accent}20` || 'rgba(128, 0, 0, 0.2)'};
      transform: scale(1.1);
    }
  }
  
  @media (max-width: 768px) {
    padding: 1rem;
    
    h2 {
      font-size: 1.2rem;
    }
  }
`;

const TermsContent = styled.div`
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1;
  color: ${props => props.theme?.colors?.text || '#FFFFFF'};
  line-height: 1.6;
  
  h1, h2, h3 {
    color: ${props => props.theme?.colors?.accent || '#800000'};
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
  }
  
  h1 {
    font-size: 1.5rem;
    text-align: center;
  }
  
  h2 {
    font-size: 1.2rem;
  }
  
  h3 {
    font-size: 1rem;
  }
  
  p {
    margin-bottom: 0.75rem;
  }
  
  ul {
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
  
  li {
    margin-bottom: 0.5rem;
  }
  
  strong {
    color: ${props => props.theme?.colors?.accent || '#800000'};
  }
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${props => `${props.theme?.colors?.background}80` || 'rgba(0, 0, 0, 0.5)'};
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    border-radius: 4px;
    
    &:hover {
      background: ${props => props.theme?.colors?.primary || '#4A0404'};
    }
  }
  
  @media (max-width: 768px) {
    padding: 1rem;
    font-size: 0.9rem;
    
    h1 {
      font-size: 1.2rem;
    }
    
    h2 {
      font-size: 1rem;
    }
    
    h3 {
      font-size: 0.9rem;
    }
  }
`;

// Motivational messages
const MOTIVATIONAL_MESSAGES = [
  "Build your vision, Elevate humanity.",
  "Create greatness, Inspire progress.",
  "Master your craft, Serve with passion.",
  "Own your success, Empower those around you.",
  "Rule with wisdom, Lead with heart.",
  "Shape your future, Change lives along the way.",
  "Rise above, Lift others higher.",
  "Conquer your dreams, Build a better world.",
  "Lead by example, Serve with strength.",
  "Pursue greatness, Give back in abundance."
];

const AuthOptionsPopup = styled.div`
  position: absolute;
  top: 50%;
  left: calc(100% + 1rem);
  transform: translateY(-50%) ${props => props.isOpen ? 'translateX(0)' : 'translateX(-10px)'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  z-index: 1000;
  
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid ${props => props.themeColors?.accent || '#800000'}50;
  border-radius: 50px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
`;

const AuthOptionBubble = styled.button`
  width: 56px;
  height: 56px;
  padding: 0;
  background: ${props => props.variant === 'google' 
    ? props.themeColors?.accent 
    : 'rgba(128, 0, 0, 0.2)'};
  color: ${props => props.variant === 'google' ? '#333' : 'white'};
  border: 1px solid ${props => props.variant === 'google' 
    ? 'transparent' 
    : 'rgba(128, 0, 0, 0.5)'};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    background: ${props => props.variant === 'google' 
      ? '#f5f5f5' 
      : 'rgba(128, 0, 0, 0.3)'};
  }

  &:active {
    transform: scale(0.95);
  }

  img {
    width: 24px;
    height: 24px;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 999;
  display: ${props => props.isOpen ? 'block' : 'none'};
`;

const EventCard = styled.div`
  background: ${props => props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'};
  border-radius: ${props => props.theme?.styles?.borderRadius || '12px'};
  overflow: hidden;
  border: 1px solid ${props => `${props.theme?.colors?.accent}30` || 'rgba(255, 255, 255, 0.1)'};
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  
  @media (hover: hover) {
    &:hover {
      transform: translateY(-2px);
      border-color: ${props => props.theme?.colors?.accent};
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    }
  }
`;

const EventTopBar = styled.div`
  height: 48px;
  min-height: 48px;
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}70`};
  border-bottom: 1px solid ${props => `${props.theme?.colors?.accent}20`};
  
  @media (min-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const EventShopInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
  
  .shop-pfp {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    background: ${props => props.theme?.colors?.accent};
    flex-shrink: 0;
    cursor: pointer;
    border: 2px solid ${props => `${props.theme?.colors?.accent}40`};
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    &:hover {
      opacity: 0.8;
      transform: scale(1.05);
    }
    
    @media (min-width: 768px) {
      width: 36px;
      height: 36px;
    }
  }
  
  .shop-name {
    font-weight: 700;
    color: ${props => props.theme?.colors?.accent};
    cursor: pointer;
    text-decoration: none;
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    &:hover {
      text-decoration: underline;
    }
    
    @media (min-width: 768px) {
      font-size: 0.95rem;
    }
  }
`;

const EventMediaContainer = styled.div`
  position: relative;
  width: 100%;
  background: ${props => `${props.theme?.colors?.background || '#000000'}80`};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img, video {
    width: 100%;
    height: auto;
    max-height: 80vh;
    object-fit: contain;
    display: block;
    background: ${props => props.theme?.colors?.background || '#000000'};
  }

  video {
    background: #000;
  }
`;

const EventBottomBar = styled.div`
  min-height: ${props => props.$expanded ? '180px' : '60px'};
  max-height: ${props => props.$expanded ? '400px' : '60px'};
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}90`};
  border-top: 1px solid ${props => `${props.theme?.colors?.accent}20`};
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  overflow: hidden;
  cursor: pointer;
  
  @media (min-width: 768px) {
    padding: 1rem;
  }
  
  &:hover {
    background: ${props => `${props.theme?.colors?.surface || 'rgba(255, 255, 255, 0.05)'}CC`};
  }
`;

const EventExpandedContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.75rem;
  opacity: ${props => props.$expanded ? 1 : 0};
  transition: opacity 0.3s ease;
  
  .event-datetime {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    font-weight: 600;
    
    svg {
      color: ${props => props.theme?.colors?.accent || '#800000'};
    }
  }
  
  .event-price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    
    .event-location {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      font-size: 0.85rem;
      color: ${props => props.theme?.colors?.text || '#FFFFFF'};
      opacity: 0.8;
      flex: 1;
      overflow: hidden;
      
      svg {
        flex-shrink: 0;
        color: ${props => props.theme?.colors?.accent || '#800000'};
      }
      
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    
    .event-price {
      font-size: 1.1rem;
      font-weight: 700;
      color: ${props => props.theme?.colors?.accent || '#800000'};
      white-space: nowrap;
    }
  }
  
  .event-description {
    font-size: 0.9rem;
    line-height: 1.5;
    color: ${props => props.theme?.colors?.text || '#FFFFFF'};
    opacity: 0.9;
    max-height: 100px;
    overflow-y: auto;
    padding-right: 0.5rem;
    
    &::-webkit-scrollbar {
      width: 4px;
    }
    
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
      background: ${props => `${props.theme?.colors?.accent}60` || 'rgba(128, 0, 0, 0.6)'};
      border-radius: 2px;
    }
  }
  
  .event-book-button {
    background: ${props => props.theme?.colors?.accent || '#800000'};
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    
    &:active {
      transform: scale(0.98);
    }
    
    @media (hover: hover) {
      &:hover {
        background: ${props => props.theme?.colors?.primary || '#4A0404'};
        box-shadow: 0 4px 12px ${props => `${props.theme?.colors?.accent}40` || 'rgba(128, 0, 0, 0.4)'};
      }
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    svg {
      width: 18px;
      height: 18px;
    }
  }
  
  @media (min-width: 768px) {
    gap: 1rem;
    
    .event-datetime {
      font-size: 0.95rem;
    }
    
    .event-description {
      font-size: 0.95rem;
    }
  }
`;

const VerticalEventContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  max-width: 600px;
  margin: 2rem auto 0;
  padding: 0 1rem;
  
  @media (max-width: 768px) {
    gap: 1.5rem;
    margin: 1rem auto 0;
    padding: 0 0.5rem;
  }
`;

// Add after VerticalPostContainer (around line 2100)
const GridPostContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  padding: 1rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    padding: 0.5rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }
`;

const GridPostCard = styled.div`
  position: relative;
  aspect-ratio: 1;
  border-radius: ${props => props.theme?.styles?.borderRadius || '12px'};
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }

  img, video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .overlay-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
    padding: 0.75rem 0.5rem;
    
    .shop-name {
      font-size: 0.75rem;
      font-weight: 600;
      color: white;
      margin-bottom: 0.25rem;
    }
    
    .like-count {
      font-size: 0.7rem;
      color: rgba(255,255,255,0.8);
      display: flex;
      align-items: center;
      gap: 0.25rem;
      
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
`;

const ViewToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem auto;
  gap: 0.5rem;
  max-width: 200px;
`;

const ViewToggleButton = styled.button`
  flex: 1;
  padding: 0.5rem 1rem;
  background: ${props => props.active ? 
    props.theme?.colors?.accent || '#800000' : 
    'transparent'};
  border: 1px solid ${props => props.theme?.colors?.accent || '#800000'};
  border-radius: 8px;
  color: ${props => props.active ? 'white' : props.theme?.colors?.accent || '#800000'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  
  &:hover {
    background: ${props => props.active ? 
      props.theme?.colors?.primary || '#4A0404' : 
      `${props.theme?.colors?.accent}20`};
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

// ─── Memoized tab sub-components ────────────────────────────────────────────
// Defined outside WelcomePage so their identity is stable across renders.
// Combined with the lazy-mount + CSS-display pattern below, switching tabs
// is instant (no unmount/remount) and inactive tabs don't re-render.


// Plural display names for category section headers
const STORE_TYPE_PLURAL_LABELS = {
  '🍽️ Restaurant': '🍽️ Restaurants',
  '👕 Clothing Store': '👕 Clothing Stores',
};
const pluralCategoryLabel = (label) => STORE_TYPE_PLURAL_LABELS[label] || label;

const CAT_COLS_DEFAULTS = [2, 1];

const ProductsTab = React.memo(({
  theme, hasProductSearchResults, productSearchResults, followedShops, followLoading,
  onItemClick, onLikeClick, onFollowToggle, onAddToCart, isAuthenticated,
  catGridCols, onSetCatCols, onToggleSearch, categories, collapsedSections, onToggleSection,
  expandedCategories, onExpandCategory, loading, previewCategories,
}) => (
  <>
    {hasProductSearchResults ? (
      <div className="search-results-section" onTouchStart={e => e.stopPropagation()}>
        <CategoryHeader theme={theme}>
          <h2>Search Results ({productSearchResults.length})</h2>
          <div className="header-right">
            <button className="mobile-search-toggle" onClick={e => { e.stopPropagation(); onToggleSearch(); }} aria-label="Toggle search">
              <Search size={18} />
            </button>
          </div>
        </CategoryHeader>
        {productSearchResults.length === 0 ? (
          <EmptyGridMessage><h3>No Items Found</h3><p>No items match your search criteria.</p></EmptyGridMessage>
        ) : (
          <GridContainer $cols={2}>
            {productSearchResults.map(item => (
              <FeaturedItem
                key={`search-${item.shopId}-${item.id}`}
                item={{ ...item, isFollowing: followedShops.has(item.shopId), isFollowLoading: followLoading.has(item.shopId) }}
                theme={theme} onItemClick={onItemClick} onLikeClick={onLikeClick}
                onFollowToggle={onFollowToggle} columns={2} onAddToCart={onAddToCart}
                isAuthenticated={isAuthenticated} showDistance showShopName              />
            ))}
          </GridContainer>
        )}
      </div>
    ) : (
      <div onTouchStart={e => e.stopPropagation()}>
        {Object.entries(loading ? (previewCategories || {}) : categories).map(([categoryName, items], catIdx) => {
          if (items.length === 0) return null;
          const sectionKey = `cat_${categoryName}`;
          // Desktop 1x = fixed 3-wide wall-to-wall grid, always 1 row (extra items
          // just scroll). Desktop 2x = the width-tiered grid, 2nd row only at 6+
          // items. There's no separate desktop 3x — it renders the same as 2x.
          const isDesktop = typeof window !== 'undefined' && window.innerWidth > 768;
          // While the real feed is still loading, every preview category starts
          // forced collapsed (regardless of device) — just the header, no
          // skeleton cards. Once the real `categories` data replaces the preview
          // (same categoryName key, same DOM node, see the map() above), mobile
          // falls back to its normal expanded-by-default and the collapse
          // wrapper's transition eases it open; desktop falls back to its
          // normal collapsed-by-default, so it stays shut with no motion.
          const isCollapsed = loading
            ? true
            : (collapsedSections[sectionKey] !== undefined ? !!collapsedSections[sectionKey] : isDesktop);
          const isExpanded = !!expandedCategories?.[sectionKey];
          const cols = catGridCols[sectionKey] ?? (CAT_COLS_DEFAULTS[catIdx] ?? 2);
          const itemCount = loading ? items.length : (isExpanded ? items.length : Math.min(items.length, 20));
          const effectiveCols = Math.min(cols, itemCount);
          const renderCols = isDesktop ? Math.min(effectiveCols, 2) : effectiveCols;
          return (
            <div key={categoryName} style={{ marginTop: '1rem' }} className="category-section" onTouchStart={e => e.stopPropagation()}>
              <CategoryHeader theme={theme} style={{ cursor: loading ? 'default' : 'pointer' }} onClick={loading ? undefined : () => onToggleSection(sectionKey, isCollapsed)}>
                <span className="item-count">{itemCount}{!loading && !isExpanded && items.length > 20 ? '+' : ''}</span>
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                  <span className="category-title-label">{pluralCategoryLabel(categoryName)}</span>
                  {!loading && (
                    <span
                      onClick={e => { e.stopPropagation(); onSetCatCols(sectionKey, isDesktop ? (cols === 1 ? 2 : 1) : (cols === 1 ? 2 : cols === 2 ? 3 : 1)); }}
                      title={isDesktop ? (renderCols === 1 ? 'Switch to 2 columns' : 'Switch to 1 column') : (effectiveCols === 1 ? 'Switch to 2 columns' : effectiveCols === 2 ? 'Switch to 3 columns' : 'Switch to 1 column')}
                      style={{ fontSize: '0.81rem', fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: '0.1rem', borderRadius: 4, borderBottom: `1px solid ${theme?.colors?.accent || '#800000'}`, padding: '0 3px', cursor: 'pointer', userSelect: 'none' }}
                    >{renderCols}×<Grid size={13} /></span>
                  )}
                  {isCollapsed ? <ChevronDown size={16} color={theme?.colors?.accent} /> : <ChevronUp size={16} color={theme?.colors?.accent} />}
                </h2>
                {!loading && catIdx === 0 && (
                  <div className="header-right" onClick={e => e.stopPropagation()}>
                    <button className="mobile-search-toggle" onClick={e => { e.stopPropagation(); onToggleSearch(); }} aria-label="Toggle search">
                      <Search size={18} />
                    </button>
                  </div>
                )}
              </CategoryHeader>
              <div style={{
                position: 'relative',
                maxHeight: isCollapsed ? 0 : 3000,
                opacity: isCollapsed ? 0 : 1,
                overflow: 'hidden',
                transition: 'max-height 0.45s ease, opacity 0.35s ease',
              }}>
                {!loading && (
                <CategoryScrollableGrid theme={theme} className="auto-scroll-grid"
                  id={`wp-scroll-p-${categoryName.replace(/\s+/g, '-').toLowerCase()}`}
                  itemCount={itemCount} $rows={effectiveCols === 1 ? 1 : itemCount <= 3 ? 1 : 2}
                  $desktopCols={(isDesktop && renderCols === 1) ? 3 : undefined}
                  $desktopRows={renderCols === 1 ? 1 : (itemCount >= 6 ? 2 : 1)}
                  $mobileCols={effectiveCols}>
                  {items.slice(0, itemCount).map(item => (
                    <FeaturedItem
                      key={`${categoryName}-${item.shopId}-${item.id}`}
                      item={{ ...item, isFollowing: followedShops.has(item.shopId), isFollowLoading: followLoading.has(item.shopId) }}
                      theme={theme} onItemClick={onItemClick} onLikeClick={onLikeClick}
                      onFollowToggle={onFollowToggle} columns={renderCols} onAddToCart={onAddToCart}
                      isAuthenticated={isAuthenticated} showDistance showShopName                    />
                  ))}
                  {!isExpanded && items.length > 20 && (
                    <button
                      onClick={() => onExpandCategory(sectionKey)}
                      style={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        gap: '0.35rem', minWidth: '90px', background: 'rgba(255,255,255,0.06)',
                        border: `1.5px dashed ${theme?.colors?.accent || '#800000'}80`, borderRadius: '10px',
                        color: theme?.colors?.accent || '#800000', fontWeight: 700, fontSize: '0.8rem',
                        cursor: 'pointer', padding: '0.5rem',
                      }}
                    >
                      <Plus size={18} />
                      +{items.length - 20} more
                    </button>
                  )}
                </CategoryScrollableGrid>
                )}
                {!loading && effectiveCols === 1 && itemCount > 1 && (() => {
                  const sid = `wp-scroll-p-${categoryName.replace(/\s+/g, '-').toLowerCase()}`;
                  const b = { position: 'absolute', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10, color: '#fff', padding: 0 };
                  return (<>
                    <button style={{ ...b, left: '0.5rem' }} onClick={() => { const el = document.getElementById(sid); if (!el) return; el.scrollBy({ left: -el.offsetWidth, behavior: 'smooth' }); }}><ChevronLeft size={18} /></button>
                    <button style={{ ...b, right: '0.5rem' }} onClick={() => { const el = document.getElementById(sid); if (!el) return; el.scrollBy({ left: el.offsetWidth, behavior: 'smooth' }); }}><ChevronRight size={18} /></button>
                  </>);
                })()}
              </div>
            </div>
          );
        })}
      </div>
    )}
  </>
));

const ServicesTab = React.memo(({
  theme, hasServiceSearchResults, serviceSearchResults, serviceSubTab,
  followedShops, followLoading, onItemClick, onLikeClick, onFollowToggle, onAddToCart,
  isAuthenticated, catGridCols, onSetCatCols, onToggleSearch, serviceCategories, collapsedSections, onToggleSection,
  expandedCategories, onExpandCategory, loading, previewServiceCategories,
}) => (
  <>
    {hasServiceSearchResults ? (
      <div className="search-results-section" onTouchStart={e => e.stopPropagation()}>
        <CategoryHeader theme={theme}>
          <h2>Search Results ({serviceSearchResults.filter(s => (s.serviceTab || 'offer') === serviceSubTab).length})</h2>
          <div className="header-right">
            <button className="mobile-search-toggle" onClick={e => { e.stopPropagation(); onToggleSearch(); }} aria-label="Toggle search">
              <Search size={18} />
            </button>
          </div>
        </CategoryHeader>
        {serviceSearchResults.length === 0 ? (
          <EmptyGridMessage><h3>No Services Found</h3><p>No services match your search criteria.</p></EmptyGridMessage>
        ) : (
          <GridContainer $cols={2}>
            {serviceSearchResults.filter(s => (s.serviceTab || 'offer') === serviceSubTab).map(service => (
              <FeaturedItem
                key={`search-${service.shopId}-${service.id}`}
                item={{ ...service, isFollowing: followedShops.has(service.shopId), isFollowLoading: followLoading.has(service.shopId) }}
                theme={theme} onItemClick={onItemClick} onLikeClick={onLikeClick}
                onFollowToggle={onFollowToggle} columns={2} onAddToCart={onAddToCart}
                isAuthenticated={isAuthenticated} showDistance showShopName              />
            ))}
          </GridContainer>
        )}
      </div>
    ) : (
      <div onTouchStart={e => e.stopPropagation()}>
        {Object.entries(loading ? (previewServiceCategories || {}) : serviceCategories).map(([categoryName, allServices], svcIdx) => {
          const services = allServices.filter(s => (s.serviceTab || 'offer') === serviceSubTab);
          if (services.length === 0) return null;
          const svcKey = `svc_${categoryName}`;
          // Desktop 1x = fixed 3-wide wall-to-wall grid, always 1 row (extra items
          // just scroll). Desktop 2x = the width-tiered grid, 2nd row only at 6+
          // items. There's no separate desktop 3x — it renders the same as 2x.
          const isDesktop = typeof window !== 'undefined' && window.innerWidth > 768;
          // While the real feed is still loading, every preview category starts
          // forced collapsed (regardless of device) — just the header, no
          // skeleton cards. Once the real `serviceCategories` data replaces the
          // preview (same categoryName key, same DOM node, see the map() above),
          // mobile falls back to its normal expanded-by-default and the collapse
          // wrapper's transition eases it open; desktop falls back to its
          // normal collapsed-by-default, so it stays shut with no motion.
          const isSvcCollapsed = loading
            ? true
            : (collapsedSections[svcKey] !== undefined ? !!collapsedSections[svcKey] : isDesktop);
          const isSvcExpanded = !!expandedCategories?.[svcKey];
          const svcDisplayCount = loading ? services.length : (isSvcExpanded ? services.length : Math.min(services.length, 30));
          const svcCols = catGridCols[svcKey] ?? (CAT_COLS_DEFAULTS[svcIdx] ?? 2);
          const svcEffectiveCols = Math.min(svcCols, svcDisplayCount);
          const svcRenderCols = isDesktop ? Math.min(svcEffectiveCols, 2) : svcEffectiveCols;
          return (
            <div key={categoryName} style={{ marginTop: '0.75rem' }} className="category-section" onTouchStart={e => e.stopPropagation()}>
              <CategoryHeader theme={theme} style={{ cursor: loading ? 'default' : 'pointer' }} onClick={loading ? undefined : () => onToggleSection(svcKey, isSvcCollapsed)}>
                <span className="item-count">{svcDisplayCount}{!loading && !isSvcExpanded && services.length > 30 ? '+' : ''}</span>
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                  <span className="category-title-label">{categoryName}</span>
                  {!loading && (
                    <span
                      onClick={e => { e.stopPropagation(); onSetCatCols(svcKey, isDesktop ? (svcCols === 1 ? 2 : 1) : (svcCols === 1 ? 2 : svcCols === 2 ? 3 : 1)); }}
                      title={isDesktop ? (svcRenderCols === 1 ? 'Switch to 2 columns' : 'Switch to 1 column') : (svcEffectiveCols === 1 ? 'Switch to 2 columns' : svcEffectiveCols === 2 ? 'Switch to 3 columns' : 'Switch to 1 column')}
                      style={{ fontSize: '0.81rem', fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: '0.1rem', borderRadius: 4, borderBottom: `1px solid ${theme?.colors?.accent || '#800000'}`, padding: '0 3px', cursor: 'pointer', userSelect: 'none' }}
                    >{svcRenderCols}×<Grid size={13} /></span>
                  )}
                  {isSvcCollapsed ? <ChevronDown size={16} color={theme?.colors?.accent} /> : <ChevronUp size={16} color={theme?.colors?.accent} />}
                </h2>
              </CategoryHeader>
              <div style={{
                position: 'relative',
                maxHeight: isSvcCollapsed ? 0 : 3000,
                opacity: isSvcCollapsed ? 0 : 1,
                overflow: 'hidden',
                transition: 'max-height 0.45s ease, opacity 0.35s ease',
              }}>
                {!loading && (
                <CategoryScrollableGrid theme={theme} className="auto-scroll-grid"
                  id={`wp-scroll-svc-${categoryName.replace(/\s+/g, '-').toLowerCase()}`}
                  itemCount={svcDisplayCount} $rows={svcEffectiveCols === 1 ? 1 : svcDisplayCount <= 3 ? 1 : 2}
                  $desktopCols={(isDesktop && svcRenderCols === 1) ? 3 : undefined}
                  $desktopRows={svcRenderCols === 1 ? 1 : (svcDisplayCount >= 6 ? 2 : 1)}
                  $mobileCols={svcEffectiveCols}>
                  {services.slice(0, svcDisplayCount).map(service => (
                    <FeaturedItem
                      key={`${categoryName}-${service.shopId}-${service.id}`}
                      item={{ ...service, price: `${service.price}`, isService: true,
                        isFollowing: followedShops.has(service.shopId), isFollowLoading: followLoading.has(service.shopId) }}
                      theme={theme} onItemClick={onItemClick} onLikeClick={onLikeClick}
                      onFollowToggle={onFollowToggle} columns={svcRenderCols} onAddToCart={onAddToCart}
                      isAuthenticated={isAuthenticated} showDistance showShopName                      />
                  ))}
                  {!isSvcExpanded && services.length > 30 && (
                    <button
                      onClick={() => onExpandCategory(svcKey)}
                      style={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        gap: '0.35rem', minWidth: '90px', background: 'rgba(255,255,255,0.06)',
                        border: `1.5px dashed ${theme?.colors?.accent || '#800000'}80`, borderRadius: '10px',
                        color: theme?.colors?.accent || '#800000', fontWeight: 700, fontSize: '0.8rem',
                        cursor: 'pointer', padding: '0.5rem',
                      }}
                    >
                      <Plus size={18} />
                      +{services.length - 30} more
                    </button>
                  )}
                </CategoryScrollableGrid>
                )}
                {!loading && svcEffectiveCols === 1 && svcDisplayCount > 1 && (() => {
                  const sid = `wp-scroll-svc-${categoryName.replace(/\s+/g, '-').toLowerCase()}`;
                  const b = { position: 'absolute', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10, color: '#fff', padding: 0 };
                  return (<>
                    <button style={{ ...b, left: '0.5rem' }} onClick={() => { const el = document.getElementById(sid); if (!el) return; el.scrollBy({ left: -el.offsetWidth, behavior: 'smooth' }); }}><ChevronLeft size={18} /></button>
                    <button style={{ ...b, right: '0.5rem' }} onClick={() => { const el = document.getElementById(sid); if (!el) return; el.scrollBy({ left: el.offsetWidth, behavior: 'smooth' }); }}><ChevronRight size={18} /></button>
                  </>);
                })()}
              </div>
            </div>
          );
        })}
      </div>
    )}
  </>
));

const EventsTab = React.memo(({
  theme, eventPosts, eventsViewMode, onSetEventsViewMode, expandedEventId, onSetExpandedEventId,
  followedShops, followLoading, onFollowToggle, onCommunityPostLike, onItemClick,
  cartItems, onSetCartItems, onSetShowCartDropdown, user, isAuthenticated, loadingEvents,
}) => {
  const navigate = useNavigate();
  const goToShop = (shopId) => { if (shopId) navigate(`/shop/${shopId}/view`); };
  return (
  <div onTouchStart={e => e.stopPropagation()} style={{ minHeight: '100vh', overflow: 'visible' }}>
    <ViewToggleContainer>
      <ViewToggleButton theme={theme} active={eventsViewMode === 'list'} onClick={() => onSetEventsViewMode('list')}><List size={16} />List</ViewToggleButton>
      <ViewToggleButton theme={theme} active={eventsViewMode === 'grid'} onClick={() => onSetEventsViewMode('grid')}><Grid size={16} />Grid</ViewToggleButton>
    </ViewToggleContainer>
    {eventPosts.length > 0 ? (
      eventsViewMode === 'list' ? (
        <VerticalEventContainer style={{ overflow: 'visible', minHeight: '100vh' }}>
          {eventPosts.map((event, index) => (
            <React.Fragment key={`event-${event.shopId}-${event.id}`}>
              <EventCard theme={theme}>
                <EventTopBar theme={theme}>
                  <EventShopInfo theme={theme}>
                    <div className="shop-pfp" onClick={e => { e.stopPropagation(); goToShop(event.shopId); }}>
                      {event.shopProfile ? <img src={event.shopProfile} alt={event.shopName} loading="lazy" decoding="async" /> : <Store size={16} />}
                    </div>
                    <span className="shop-name" onClick={e => { e.stopPropagation(); goToShop(event.shopId); }}>{event.shopName}</span>
                  </EventShopInfo>
                  {isAuthenticated && event.shopId && (
                    <FollowButton onClick={e => { e.stopPropagation(); onFollowToggle(event.shopId, e); }}
                      theme={theme} $isFollowing={followedShops.has(event.shopId)}
                      $isLoading={followLoading.has(event.shopId)} disabled={followLoading.has(event.shopId)}
                      title={followedShops.has(event.shopId) ? 'Following' : 'Follow'}>
                      {followedShops.has(event.shopId) ? <CheckCircle size={16} /> : <PlusCircle size={16} />}
                    </FollowButton>
                  )}
                </EventTopBar>
                <EventMediaContainer theme={theme} onClick={e => { e.stopPropagation(); onItemClick(event); }} style={{ cursor: 'pointer' }}>
                  {event.contentUrl || event.imageUrl ? (
                    event.type === 'video' || event.contentUrl?.includes('video') ? (
                      <video src={event.contentUrl || event.videoUrl} loop muted playsInline className="media-list-video" controls />
                    ) : (
                      <img src={event.contentUrl || event.imageUrl} alt={event.title || event.name || 'Event'} loading="lazy" decoding="async" />
                    )
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '200px', padding: '2rem', color: theme?.colors?.text, opacity: 0.3 }}>
                      <Calendar size={60} /><p style={{ marginTop: '1rem' }}>No media</p>
                    </div>
                  )}
                </EventMediaContainer>
                <EventBottomBar theme={theme} $expanded={expandedEventId === event.id}
                  onClick={e => { e.stopPropagation(); onSetExpandedEventId(expandedEventId === event.id ? null : event.id); }}>
                  <EventTitle theme={theme} $expanded={expandedEventId === event.id}>
                    <h3 className="event-name">{event.title || event.name || 'Untitled Event'}</h3>
                    <LikeButtonRight theme={theme} isLiked={event.engagement?.likes?.includes(user?.uid) || false}
                      onClick={e => { e.stopPropagation(); onCommunityPostLike(event); }} style={{ marginRight: '0.5rem', flexShrink: 0 }}>
                      <Heart size={18} /><span>{event.engagement?.likeCount || 0}</span>
                    </LikeButtonRight>
                    <ChevronDown size={20} className="expand-icon" />
                  </EventTitle>
                  <EventExpandedContent theme={theme} $expanded={expandedEventId === event.id}>
                    <div className="event-datetime"><Calendar size={16} /><span>{event.eventDate ? new Date(event.eventDate).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }) : 'Date TBA'}{event.eventTime && ` • ${event.eventTime}`}</span></div>
                    <div className="event-price-row">
                      <div className="event-location"><Navigation size={14} /><span>{event.location || event.address || 'Location TBA'}</span></div>
                      <div className="event-price">{event.price && parseFloat(event.price) > 0 ? formatShopPrice(event.price, event.currency) : 'Free'}</div>
                    </div>
                    {(event.description || event.caption) && <div className="event-description">{event.description || event.caption}</div>}
                    <button className="event-book-button" onClick={e => {
                      e.stopPropagation();
                      const availableSlots = parseInt(event.capacity || event.slots || 1);
                      const attendees = parseInt(event.attendees || 0);
                      if (attendees >= availableSlots) { alert('This event is sold out'); return; }
                      const eventForCart = { ...event, id: event.id, shopId: event.shopId, name: event.title || event.name || 'Untitled Event', price: event.price || '0', isService: true, slots: availableSlots, images: event.contentUrl ? [event.contentUrl] : [], shopName: event.shopName, shopProfile: event.shopProfile };
                      const existingItem = cartItems.find(i => i.id === event.id && i.shopId === event.shopId);
                      if (existingItem) { onSetCartItems(cartItems.map(i => i.id === event.id && i.shopId === event.shopId ? { ...i, cartQuantity: i.cartQuantity + 1 } : i)); }
                      else { onSetCartItems([...cartItems, { ...eventForCart, cartQuantity: 1 }]); }
                      onSetShowCartDropdown(true);
                    }} disabled={parseInt(event.attendees || 0) >= parseInt(event.capacity || event.slots || 1)}>
                      <Calendar size={18} />{parseInt(event.attendees || 0) >= parseInt(event.capacity || event.slots || 1) ? 'Sold Out' : 'Get Ticket(s)'}
                    </button>
                  </EventExpandedContent>
                </EventBottomBar>
              </EventCard>
              {index < eventPosts.length - 1 && <PostDivider theme={theme} />}
            </React.Fragment>
          ))}
        </VerticalEventContainer>
      ) : (
        <GridPostContainer theme={theme}>
          {eventPosts.map(event => (
            <GridPostCard key={`grid-event-${event.shopId}-${event.id}`} theme={theme} onClick={() => onItemClick(event)}>
              {event.contentUrl || event.imageUrl ? (event.type === 'video' ? <video src={event.contentUrl} muted /> : <img src={event.contentUrl || event.imageUrl} alt={event.title} loading="lazy" decoding="async" />) : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', background: theme?.colors?.surface }}><Calendar size={40} opacity={0.3} /></div>}
              <div className="overlay-info">
                <div className="shop-name">{event.title || event.name}</div>
                <div className="like-count"><Calendar size={12} />{event.eventDate ? new Date(event.eventDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : 'TBA'}</div>
              </div>
            </GridPostCard>
          ))}
        </GridPostContainer>
      )
    ) : loadingEvents ? <LoadingSpinner /> : (
      <EmptyGridMessage><h3>No Events Yet</h3></EmptyGridMessage>
    )}
  </div>
  );
});

const MediaTab = React.memo(({
  theme, friendsPosts, userOwnPosts, mediaViewMode, onSetMediaViewMode,
  followedShops, followLoading, onFollowToggle, onCommunityPostLike, onItemClick,
  user, isAuthenticated, loadingFriends,
}) => {
  const navigate = useNavigate();
  const goToShop = (shopId) => { if (shopId) navigate(`/shop/${shopId}/view`); };
  const renderPostCard = (post, key, showFollowBtn = true) => (
    <VerticalPostCard theme={theme} key={key} onClick={() => onItemClick(post)}>
      <PostTopBar theme={theme}>
        <ShopInfoLeft theme={theme}>
          <div className="shop-pfp" onClick={e => { e.stopPropagation(); goToShop(post.shopId); }}>
            {post.shopProfile ? <img src={post.shopProfile} alt={post.shopName} loading="lazy" decoding="async" /> : <Store size={16} />}
          </div>
          <span className="shop-name" onClick={e => { e.stopPropagation(); goToShop(post.shopId); }}>{post.shopName}</span>
        </ShopInfoLeft>
        {showFollowBtn && isAuthenticated && post.shopId !== user?.uid && (
          <FollowButton onClick={e => { e.stopPropagation(); onFollowToggle(post.shopId, e); }}
            theme={theme} $isFollowing={followedShops.has(post.shopId)}
            $isLoading={followLoading.has(post.shopId)} disabled={followLoading.has(post.shopId)}
            title={followedShops.has(post.shopId) ? 'Following' : 'Follow'}>
            {followedShops.has(post.shopId) ? <CheckCircle size={16} /> : <PlusCircle size={16} />}
          </FollowButton>
        )}
        {!isAuthenticated && (
          <LikeButtonRight theme={theme} isLiked={false} onClick={() => { const r = encodeURIComponent(window.location.href); window.location.href = `https://kalkode.com/auth?mode=login&from=${r}&message=${encodeURIComponent('Please log in to like posts')}`; }}>
            <Heart size={20} /><span>{post.engagement?.likeCount || 0}</span>
          </LikeButtonRight>
        )}
      </PostTopBar>
      <VerticalMediaContainer theme={theme} onClick={e => { e.stopPropagation(); onItemClick(post); }} style={{ cursor: 'pointer' }}>
        {post.type === 'clip' || post.contentUrl?.includes('clip-') || post.contentUrl?.includes('%2Fclip-') ? <video src={post.contentUrl} loop muted playsInline className="media-list-video" controls /> : <img src={post.contentUrl} alt={post.caption || 'Community post'} loading="lazy" decoding="async" />}
      </VerticalMediaContainer>
      <PostBottomBar theme={theme}>
        <div className={post.caption ? 'caption' : 'no-caption'}>{post.caption || (!post.caption && isAuthenticated ? 'No caption' : '')}</div>
        {isAuthenticated && (
          <LikeButtonRight theme={theme} isLiked={post.engagement?.likes?.includes(user?.uid) || false}
            onClick={() => onCommunityPostLike(post)} style={{ marginLeft: 'auto', flexShrink: 0 }}>
            <Heart size={20} /><span>{post.engagement?.likeCount || 0}</span>
          </LikeButtonRight>
        )}
      </PostBottomBar>
    </VerticalPostCard>
  );

  const ownPostsSlice = userOwnPosts.slice(0, 6);
  const followedPosts = friendsPosts.filter(p => p.shopId !== user?.uid).slice(0, Math.max(0, 6 - ownPostsSlice.length));
  const nearbyPosts = !isAuthenticated ? friendsPosts.slice(0, 6) : [];

  return (
    <div onTouchStart={e => e.stopPropagation()} style={{ minHeight: '100vh', overflow: 'visible' }}>
      <ViewToggleContainer>
        <ViewToggleButton theme={theme} active={mediaViewMode === 'list'} onClick={() => onSetMediaViewMode('list')}><List size={16} />List</ViewToggleButton>
        <ViewToggleButton theme={theme} active={mediaViewMode === 'grid'} onClick={() => onSetMediaViewMode('grid')}><Grid size={16} />Grid</ViewToggleButton>
      </ViewToggleContainer>
      {friendsPosts.length > 0 || ownPostsSlice.length > 0 ? (
        mediaViewMode === 'list' ? (
          <VerticalPostContainer style={{ overflow: 'visible', minHeight: '100vh' }}>
            {isAuthenticated && ownPostsSlice.map((post, i) => (
              <React.Fragment key={`own-${post.shopId}-${post.id}`}>
                {renderPostCard(post, `own-card-${post.id}`, false)}
                {i < ownPostsSlice.length - 1 && <PostDivider theme={theme} />}
              </React.Fragment>
            ))}
            {isAuthenticated && followedPosts.map((post, i, arr) => (
              <React.Fragment key={`followed-${post.shopId}-${post.id}`}>
                {renderPostCard(post, `followed-card-${post.id}`, true)}
                {i < arr.length - 1 && <PostDivider theme={theme} />}
              </React.Fragment>
            ))}
            {nearbyPosts.map((post, i) => (
              <React.Fragment key={`nearby-${post.shopId}-${post.id}`}>
                {renderPostCard(post, `nearby-card-${post.id}`, false)}
                {i < nearbyPosts.length - 1 && <PostDivider theme={theme} />}
              </React.Fragment>
            ))}
          </VerticalPostContainer>
        ) : (
          <GridPostContainer theme={theme}>
            {friendsPosts.slice(0, 6).map(post => (
              <GridPostCard key={`grid-${post.shopId}-${post.id}`} theme={theme} onClick={() => onItemClick(post)}>
                {post.type === 'clip' || post.contentUrl?.includes('clip-') || post.contentUrl?.includes('%2Fclip-') ? <video src={post.contentUrl} muted /> : <img src={post.contentUrl} alt={post.caption || 'Post'} loading="lazy" decoding="async" />}
                <div className="overlay-info">
                  <div className="shop-name">{post.shopName}</div>
                  <div className="like-count"><Heart size={12} />{post.engagement?.likeCount || 0}</div>
                </div>
              </GridPostCard>
            ))}
          </GridPostContainer>
        )
      ) : loadingFriends ? (
        <LoadingSpinner />
      ) : (
        <EmptyGridMessage><h3>No Posts Yet, Be the First to Post.</h3></EmptyGridMessage>
      )}
    </div>
  );
});

// ─────────────────────────────────────────────────────────────────────────────

// How long the cached full-collection fetch (allFetchedItemsRef / allFetchedServicesRef)
// stays fresh before a reload re-scans the shops collection — keeps a long SPA
// session (no full page reload) from permanently showing stale shops/pfps.
const FEED_CACHE_TTL_MS = 3 * 60 * 1000;

const WelcomePage = () => {
  const navigate = useNavigate();
  const [motivationalMessage, setMotivationalMessage] = useState("");
  // Randomized once per page load so the same tab (Products) isn't always
  // the first thing every visitor sees — picked once via the lazy initializer
  // so it stays stable across re-renders instead of re-rolling every render.
  // Only Products/Services are in the pool (Events and Media aren't good
  // "first impression" landing tabs for a random visitor).
  // Feed cache: if a previous WelcomePage mount in this SPA session already
  // loaded everything, hydrate straight from it instead of starting empty —
  // this is what lets navigating to a shop and back skip the reload entirely.
  // Resets naturally on a hard reload/PWA relaunch since it's just a module
  // variable (see src/utils/feedCache.js).
  const cachedFeed = getFeedCache();
  const [activeTab, setActiveTab] = useState(() => {
    if (cachedFeed?.activeTab) return cachedFeed.activeTab;
    const tabs = ['featured', 'services'];
    return tabs[Math.floor(Math.random() * tabs.length)];
  });
  const [visitedTabs, setVisitedTabs] = useState(() =>
    cachedFeed?.visitedTabs ? new Set(cachedFeed.visitedTabs) : new Set([activeTab])
  );
  const [featuredItems, setFeaturedItems] = useState(() => cachedFeed?.featuredItems || []);
  const [loading, setLoading] = useState(() => !cachedFeed);
  const [error, setError] = useState(null);
  // A handful of real (unsorted, no distance computed) cards fetched the
  // instant the page mounts, shown in place of the skeleton while the full
  // location-aware fetch/categorize/sort pipeline is still running. Once
  // that finishes, the real categorized/sorted data takes over everywhere
  // these are used — proximity sorting is only skipped for this first
  // quick batch, never for the rest of the feed.
  const [quickPreviewItems, setQuickPreviewItems] = useState([]);
  const [quickPreviewServices, setQuickPreviewServices] = useState([]);
  const [nearbyItems, setNearbyItems] = useState([]);
  const [featuredMedia, setFeaturedMedia] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchAddress, setSearchAddress] = useState('');
  const [searching, setSearching] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const [locationChecked, setLocationChecked] = useState(false);
  const [showLocationPrompt, setShowLocationPrompt] = useState(false);
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const [eventPosts, setEventPosts] = useState(() => cachedFeed?.eventPosts || []);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [expandedEventId, setExpandedEventId] = useState(null);
  const [totalItems, setTotalItems] = useState(() => cachedFeed?.totalItems || 0);
  // Lazy initializers so the theme (pinned or random) is picked synchronously on
  // the very first render, instead of starting null and flipping colors a moment
  // later once a mount effect runs — that null->themed jump was a visible flash
  // on every page load.
  const [currentStyle, setCurrentStyle] = useState(() => {
    try {
      const pinnedStyleId = localStorage.getItem('pinnedStyleId');
      if (pinnedStyleId) {
        const pinnedStyle = Object.values(WELCOME_STYLES).find(
          style => style.id.toString() === pinnedStyleId
        );
        if (pinnedStyle) return pinnedStyle;
      }
    } catch (_) { /* localStorage unavailable — fall through to random */ }
    const styles = Object.values(WELCOME_STYLES);
    return styles[Math.floor(Math.random() * styles.length)];
  });
  const itemsPerPage = 6;
  const [isPinned, setIsPinned] = useState(() => !!localStorage.getItem('pinnedStyleId'));
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [orderQuantity, setOrderQuantity] = useState(1);
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  const [infoPanelOpen, setInfoPanelOpen] = useState(false);
  const [restaurantPanelOpen, setRestaurantPanelOpen] = useState(false);
  const [attributesPanelOpen, setAttributesPanelOpen] = useState(false);
  const [jobInfoPanelOpen, setJobInfoPanelOpen] = useState(false);
  const [selectedAttributes, setSelectedAttributes] = useState({});
  const [zoomedShopItems, setZoomedShopItems] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedSides, setSelectedSides] = useState(new Set());
  const [sideItemOptions, setSideItemOptions] = useState({});
  const [specialInstructions, setSpecialInstructions] = useState('');
  const [showTerms, setShowTerms] = useState(false);
const [followingFilter, setFollowingFilter] = useState(() => cachedFeed?.followingFilter || 'public'); // 'public' or 'following'
const [followedShops, setFollowedShops] = useState(new Set());
const [followLoading, setFollowLoading] = useState(new Set()); 

const [showAuthOptions, setShowAuthOptions] = useState(false);
const [authLoading, setAuthLoading] = useState(false);
const [showBrandModal, setShowBrandModal] = useState(false);
const [brandNameInput, setBrandNameInput] = useState('');
const [brandNameError, setBrandNameError] = useState('');
const [brandNameChecking, setBrandNameChecking] = useState(false);
const [brandLogoFile, setBrandLogoFile] = useState(null);
const [brandLogoPreview, setBrandLogoPreview] = useState(null);
const [showSignInPrompt, setShowSignInPrompt] = useState(false);
const [showZoomGooglePrompt, setShowZoomGooglePrompt] = useState(false);
const [inviteShopName, setInviteShopName] = useState('');

const [deferredPrompt, setDeferredPrompt] = useState(null);
const [showPWAInstall, setShowPWAInstall] = useState(false);
const [showIOSGuide, setShowIOSGuide] = useState(false);
const [showInstagramGuide, setShowInstagramGuide] = useState(false);
  
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [productSearchResults, setProductSearchResults] = useState([]);
  const [isLoadingContent, setIsLoadingContent] = useState(false);
  const [hasProductSearchResults, setHasProductSearchResults] = useState(false);
  
  const [featuredServices, setFeaturedServices] = useState(() => cachedFeed?.featuredServices || []);
  const [serviceSearchTerm, setServiceSearchTerm] = useState('');
  const [serviceSearchResults, setServiceSearchResults] = useState([]);
  const [hasServiceSearchResults, setHasServiceSearchResults] = useState(false);
  const [mediaViewMode, setMediaViewMode] = useState('list'); // 'list' or 'grid'
  const [eventsViewMode, setEventsViewMode] = useState('list'); // 'list' or 'grid'

  const [mediaSearchTerm, setMediaSearchTerm] = useState('');
  const [mediaSearchResults, setMediaSearchResults] = useState([]);
  const [hasMediaSearchResults, setHasMediaSearchResults] = useState(false);
  const [isAmharicLocale, setIsAmharicLocale] = useState(false);
  const [currentAmharicFont, setCurrentAmharicFont] = useState('amharic-font-1');
  const [friendsPosts, setFriendsPosts] = useState(() => cachedFeed?.friendsPosts || []);
  const [loadingFriends, setLoadingFriends] = useState(false);
  const [isZoomOpen, setIsZoomOpen] = useState(false);
  // Unified QR overlay — used for both the static KalKode QR and a shop's own
  // QR code. null = closed; otherwise { image, title, subtitle, linkUrl, loading, error }.
  const [qrOverlay, setQrOverlay] = useState(null);
  const [qrLinkCopied, setQrLinkCopied] = useState(false);

  const videoObserverRef = useRef(null);

  const [itemCardSwipeOffset, setItemCardSwipeOffset] = useState(0);
const [itemCardSwipeStartX, setItemCardSwipeStartX] = useState(null);
const [isSwipingItemCard, setIsSwipingItemCard] = useState(false);

const [cartItems, setCartItems] = useState([]);
const [showCartDropdown, setShowCartDropdown] = useState(false);
// Category keys (cat_*/svc_*) are deliberately left unseeded here — whether
// a category defaults to collapsed or expanded depends on screen width
// (desktop starts collapsed, mobile starts expanded) and is resolved at
// render time in ProductsTab/ServicesTab. Once a user actually toggles one,
// their explicit choice lives here and overrides that default.
const [collapsedSections, setCollapsedSections] = useState({});
const [catGridCols, setCatGridCols] = useState({});
const setCatCols = useCallback((key, val) => setCatGridCols(prev => ({ ...prev, [key]: val })), []);
const [headerVisible, setHeaderVisible] = useState(true);
const lastScrollYRef = useRef(0);
const scrollUpAccumRef = useRef(0);
// "Show more" per category — reveals the rest of that category's already-
// fetched/cached items instead of the default 20 (products) / 30 (services)
// slice. Pure client-side reveal, no refetch.
const [expandedCategories, setExpandedCategories] = useState({});

// `currentEffective`, when passed, is what's actually rendered right now
// (accounting for the responsive default when the user hasn't explicitly
// toggled this key yet) — toggling flips THAT, not the possibly-undefined
// raw stored value, so a desktop category that starts collapsed by default
// actually expands on the first click instead of "toggling" straight back
// to collapsed.
const toggleSection = useCallback((key, currentEffective) => {
  setCollapsedSections(prev => {
    const current = currentEffective !== undefined ? currentEffective : !!prev[key];
    return { ...prev, [key]: !current };
  });
}, []);

const expandCategory = useCallback((key) => {
  setExpandedCategories(prev => ({ ...prev, [key]: true }));
}, []);

  
  const { user, isAuthenticated } = useAuth();
  const [shopData, setShopData] = useState(null);
  const sliderRef = useRef(null);
  const sliderAnimationRef = useRef(null);
  const [zoomedItem, setZoomedItem] = useState(null);
  // City badge for the zoomed carousel — independent of formatItemLocation's
  // distance-first label, so it reliably shows a city even for nearby items
  // that never went through the far-item reverse-geocode step.
  const [zoomedItemCity, setZoomedItemCity] = useState(null);

  useEffect(() => {
    setZoomedItemCity(null);
    if (!zoomedItem) return;

    if (zoomedItem.city) {
      setZoomedItemCity(formatCityStateLabel(zoomedItem));
      return;
    }

    const lat = zoomedItem.coordinates?.lat;
    const lng = zoomedItem.coordinates?.lng;
    if (lat == null || lng == null) return;

    let cancelled = false;
    reverseGeocode(lat, lng).then(geo => {
      if (!cancelled && geo?.city) {
        setZoomedItemCity(formatCityStateLabel({ city: geo.city, state: geo.state, country: geo.country }));
      }
    });
    return () => { cancelled = true; };
  }, [zoomedItem?.id, zoomedItem?.shopId, zoomedItem?.city, zoomedItem?.coordinates?.lat, zoomedItem?.coordinates?.lng]);

  const [showZoomedOrderForm, setShowZoomedOrderForm] = useState(false);
  // Live duration/date-aware total reported up by the inline OrderFormPanel, so the
  // sticky "Order" CTA can show the real price instead of a flat per-unit rate.
  const [zoomedOrderTotal, setZoomedOrderTotal] = useState(null);
  const formScrollRef = useRef(null);
  const shouldOpenFormOnZoom = useRef(false);
  const [showSharePanel, setShowSharePanel] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const [feedShops, setFeedShops] = useState([]);
  const [feedServiceShops, setFeedServiceShops] = useState([]);
  const [shopOverlay, setShopOverlay] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const [selectedChatItem, setSelectedChatItem] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { userLocation, locationPermission, requestLocation } = useLocation();
  const [updatingLocation, setUpdatingLocation] = useState(false);
  const [themeDropdownOpen, setThemeDropdownOpen] = useState(false);
  const [showFollowingLoginPrompt, setShowFollowingLoginPrompt] = useState(false);
  const [showLocationToast, setShowLocationToast] = useState(false);
  const [locationToastMessage, setLocationToastMessage] = useState('');
  const [userOwnPosts, setUserOwnPosts] = useState(() => cachedFeed?.userOwnPosts || []);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearchResults, setHasSearchResults] = useState(false);
  const prevLocationRef = useRef(null);
  const loadedFilterRef = useRef(null);
  // Raw (unfiltered-by-following) results from getFeaturedItems/getFeaturedServices —
  // that fetch scans the entire shops collection and doesn't depend on
  // location or the following filter, so once we have it, toggling
  // Public/Following just re-filters this cached list client-side instead of
  // re-scanning the whole collection again.
  const allFetchedItemsRef = useRef(null);
  const allFetchedServicesRef = useRef(null);
  // Timestamps for the above — past FEED_CACHE_TTL_MS, a reload re-scans the
  // shops collection instead of reusing the stale list, so new shops and
  // profile-picture updates show up without the user having to fully reload
  // the app (SPA navigation alone never touches these refs).
  const allFetchedItemsTimeRef = useRef(0);
  const allFetchedServicesTimeRef = useRef(0);
  // Whether this mount started out hydrated from a previous session's cache —
  // used to skip the initial load effect entirely when we already have data.
  const hydratedFromCacheRef = useRef(!!cachedFeed);
  const defaultCategories = () => Object.fromEntries([
    ...STORE_TYPES.map(t => [t.label, []]),
    ['Digital Products', []],
  ]);
  const [categories, setCategories] = useState(() => cachedFeed?.categories || defaultCategories());

  const [serviceCategories, setServiceCategories] = useState(() => cachedFeed?.serviceCategories || {});

  // Flattened lists fed to the map overlay. Memoized so these stay stable
  // across renders that don't actually touch item/category data (e.g. a theme
  // refresh) — without this, TreasureMap saw a brand-new array every render
  // and re-ran its own distance filtering each time, which is what made theme
  // switching feel slow: it wasn't a refetch, just this recomputing for no reason.
  const allMapProducts = useMemo(
    () => [...featuredItems, ...Object.values(categories).flat()],
    [featuredItems, categories]
  );
  const allMapServices = useMemo(
    () => [...featuredServices, ...Object.values(serviceCategories).flat()],
    [featuredServices, serviceCategories]
  );



// Replace the existing state variables related to ZIP with city/region states
const [effectiveLocation, setEffectiveLocation] = useState(null);
const [deviceInfo] = useState(() => getDeviceInfo());
const [isIPLocation, setIsIPLocation] = useState(false);
const [showGuestInfoModal, setShowGuestInfoModal] = useState(false);
const [pendingGuestOrder, setPendingGuestOrder] = useState(null);
// Add these state variables with the other useState declarations
const [cityRegion, setCityRegion] = useState('');
const [isConvertingToCity, setIsConvertingToCity] = useState(false);
const [cityInputValue, setCityInputValue] = useState('');
const [currentBgImage, setCurrentBgImage] = useState(TREASURE_BACKGROUNDS[0]);
const [isProcessingClick, setIsProcessingClick] = useState(false);
const [clusterItems, setClusterItems] = useState([]); // NEW - array of items from chest
const [currentClusterIndex, setCurrentClusterIndex] = useState(0); // NEW - current position in cluster

const eventsTabRef = useRef(null);
const mediaTabRef = useRef(null);
const featuredTabRef = useRef(null);
const servicesTabRef = useRef(null);
const gigsTabRef = useRef(null);

// Flush queued view increments before leaving the page
useEffect(() => {
  const flush = () => { flushPendingViews(); };
  const handleVisibility = () => { if (document.visibilityState === 'hidden') flushPendingViews(); };
  window.addEventListener('beforeunload', flush);
  document.addEventListener('visibilitychange', handleVisibility);
  return () => {
    flushPendingViews();
    window.removeEventListener('beforeunload', flush);
    document.removeEventListener('visibilitychange', handleVisibility);
  };
}, []);

// Hide header on scroll down; require sustained upward scroll before showing again.
// Desktop: ~3 scroll notches (240px); Mobile: ~2 notches (160px).
useEffect(() => {
  const handleScroll = () => {
    const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const delta = currentY - lastScrollYRef.current;
    const isDesktop = window.innerWidth > 768;
    const needed = isDesktop ? 240 : 160;

    if (currentY < 10) {
      setHeaderVisible(true);
      scrollUpAccumRef.current = 0;
    } else if (delta > 8) {
      setHeaderVisible(false);
      scrollUpAccumRef.current = 0;
    } else if (delta < -4) {
      scrollUpAccumRef.current += Math.abs(delta);
      if (scrollUpAccumRef.current >= needed) {
        setHeaderVisible(true);
      }
    }

    lastScrollYRef.current = currentY;
  };
  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}, []);

// Lock body scroll when shop overlay is open
useEffect(() => {
  if (shopOverlay) {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }
}, [shopOverlay]);

useEffect(() => {
  // Clear all searches when tab changes
  setProductSearchTerm('');
  setProductSearchResults([]);
  setHasProductSearchResults(false);
  setServiceSearchTerm('');
  setServiceSearchResults([]);
  setHasServiceSearchResults(false);
  setMediaSearchTerm('');
  setMediaSearchResults([]);
  setHasMediaSearchResults(false);
}, [activeTab]);

useEffect(() => {
  setVisitedTabs(prev => { if (prev.has(activeTab)) return prev; return new Set([...prev, activeTab]); });
}, [activeTab]);


useEffect(() => {
  if (isPWA()) {
    setShowPWAInstall(false);
    return;
  }

  const ua = navigator.userAgent;
  const isIOSDevice  = (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isInstagram  = /Instagram/.test(ua);

  // iOS and Instagram never fire beforeinstallprompt — show button manually
  if (isIOSDevice || isInstagram) {
    setShowPWAInstall(true);
  }

  // Listen for the beforeinstallprompt event (Android/Desktop Chrome)
  const handleBeforeInstallPrompt = (e) => {
    e.preventDefault();
    setDeferredPrompt(e);
    setShowPWAInstall(true);
  };

  window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

  const handleAppInstalled = () => {
    setShowPWAInstall(false);
    setDeferredPrompt(null);
  };

  window.addEventListener('appinstalled', handleAppInstalled);

  return () => {
    window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.removeEventListener('appinstalled', handleAppInstalled);
  };
}, []);

useEffect(() => {
  // Only run in media tab, list view
  if (activeTab !== 'media' || mediaViewMode !== 'list') {
    // Disconnect any existing observer when leaving media/list
    if (videoObserverRef.current) {
      videoObserverRef.current.disconnect();
      videoObserverRef.current = null;
    }
    return;
  }

  // Small delay to let DOM render
  const timer = setTimeout(() => {
    // Disconnect previous observer
    if (videoObserverRef.current) {
      videoObserverRef.current.disconnect();
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {}); // catch prevents unhandled promise on blocked autoplay
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.5, // 50% of video must be visible to play
      }
    );

    videoObserverRef.current = observer;

    // Observe all videos currently in the media list
    const videos = document.querySelectorAll('.media-list-video');
    videos.forEach((video) => observer.observe(video));
  }, 300);

  return () => {
    clearTimeout(timer);
    if (videoObserverRef.current) {
      videoObserverRef.current.disconnect();
      videoObserverRef.current = null;
    }
  };
}, [activeTab, mediaViewMode, friendsPosts, userOwnPosts]);

useEffect(() => {
  const loadFollowingList = async () => {
    if (!isAuthenticated || !user?.uid) {
      setFollowedShops(new Set());
      return;
    }

    try {
      const { getShopData } = await import('../firebase/firebaseService');
      const userData = await getShopData(user.uid);
      
      if (userData && userData.following) {
        setFollowedShops(new Set(userData.following));
        console.log('✅ Loaded following list:', userData.following.length, 'shops');
      }
    } catch (error) {
      console.error('❌ Error loading following list:', error);
    }
  };

  loadFollowingList();
}, [isAuthenticated, user]);

const getAllItemsFromCurrentTab = useCallback(() => {
  switch (activeTab) {
    case 'featured':
      if (hasProductSearchResults) {
        return productSearchResults;
      }
      return [
        ...featuredItems,
        ...Object.values(categories).flat()
      ];
    case 'services':
      if (hasServiceSearchResults) {
        return serviceSearchResults.filter(s => (s.serviceTab || 'offer') === 'offer');
      }
      return [
        ...featuredServices.filter(s => (s.serviceTab || 'offer') === 'offer'),
        ...Object.values(serviceCategories).flat().filter(s => (s.serviceTab || 'offer') === 'offer')
      ];
    case 'gigs':
      if (hasServiceSearchResults) {
        return serviceSearchResults.filter(s => (s.serviceTab || 'offer') === 'need');
      }
      return [
        ...featuredServices.filter(s => (s.serviceTab || 'offer') === 'need'),
        ...Object.values(serviceCategories).flat().filter(s => (s.serviceTab || 'offer') === 'need')
      ];
    case 'media':
      try {
        const combined = [];
        const seen = new Set();
        const pushIfNew = (p) => {
          if (!p) return;
          const key = `${p.shopId}::${p.id}`;
          if (seen.has(key)) return;
          seen.add(key);
          combined.push(p);
        };
        if (Array.isArray(userOwnPosts)) userOwnPosts.forEach(pushIfNew);
        if (Array.isArray(friendsPosts)) friendsPosts.forEach(pushIfNew);
        return combined;
      } catch (err) {
        console.warn('Error building media items list', err);
        return friendsPosts || [];
      }
    case 'events':
      return eventPosts || [];
    default:
      return [];
  }
}, [activeTab, featuredItems, categories, featuredServices, serviceCategories, hasProductSearchResults, productSearchResults, hasServiceSearchResults, serviceSearchResults, userOwnPosts, friendsPosts, eventPosts]);

const loadEventsContent = async () => {
  console.log('🎉 Preloading events content...');
  setLoadingEvents(true);
  
  try {
    let allEvents = [];
    
    if (isAuthenticated && user?.uid) {
      console.log('🔍 Fetching events for authenticated user...');
      const events = await getEventPosts(user.uid, effectiveLocation, 20); // ✅ Limit to 20
      allEvents = events;
    } else {
      if (effectiveLocation) {
        console.log('📍 Fetching nearby events...');
        const events = await getEventPosts(null, effectiveLocation, 20); // ✅ Limit to 20
        allEvents = events;
      }
    }
    
    console.log(`✅ Preloaded ${allEvents.length} events (max 20)`);
    setEventPosts(allEvents.slice(0, 20)); // ✅ Hard limit to 20
  } catch (error) {
    console.error('❌ Error preloading events:', error);
    setEventPosts([]);
  } finally {
    setLoadingEvents(false);
  }
};

// 3. Create a new loadMediaContent function (replace the existing Media useEffect)
const loadMediaContent = async () => {
  console.log('📱 Preloading media content...');
  setLoadingFriends(true);

  try {
    if (isAuthenticated && user?.uid) {
      // Own posts and followed-shop posts don't depend on each other — fetch
      // them in parallel instead of back-to-back, then render immediately.
      // The nearby-posts fallback below only fires when that wasn't enough to
      // fill the feed, so it's kept as a second, separate append instead of
      // making the first render wait on it too.
      console.log('📱 Loading own + followed posts in parallel...');
      const [ownPosts, followedPosts] = await Promise.all([
        getCommunityPostsForShop(user.uid, 20),
        getFollowedShopsPosts(user.uid, 20), // ✅ Limit to 20
      ]);
      const ownSlice = ownPosts.slice(0, 20); // ✅ Limit to 20
      setUserOwnPosts(ownSlice);

      let combined = [...ownSlice, ...followedPosts];
      console.log(`✅ Preloaded ${Math.min(combined.length, 20)} media posts (own + followed)`);
      setFriendsPosts(combined.slice(0, 20)); // ✅ Hard limit to 20 — shown right away

      // If we still need more content, add nearby posts on top of what's already showing
      if (combined.length < 20 && effectiveLocation) {
        console.log('📍 Loading nearby posts...');
        const nearbyPosts = await getPopularPostsInArea(effectiveLocation, 50, 20);

        // Filter out duplicates
        const existingIds = new Set(combined.map(p => `${p.shopId}-${p.id}`));
        const uniqueNearbyPosts = nearbyPosts.filter(p =>
          !existingIds.has(`${p.shopId}-${p.id}`)
        );

        combined = [...combined, ...uniqueNearbyPosts];
        console.log(`✅ Preloaded ${Math.min(combined.length, 20)} media posts (+ nearby)`);
        setFriendsPosts(combined.slice(0, 20)); // ✅ Hard limit to 20
      }
    } else {
      // Not authenticated - just load popular posts in area
      if (effectiveLocation) {
        console.log('🌍 Loading popular posts in area...');
        const allPosts = await getPopularPostsInArea(effectiveLocation, 50, 20);
        console.log(`✅ Preloaded ${allPosts.slice(0, 20).length} media posts (max 20)`);
        setFriendsPosts(allPosts.slice(0, 20)); // ✅ Hard limit to 20
      } else {
        setFriendsPosts([]);
      }
    }
  } catch (error) {
    console.error('❌ Error preloading media:', error);
    setFriendsPosts([]);
  } finally {
    setLoadingFriends(false);
  }
};

const handleBookEvent = (event) => {
  if (!isAuthenticated) {
    // Redirect to login or show auth modal
    navigate('/auth', { state: { mode: 'login' } });
    return;
  }
  
  console.log('Booking event:', event);
  // Implement booking logic here
  // You could open a chat with the event organizer
  // or navigate to a booking page
};

const handleFollowToggle = async (shopId, e) => {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }

  if (!isAuthenticated || !user?.uid) {
    handleGoogleSignIn();
    return;
  }

  if (shopId === user.uid) {
    console.log('Cannot follow your own shop');
    return;
  }

  // Add to loading set
  setFollowLoading(prev => new Set(prev).add(shopId));

  try {
    const isCurrentlyFollowing = followedShops.has(shopId);
    
    // Optimistic update
    setFollowedShops(prev => {
      const newSet = new Set(prev);
      if (isCurrentlyFollowing) {
        newSet.delete(shopId);
      } else {
        newSet.add(shopId);
      }
      return newSet;
    });

    // Call Firebase function
    const result = await toggleFollowShop(user.uid, shopId);
    
    console.log(result ? '✅ Followed shop:' : '❌ Unfollowed shop:', shopId);
    
  } catch (error) {
    console.error('❌ Error toggling follow:', error);
    
    // Revert optimistic update on error
    setFollowedShops(prev => {
      const newSet = new Set(prev);
      if (newSet.has(shopId)) {
        newSet.delete(shopId);
      } else {
        newSet.add(shopId);
      }
      return newSet;
    });
    
    alert('Failed to update follow status. Please try again.');
  } finally {
    // Remove from loading set
    setFollowLoading(prev => {
      const newSet = new Set(prev);
      newSet.delete(shopId);
      return newSet;
    });
  }
};

const handleBrandNameSubmit = async () => {
  let name = brandNameInput.trim();
  // Validation only when user has typed something
  if (name) {
    if (name.length < 2) { setBrandNameError('Brand name must be at least 2 characters.'); return; }
    if (name.length > 50) { setBrandNameError('Brand name must be 50 characters or less.'); return; }
    const slug = name.toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!slug) { setBrandNameError('Brand name must contain at least one letter or number.'); return; }
    setBrandNameChecking(true);
    setBrandNameError('');
    try {
      const { usernameExists } = await import('../firebase/firebaseService');
      const taken = await usernameExists(slug);
      if (taken) { setBrandNameError('That name is already taken — try something unique!'); setBrandNameChecking(false); return; }
    } catch (_) {}
    setBrandNameChecking(false);
  }
  // Store name (empty = handleGoogleSignIn will auto-generate one)
  if (name) sessionStorage.setItem('kk_guest_name', name);
  setShowBrandModal(false);
  handleGoogleSignIn();
};

const handleGoogleSignIn = async () => {
  try {
    setAuthLoading(true);
    console.log('🔐 Attempting Google Sign-In...');
    
  const result = await safeSignInWithPopup(googleProvider);
  const user = result.user;
    
    console.log('✅ Google Sign-In successful:', user.uid);
    
    const { checkExistingShop, saveShopData, generateUsername } = await import('../firebase/firebaseService');
    const hasShop = await checkExistingShop(user.uid);
    
    if (!hasShop) {
      console.log('📝 No account found - creating new shop with default settings...');
      
      // Generate a cool marketplace-style name instead of using their personal name
      const marketplaceNames = [
  "Side Hustle",
  "Sailor",
  "Plug",
  "Stash",
  "Vault",
  "Block",
  "Corner",
  "Supply",
  "Cashout",
  "Street",
  "Motion",
  "Deal",
  "Flip",
  "Drop",
  "Link",
  "Run",
  "Load",
  "Bag",
  "Stack",
  "Exchange"
];
      const emailName = user.email.split('@')[0];

      // Use guest-entered name if available, else fall back to random marketplace name
      const storedGuestName = sessionStorage.getItem('kk_guest_name');
      sessionStorage.removeItem('kk_guest_name');
      sessionStorage.removeItem('kk_guest_email');
      setBrandLogoFile(null);
      setBrandLogoPreview(null);

      const randomMarketplaceName = marketplaceNames[Math.floor(Math.random() * marketplaceNames.length)];
      const shopName = storedGuestName || `${randomMarketplaceName} ${Math.floor(Math.random() * 999)}`;

      const username = await generateUsername(shopName);
      
      // Import WELCOME_STYLES
      const { WELCOME_STYLES } = await import('../theme/welcomeStyles');
      
      // Create default shop data with marketplace-style name
      const defaultShopData = {
        name: shopName,
        username: username,
        description: ``,
        profile: brandLogoFile ? { file: brandLogoFile } : null,
        theme: WELCOME_STYLES.STYLE_1, // Default theme
        isRestaurant: false,
        selectedHomeTemplate: 1,
        items: [],
        services: [],
        layout: {
          namePosition: 'left',
          tabPosition: 'top',
          nameSize: 2.5
        },
        profileBackgroundImages: [
          'https://images.unsplash.com/photo-1522124624696-7ea32eb9592c?q=80&w=1169&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1444080748397-f442aa95c3e5?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
          'https://images.unsplash.com/photo-1520034475321-cbe63696469a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
        ],
        homeSections: [
          {
            id: 'hero-1',
            type: 'hero-banner',
            order: 0,
            config: {
              headline: shopName,
              subtitle: 'Your digital marketplace for unique finds',
              backgroundImage: null,
              height: '70vh'
            }
          },
          {
            id: 'mission-1',
            type: 'mission-statement',
            order: 1,
            config: {
              title: 'Mission',
              content: 'We have top quality products ready to be delivered with exceptional customer service. Our commitment to quality  drives everything we do.'
            }
          }
        ],
        ownerInfo: {
          // Store original user info separately
          originalName: user.displayName || emailName,
          email: user.email,
          photoURL: user.photoURL
        },
        createdAt: new Date().toISOString()
      };
      
      // Save the default shop
      await saveShopData(user.uid, defaultShopData);
      console.log('✅ Default shop created successfully with marketplace name:', shopName);
    }
    
    // Navigate to the first accessible shop (own shop first, then shared)
    let firstShopId = user.uid; // default to own shop
    try {
      const { getDocs: _getDocs, collection: _col, query: _q, where: _where } = await import('firebase/firestore');
      const { db: _db } = await import('../firebase/config');
      const userSnap = await (await import('firebase/firestore')).getDoc(
        (await import('firebase/firestore')).doc(_db, 'users', user.uid)
      );
      if (userSnap.exists()) {
        const userData = userSnap.data();
        const ownedShops = userData.ownedShops || [];
        const shopAccess = userData.shopAccess || [];
        // Check if own primary shop exists
        const ownSnap = await (await import('firebase/firestore')).getDoc(
          (await import('firebase/firestore')).doc(_db, 'shops', user.uid)
        );
        if (!ownSnap.exists() && ownedShops.length === 0 && shopAccess.length > 0) {
          // User has no own shop but has shared access — go to first shared shop
          firstShopId = shopAccess[0].shopId;
        }
      }
    } catch (_) { /* non-critical, fall back to own uid */ }
    navigate(`/shop/${firstShopId}`);
    
  } catch (error) {
    console.error('❌ Google Sign-In error:', error);
    
    // ✅ UPDATED: Better error handling with specific checks
    if (error.code === 'auth/popup-blocked') {
      alert('Popup was blocked. Please allow popups and try again.');
    } else if (
      error.code === 'auth/popup-closed-by-user' ||
      error.code === 'auth/cancelled-popup-request' ||
      error.code === 'auth/popup-in-progress'
    ) {
      // User dismissed or another popup is still clearing — silent, they can try again
    } else {
      alert('Failed to sign in with Google. Please try again.');
    }
  } finally {
    // ✅ CRITICAL: Always stop loading, even if user closes popup
    setAuthLoading(false);
  }
};

const handleEmailSignIn = () => {
  setShowAuthOptions(false);
  navigate('/auth', { state: { mode: 'login' } });
};


const handlePrevImage = useCallback(() => {
  if (!zoomedItem || !zoomedItem.images) return;
  const validImages = zoomedItem.images.filter(Boolean);
  if (validImages.length <= 1) return;
  
  setCurrentImageIndex(prev => 
    prev === 0 ? validImages.length - 1 : prev - 1
  );
}, [zoomedItem]);

// When a new item is zoomed, open form + scroll if triggered via unzoomed Order button
useEffect(() => {
  if (!zoomedItem || !shouldOpenFormOnZoom.current) return;
  shouldOpenFormOnZoom.current = false;
  const t = setTimeout(() => {
    setShowZoomedOrderForm(true);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      formScrollRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
  }, 120);
  return () => clearTimeout(t);
}, [zoomedItem?.id]); // eslint-disable-line react-hooks/exhaustive-deps

// Reset the live order total whenever a different card is zoomed in — the inline
// OrderFormPanel reports a fresh value for the new item right after.
useEffect(() => {
  setZoomedOrderTotal(null);
}, [zoomedItem?.id]);

// Add function to handle horizontal image navigation
const handleNextImage = useCallback(() => {
  if (!zoomedItem || !zoomedItem.images) return;
  const validImages = zoomedItem.images.filter(Boolean);
  if (validImages.length <= 1) return;
  
  setCurrentImageIndex(prev => (prev + 1) % validImages.length);
}, [zoomedItem]);

const handleNextItem = useCallback(() => {
  const allItems = getAllItemsFromCurrentTab();
  if (allItems.length <= 1) return;
  
  const currentIndex = allItems.findIndex(item => 
    item.id === zoomedItem?.id && item.shopId === zoomedItem?.shopId
  );
  
  if (currentIndex === -1) return;
  
  const nextIndex = (currentIndex + 1) % allItems.length;
  const nextItem = allItems[nextIndex];
  
  // ✅ ADD: Transform media posts just like handleItemClick does
  const isPost = nextItem.contentUrl || nextItem.type === 'image' || nextItem.type === 'video';
  const isEvent = nextItem.eventDate || nextItem.isEvent;
  
  let itemToSet = nextItem;
  if (isPost || isEvent) {
    itemToSet = {
      ...nextItem,
      id: nextItem.id,
      shopId: nextItem.shopId,
      name: nextItem.title || nextItem.name || 'Untitled',
      price: nextItem.price || '0',
      description: nextItem.caption || nextItem.description || '',
      images: nextItem.contentUrl ? [{ 
        url: nextItem.contentUrl, 
        isVideo: nextItem.type === 'video' || 
                 (nextItem.contentUrl?.includes('clip-')) ||
                 (nextItem.contentUrl?.includes('%2Fclip-'))
      }] : [],
      isService: isEvent,
      quantity: isEvent ? (nextItem.capacity || nextItem.slots || 1) : 1,
      slots: nextItem.capacity || nextItem.slots,
      isLiked: nextItem.engagement?.likes?.includes(user?.uid) || false,
      likeCount: nextItem.engagement?.likeCount || 0,
      shopName: nextItem.shopName,
      shopProfile: nextItem.shopProfile,
      shopUsername: nextItem.shopUsername
    };
  }
  
  setZoomedItem(itemToSet);
  setShowZoomedOrderForm(false);
  setShowZoomGooglePrompt(false);
  setCurrentImageIndex(0);
  setOrderQuantity(1);
  setInfoPanelOpen(false);
  setJobInfoPanelOpen(false);
  setClusterItems([itemToSet]);
  setCurrentClusterIndex(0);

  if (nextItem.shopId && nextItem.id) {
    queueViewIncrement(nextItem.shopId, nextItem.id, nextItem.isService);
  }
}, [zoomedItem, getAllItemsFromCurrentTab, user?.uid]);

const handlePrevItem = useCallback(() => {
  const allItems = getAllItemsFromCurrentTab();
  if (allItems.length <= 1) return;
  
  const currentIndex = allItems.findIndex(item => 
    item.id === zoomedItem?.id && item.shopId === zoomedItem?.shopId
  );
  
  if (currentIndex === -1) return;
  
  const prevIndex = currentIndex === 0 
    ? allItems.length - 1 
    : currentIndex - 1;
  const prevItem = allItems[prevIndex];
  
  // ✅ ADD: Transform media posts just like handleItemClick does
  const isPost = prevItem.contentUrl || prevItem.type === 'image' || prevItem.type === 'video';
  const isEvent = prevItem.eventDate || prevItem.isEvent;
  
  let itemToSet = prevItem;
  if (isPost || isEvent) {
    itemToSet = {
      ...prevItem,
      id: prevItem.id,
      shopId: prevItem.shopId,
      name: prevItem.title || prevItem.name || 'Untitled',
      price: prevItem.price || '0',
      description: prevItem.caption || prevItem.description || '',
      images: prevItem.contentUrl ? [{ 
        url: prevItem.contentUrl, 
        isVideo: prevItem.type === 'video' || 
                 (prevItem.contentUrl?.includes('clip-')) ||
                 (prevItem.contentUrl?.includes('%2Fclip-'))
      }] : [],
      isService: isEvent,
      quantity: isEvent ? (prevItem.capacity || prevItem.slots || 1) : 1,
      slots: prevItem.capacity || prevItem.slots,
      isLiked: prevItem.engagement?.likes?.includes(user?.uid) || false,
      likeCount: prevItem.engagement?.likeCount || 0,
      shopName: prevItem.shopName,
      shopProfile: prevItem.shopProfile,
      shopUsername: prevItem.shopUsername
    };
  }
  
  setZoomedItem(itemToSet);
  setShowZoomedOrderForm(false);
  setShowZoomGooglePrompt(false);
  setCurrentImageIndex(0);
  setOrderQuantity(1);
  setInfoPanelOpen(false);
  setJobInfoPanelOpen(false);
  setClusterItems([itemToSet]);
  setCurrentClusterIndex(0);

  if (prevItem.shopId && prevItem.id) {
    queueViewIncrement(prevItem.shopId, prevItem.id, prevItem.isService);
  }
}, [zoomedItem, getAllItemsFromCurrentTab, user?.uid]);

const handleNextClusterItem = useCallback(() => {
  if (clusterItems.length <= 1) return;
  const carousel = document.querySelector('.image-carousel');
  if (carousel) {
    carousel.style.transition = 'transform 0.3s ease';
    setTimeout(() => { if (carousel) carousel.style.transition = ''; }, 300);
  }
  const nextIndex = (currentClusterIndex + 1) % clusterItems.length;
  setCurrentClusterIndex(nextIndex);
  setZoomedItem(clusterItems[nextIndex]);
  setOrderQuantity(1);
  setCurrentImageIndex(0);
  const newItem = clusterItems[nextIndex];
  if (newItem.shopId && newItem.id) {
    queueViewIncrement(newItem.shopId, newItem.id, newItem.isService);
  }
}, [clusterItems, currentClusterIndex]);

const handlePrevClusterItem = useCallback(() => {
  if (clusterItems.length <= 1) return;
  const carousel = document.querySelector('.image-carousel');
  if (carousel) {
    carousel.style.transition = 'transform 0.3s ease';
    setTimeout(() => { if (carousel) carousel.style.transition = ''; }, 300);
  }
  const prevIndex = currentClusterIndex === 0 ? clusterItems.length - 1 : currentClusterIndex - 1;
  setCurrentClusterIndex(prevIndex);
  setZoomedItem(clusterItems[prevIndex]);
  setOrderQuantity(1);
  setCurrentImageIndex(0);
  const newItem = clusterItems[prevIndex];
  if (newItem.shopId && newItem.id) {
    queueViewIncrement(newItem.shopId, newItem.id, newItem.isService);
  }
}, [clusterItems, currentClusterIndex]);

// Keyboard navigation for desktop
useEffect(() => {
  if (!zoomedItem || window.innerWidth <= 768) return;
  
  const handleKeyDown = (e) => {
    // Prevent default behavior for arrow keys
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
      e.preventDefault();
    }
    
    switch (e.key) {
      case 'ArrowUp':
        clusterItems.length > 1 ? handlePrevClusterItem() : handlePrevItem();
        break;
      case 'ArrowDown':
        clusterItems.length > 1 ? handleNextClusterItem() : handleNextItem();
        break;
      case 'ArrowLeft':
        handlePrevImage();
        break;
      case 'ArrowRight':
        handleNextImage();
        break;
      case 'Escape':
        handleCloseZoom();
        break;
      default:
        break;
    }
  };

  window.addEventListener('keydown', handleKeyDown);

  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [zoomedItem, handlePrevItem, handleNextItem, handlePrevImage, handleNextImage, clusterItems, handleNextClusterItem, handlePrevClusterItem]);







// Replace the existing zoom overlay useEffect with this enhanced version
useEffect(() => {
  if (!zoomedItem) return;
  
  let touchStartY = 0;
  let touchStartX = 0;
  let touchEndY = 0;
  let touchEndX = 0;
  let swipeDirection = null;
  let isVerticalSwipe = false;
  let isHorizontalSwipe = false;
  
  const container = document.querySelector('.zoom-container');
  if (!container) return;
  
  const handleTouchStart = (e) => {
    // Pause swipe navigation while options/info panels are open or order form is visible
    if (infoPanelOpen || restaurantPanelOpen || showZoomedOrderForm) return;
    // Route map handles touch — never intercept swipe for ride cards
    if (zoomedItem?.jobType === 'rides') return;
    // Don't handle if touching controls
    if (e.target.closest('button') ||
        e.target.closest('.info-panel') ||
        e.target.closest('.overlay-quantity-control') ||
        e.target.closest('.overlay-order-button') ||
        e.target.closest('.overlay-store-info') ||
        e.target.closest('.item-name-overlay') ||
        e.target.closest('.carousel-dots') ||
        e.target.closest('.carousel-button')) {
      return;
    }

    const touch = e.changedTouches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    swipeDirection = null;
    isVerticalSwipe = false;
    isHorizontalSwipe = false;
  };
  
  const handleTouchMove = (e) => {
    if (!touchStartX || !touchStartY) return;
    
    const touch = e.changedTouches[0];
    touchEndX = touch.clientX;
    touchEndY = touch.clientY;
    
    const verticalDiff = Math.abs(touchEndY - touchStartY);
    const horizontalDiff = Math.abs(touchEndX - touchStartX);
    
    // Determine swipe direction if not already set
    if (!swipeDirection && (verticalDiff > 10 || horizontalDiff > 10)) {
      if (verticalDiff > horizontalDiff * 1.5) {
        swipeDirection = 'vertical';
        isVerticalSwipe = true;
      } else if (horizontalDiff > verticalDiff * 1.5) {
        swipeDirection = 'horizontal';
        isHorizontalSwipe = true;
      }
    }
    
    // Show visual feedback for vertical swipes (not for ride cards — map handles touch)
    if (isVerticalSwipe && verticalDiff > 30 && zoomedItem?.jobType !== 'rides') {
      const direction = touchEndY < touchStartY ? 'down' : 'up';
      const indicators = container.querySelectorAll('.swipe-indicator');
      indicators.forEach(indicator => {
        if (indicator.classList.contains(direction === 'down' ? 'bottom' : 'top')) {
          indicator.style.opacity = '1';
        }
      });
    }
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchStartY) return;

    const verticalDistance = touchStartY - touchEndY;
    const horizontalDistance = touchStartX - touchEndX;
    const minSwipeDistance = 50;

    // Reset visual feedback
    const indicators = container.querySelectorAll('.swipe-indicator');
    indicators.forEach(indicator => {
      indicator.style.opacity = '';
    });

    // Ride cards show a map — skip vertical swipe nav so map pan/zoom isn't intercepted
    if (isVerticalSwipe && Math.abs(verticalDistance) > minSwipeDistance && zoomedItem?.jobType !== 'rides') {
      if (verticalDistance > 0) {
        // Swiped up - next item (stay within chest if in cluster mode)
        clusterItems.length > 1 ? handleNextClusterItem() : handleNextItem();
      } else {
        // Swiped down - previous item
        clusterItems.length > 1 ? handlePrevClusterItem() : handlePrevItem();
      }
    }
    // Handle horizontal swipe (images)
    else if (isHorizontalSwipe && Math.abs(horizontalDistance) > minSwipeDistance) {
      if (horizontalDistance > 0) {
        // Swiped left - next image
        handleNextImage();
      } else {
        // Swiped right - previous image
        handlePrevImage();
      }
    }
    
    // Reset
    touchStartX = 0;
    touchStartY = 0;
    touchEndX = 0;
    touchEndY = 0;
    swipeDirection = null;
    isVerticalSwipe = false;
    isHorizontalSwipe = false;
  };
  
  container.addEventListener('touchstart', handleTouchStart, { passive: true });
  container.addEventListener('touchmove', handleTouchMove, { passive: true });
  container.addEventListener('touchend', handleTouchEnd, { passive: true });
  
  return () => {
    container.removeEventListener('touchstart', handleTouchStart);
    container.removeEventListener('touchmove', handleTouchMove);
    container.removeEventListener('touchend', handleTouchEnd);
  };
}, [zoomedItem, handleNextItem, handlePrevItem, handleNextImage, handlePrevImage, infoPanelOpen, restaurantPanelOpen, showZoomedOrderForm, clusterItems, handleNextClusterItem, handlePrevClusterItem]);

// Lightweight vertical shandleNextItem wipe handler specifically for quick up/down navigation
useEffect(() => {
  if (!zoomedItem) return;
  // only enable this quick vertical-swipe navigation while on the media tab
  if (activeTab !== 'media') return;
  // Ride cards display a map — skip vertical swipe so the map can pan/zoom freely
  if (zoomedItem.jobType === 'rides') return;

  const container = document.querySelector('.zoom-container');
  if (!container) return;

  let startY = null;
  let lastTrigger = 0;

  const onTouchStart = (e) => {
    // Pause swipe navigation while options/info panels are open or order form is visible
    if (infoPanelOpen || restaurantPanelOpen || showZoomedOrderForm) { startY = null; return; }
    // ignore touches that start on controls/overlays
    if (e.target.closest('button') ||
        e.target.closest('.info-panel') ||
        e.target.closest('.overlay-quantity-control') ||
        e.target.closest('.overlay-order-button') ||
        e.target.closest('.overlay-store-info') ||
        e.target.closest('.item-name-overlay') ||
        e.target.closest('.carousel-dots') ||
        e.target.closest('.carousel-button')) {
      startY = null;
      return;
    }

    if (e.touches && e.touches[0]) startY = e.touches[0].clientY;
  };

  const onTouchEnd = (e) => {
    if (startY === null) return;
    const endY = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientY : null;
    if (endY === null) return;

    const delta = startY - endY;
    const threshold = 60;
    const now = Date.now();
    if (now - lastTrigger < 400) { startY = null; return; }

    if (Math.abs(delta) > threshold) {
      if (delta > 0) {
        clusterItems.length > 1 ? handleNextClusterItem() : handleNextItem();
      } else {
        clusterItems.length > 1 ? handlePrevClusterItem() : handlePrevItem();
      }
      lastTrigger = now;
    }

    startY = null;
  };

  container.addEventListener('touchstart', onTouchStart, { passive: true });
  container.addEventListener('touchend', onTouchEnd, { passive: true });

  return () => {
    container.removeEventListener('touchstart', onTouchStart);
    container.removeEventListener('touchend', onTouchEnd);
  };
}, [zoomedItem, activeTab, handleNextItem, handlePrevItem, infoPanelOpen, restaurantPanelOpen, showZoomedOrderForm, clusterItems, handleNextClusterItem, handlePrevClusterItem]);

// Add this useEffect near your other useEffects:
useEffect(() => {
  const handleClickOutside = (event) => {
    if (themeDropdownOpen && !event.target.closest('.theme-dropdown-container')) {
      setThemeDropdownOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [themeDropdownOpen]);

useEffect(() => {
  const handleClickOutsideFollowingPrompt = (event) => {
    if (showFollowingLoginPrompt && !event.target.closest('.following-login-prompt-container')) {
      setShowFollowingLoginPrompt(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutsideFollowingPrompt);
  return () => document.removeEventListener('mousedown', handleClickOutsideFollowingPrompt);
}, [showFollowingLoginPrompt]);

// Auto-show sign-in prompt when ?signin=true is in the URL (e.g. from invitation emails)
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('signin') === 'true') {
    const shopName = params.get('shop') || '';
    setInviteShopName(shopName);
    setShowSignInPrompt(true);
    window.history.replaceState({}, '', window.location.pathname);
  }
}, []);

const handlePWAInstall = async () => {
  const ua = navigator.userAgent;
  const isInstagram = /Instagram/.test(ua);
  const isIOSDevice = (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isInstagram) {
    setShowInstagramGuide(true);
    return;
  }

  if (isIOSDevice) {
    setShowIOSGuide(true);
    return;
  }

  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  if (outcome === 'accepted') {
    setShowPWAInstall(false);
  }
  setDeferredPrompt(null);
};

// Fetch shop items when zoomed item is a restaurant
useEffect(() => {
  if (!zoomedItem) {
    setZoomedShopItems([]);
    return;
  }
  const shopId = zoomedItem.shopId;
  if (!shopId) return;
  getDoc(doc(db, 'shops', shopId)).then(snap => {
    if (snap.exists()) {
      const data = snap.data();
      const others = (data.items || []).filter(i =>
        i.id !== zoomedItem.id && !i.hidden && i.visible !== false && !i.deleted && parseInt(i.quantity || 0) > 0
      );
      setZoomedShopItems(others.slice(0, 5));
    }
  }).catch(() => {});
}, [zoomedItem?.id]);

// Update the handleCloseZoom function to reset info panel
const handleCloseZoom = () => {
  let returnUrl = null;
  setIsZoomOpen(false);
  setInfoPanelOpen(false);
  setRestaurantPanelOpen(false);
  setJobInfoPanelOpen(false);
  setShowSharePanel(false);
  setSelectedOptions({});
  setSelectedSides(new Set());
  setSideItemOptions({});
  setSpecialInstructions('');
  setShowZoomGooglePrompt(false);

  const preventReturn = sessionStorage.getItem('preventReturnToPublic');
  
  if (!preventReturn && zoomedItem?.returnUrl) {
    returnUrl = zoomedItem.returnUrl;
  }
  
  sessionStorage.removeItem('preventReturnToPublic');
  
  setZoomedItem(null);
  setShowZoomedOrderForm(false);
  setCurrentImageIndex(0);
  setClusterItems([]);
  setCurrentClusterIndex(0);
  setSelectedAttributes({});
  setAttributesPanelOpen(false);

  const scrollY = window.lastScrollPosition || 0;
  
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  
  if (returnUrl && !preventReturn) {
    console.log('🔙 Returning to public page:', returnUrl);
    window.location.href = returnUrl;
    return;
  }
  
  window.scrollTo({
    top: scrollY,
    left: 0,
    behavior: 'instant'
  });
  
  delete window.lastScrollPosition;
  
  if (!returnUrl || preventReturn) {
    navigate('/', { replace: true });
  }
  
  if (clusterItems.length > 1) {
    setMapOpen(true);
  }
};


// Store card — matches FeaturedItem layout exactly (TopBar + Image + ItemInfo)
const StoreCard = ({ shop, theme, onClick, isIPLocation, onToggleLocation, onShopLike }) => {
  const navigate  = useNavigate();
  const accent   = theme?.colors?.accent  || '#800000';
  const surface  = theme?.colors?.surface || 'rgba(0,0,0,0.4)';
  const text     = theme?.colors?.text    || '#fff';
  const bg       = theme?.colors?.background || '#0f0f1a';
  const radius   = theme?.styles?.borderRadius || '12px';
  const headFont = theme?.fonts?.heading  || 'inherit';
  const bodyFont = theme?.fonts?.body     || 'inherit';

  const cardRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = cardRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting && entry.intersectionRatio >= 0.95),
      { threshold: 0.95 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const initial = (shop.shopName || 'S')[0].toUpperCase();
  const pfpSrc  = shop.shopProfilePicture
    ? (typeof shop.shopProfilePicture === 'string'
        ? shop.shopProfilePicture
        : shop.shopProfilePicture?.preview || shop.shopProfilePicture?.url)
    : null;

  const isFollowing    = followedShops.has(shop.shopId);
  const isFollowLoading = followLoading.has(shop.shopId);

  // Nearest item distance
  const nearest = shop.items
    .filter(i => i.distanceInMiles && parseFloat(i.distanceInMiles) < Infinity)
    .sort((a, b) => parseFloat(a.distanceInMiles) - parseFloat(b.distanceInMiles))[0];
  const distLabel = nearest?.formattedDistance;

  // Lowest price
  const prices  = shop.items.map(i => parseFloat(i.price)).filter(p => p > 0);
  const minPrice = prices.length ? Math.min(...prices) : null;

  const countLabel = shop.isService
    ? `${shop.items.length} service${shop.items.length !== 1 ? 's' : ''}`
    : `${shop.items.length} item${shop.items.length !== 1 ? 's' : ''}`;

  const storeDescText = shop.shopDescription || shop.shopStoreType || '';

  return (
    <div ref={cardRef} style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
    <div
      onClick={onClick}
      style={{
        background: surface,
        borderRadius: radius,
        overflow: 'hidden',
        border: `1px solid ${accent}30`,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.borderColor = accent; e.currentTarget.style.boxShadow = `0 5px 15px ${accent}40`; }}
      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.borderColor = `${accent}30`; e.currentTarget.style.boxShadow = ''; }}
    >
      {/* TOP BAR — pfp only (matches FeaturedItem new compact style) */}
      <div style={{
        padding: '0.3rem 0.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '0.4rem',
        minHeight: '30px',
        flexShrink: 0,
      }}>
        {/* Left: pfp */}
        <div
          onClick={e => { e.stopPropagation(); if (shop.shopId) navigate(`/shop/${shop.shopId}/view`); }}
          title={shop.shopName}
          style={{
            width: '22px', height: '22px', borderRadius: '50%', flexShrink: 0,
            border: `1px solid ${accent}40`, overflow: 'hidden',
            background: `${accent}22`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          {pfpSrc
            ? <img src={pfpSrc} alt={shop.shopName} loading="lazy" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} onError={e => { e.target.style.display = 'none'; }} />
            : <span style={{ fontSize: '9px', fontWeight: 'bold', color: accent }}>{initial}</span>
          }
        </div>
        {/* Center: shop name */}
        <span
          onClick={e => { e.stopPropagation(); if (shop.shopId) navigate(`/shop/${shop.shopId}/view`); }}
          style={{
            flex: 1, minWidth: 0,
            fontSize: 'clamp(0.5rem, 1.8vw, 0.68rem)',
            fontWeight: 600,
            color: accent,
            overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
            cursor: 'pointer',
            textDecoration: 'underline', textUnderlineOffset: '2px',
          }}
        >
          {shop.shopName || 'Shop'}
        </span>
        {/* Right: follow button */}
        <button
          onClick={e => { e.stopPropagation(); if (isAuthenticated) handleFollowToggle(shop.shopId, e); }}
          disabled={isFollowLoading}
          style={{
            background: isFollowing ? 'rgba(76,175,80,0.12)' : `${accent}18`,
            border: `1px solid ${isFollowing ? 'rgba(76,175,80,0.5)' : `${accent}55`}`,
            borderRadius: '50%',
            color: isFollowing ? '#4caf50' : accent,
            width: '20px', height: '20px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: isFollowLoading ? 'not-allowed' : 'pointer',
            flexShrink: 0, padding: 0,
          }}
        >
          {isFollowing
            ? <Check size={9} strokeWidth={3} />
            : <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          }
        </button>
      </div>

      {/* IMAGE — store pfp, square aspect ratio like FeaturedItem ImageSection */}
      <div style={{ position: 'relative', aspectRatio: '1 / 1', background: bg, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <style>{`@keyframes storeCardZoom { 0% { transform: scale(1); } 50% { transform: scale(1.27); } 100% { transform: scale(1); } }`}</style>
        {pfpSrc
          ? <img src={pfpSrc} alt={shop.shopName} loading="lazy" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', animation: isVisible ? 'storeCardZoom 14s ease-in-out infinite' : 'none', transformOrigin: 'center center' }} />
          : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3rem', fontWeight: '800', color: `${accent}70`, background: `${accent}12`, animation: isVisible ? 'storeCardZoom 14s ease-in-out infinite' : 'none', transformOrigin: 'center center' }}>{initial}</div>
        }
      </div>

      {/* BOTTOM INFO — compact single row: count | distance | like */}
      <div style={{
        padding: '0.4rem 0.5rem',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '0.25rem',
        background: surface,
        borderTop: `1px solid ${accent}15`,
      }}>
        {/* Count */}
        <span style={{ fontSize: '0.7rem', fontWeight: '700', color: accent, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1 }}>
          {countLabel}
        </span>

        {/* Distance */}
        {distLabel && (
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.15rem', fontSize: '0.62rem', fontWeight: '600', color: accent, flexShrink: 0, whiteSpace: 'nowrap' }}>
            <MapPin size={8} /> {distLabel}
          </span>
        )}

        {/* Like */}
        <button
          onClick={e => { e.stopPropagation(); onShopLike && onShopLike(shop); }}
          style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: '0.15rem',
            color: shop.isShopLiked ? accent : `${text}50`,
            padding: '0.15rem', flexShrink: 0,
          }}
        >
          <svg width="11" height="11" viewBox="0 0 24 24" fill={shop.isShopLiked ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
          {(shop.shopLikeCount > 0) && (
            <span style={{ fontSize: '0.6rem', fontWeight: '700' }}>
              {shop.shopLikeCount >= 1000 ? `${(shop.shopLikeCount / 1000).toFixed(1)}k` : shop.shopLikeCount}
            </span>
          )}
        </button>
      </div>
    </div>
    </div>
  );
};

const handleItemClick = (itemOrItems) => {
  if (isZoomOpen) return;
  if (isProcessingClick) return;
  
  setIsProcessingClick(true);
  setTimeout(() => setIsProcessingClick(false), 500);
  
  setIsZoomOpen(true);
  
  // ✅ NEW: Check if it's a community post or event
  const isPost = itemOrItems.contentUrl || itemOrItems.type === 'image' || itemOrItems.type === 'video';
  const isEvent = itemOrItems.eventDate || itemOrItems.isEvent;
  
  setShowZoomGooglePrompt(false);

  if (Array.isArray(itemOrItems)) {
    // Cluster from map
    setClusterItems(itemOrItems);
    setCurrentClusterIndex(0);
    setZoomedItem(itemOrItems[0]);
  } else if (isPost || isEvent) {
    // ✅ NEW: Handle posts/events - convert to zoomable format
    const zoomableItem = {
      ...itemOrItems,
      id: itemOrItems.id,
      shopId: itemOrItems.shopId,
      name: itemOrItems.title || itemOrItems.name || 'Untitled',
      price: itemOrItems.price || '0',
      description: itemOrItems.caption || itemOrItems.description || '',
      images: itemOrItems.contentUrl ? [{ 
        url: itemOrItems.contentUrl, 
        isVideo: itemOrItems.type === 'video' || 
                 (itemOrItems.contentUrl?.includes('clip-')) ||      // ADD
                 (itemOrItems.contentUrl?.includes('%2Fclip-'))      // ADD
      }] : [],
      isService: isEvent,
      quantity: isEvent ? (itemOrItems.capacity || itemOrItems.slots || 1) : 1,
      slots: itemOrItems.capacity || itemOrItems.slots,
      isLiked: itemOrItems.engagement?.likes?.includes(user?.uid) || false,
      likeCount: itemOrItems.engagement?.likeCount || 0,
      shopName: itemOrItems.shopName,
      shopProfile: itemOrItems.shopProfile,
      shopUsername: itemOrItems.shopUsername
    };
    
    setClusterItems([zoomableItem]);
    setCurrentClusterIndex(0);
    setZoomedItem(zoomableItem);
  } else {
    // Regular item
    setClusterItems([itemOrItems]);
    setCurrentClusterIndex(0);
    setZoomedItem(itemOrItems);
    // Only reveal on the explicit "Order" button click (see OverlayOrderButton) —
    // not just because the zoomed item happens to be a service card.
    setShowZoomedOrderForm(false);
  }
  
  // Track view
  if (itemOrItems.shopId && itemOrItems.id) {
    queueViewIncrement(itemOrItems.shopId, itemOrItems.id, itemOrItems.isService);
  }
  
  // Lock scroll
  const scrollY = window.pageYOffset || document.documentElement.scrollTop;
  window.lastScrollPosition = scrollY;
  
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
};



const getRandomAmharicFont = () => {
  const fonts = ['amharic-font-1', 'amharic-font-2', 'amharic-font-3', 'amharic-font-4', 'amharic-font-5'];
  const randomIndex = Math.floor(Math.random() * fonts.length);
  return fonts[randomIndex];
};

// Add this function near the top with other utility functions
const isEthiopiaOrEritrea = (location) => {
  if (!location) return false;
  
  // Check if we have country information
  if (location.country) {
    return location.country.toLowerCase() === 'ethiopia' || 
           location.country.toLowerCase() === 'eritrea';
  }
  
  // Check if we have region information that might indicate Ethiopia/Eritrea
  if (location.region) {
    const regionLower = location.region.toLowerCase();
    return regionLower.includes('ethiopia') || 
           regionLower.includes('eritrea') ||
           regionLower.includes('addis ababa') ||
           regionLower.includes('asmara');
  }
  
  // Check if we have city information that might indicate Ethiopia/Eritrea
  if (location.city) {
    const cityLower = location.city.toLowerCase();
    return cityLower.includes('addis') ||
           cityLower.includes('asmara') ||
           cityLower.includes('mekele') ||
           cityLower.includes('dire dawa') ||
           cityLower.includes('bahir dar') ||
           cityLower.includes('gondar');
  }
  
  return false;
};

useEffect(() => {
  if (!zoomedItem) return;
  
  let touchStartY = 0;
  let touchStartX = 0;
  let touchEndY = 0;
  let touchEndX = 0;
  let swipeDirection = null;
  let isVerticalSwipe = false;
  let isHorizontalSwipe = false;
  
  const container = document.querySelector('.zoom-container');
  if (!container) return;
  
  const handleTouchStart = (e) => {
    // Pause swipe navigation while options/info panels are open or order form is visible
    if (infoPanelOpen || restaurantPanelOpen || showZoomedOrderForm) return;
    // Route map handles touch — never intercept swipe for ride cards
    if (zoomedItem?.jobType === 'rides') return;
    // Don't handle if touching controls
    if (e.target.closest('button') ||
        e.target.closest('.info-panel') ||
        e.target.closest('.overlay-quantity-control') ||
        e.target.closest('.overlay-order-button') ||
        e.target.closest('.overlay-store-info') ||
        e.target.closest('.item-name-overlay') ||
        e.target.closest('.carousel-dots') ||
        e.target.closest('.carousel-button')) {
      return;
    }

    const touch = e.changedTouches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    swipeDirection = null;
    isVerticalSwipe = false;
    isHorizontalSwipe = false;
  };
  
  const handleTouchMove = (e) => {
    if (!touchStartX || !touchStartY) return;
    
    const touch = e.changedTouches[0];
    touchEndX = touch.clientX;
    touchEndY = touch.clientY;
    
    const verticalDiff = Math.abs(touchEndY - touchStartY);
    const horizontalDiff = Math.abs(touchEndX - touchStartX);
    
    // Determine swipe direction if not already set
    if (!swipeDirection && (verticalDiff > 10 || horizontalDiff > 10)) {
      if (verticalDiff > horizontalDiff * 1.5) {
        swipeDirection = 'vertical';
        isVerticalSwipe = true;
      } else if (horizontalDiff > verticalDiff * 1.5) {
        swipeDirection = 'horizontal';
        isHorizontalSwipe = true;
      }
    }
    
    // Show visual feedback for vertical swipes (not for ride cards — map handles touch)
    if (isVerticalSwipe && verticalDiff > 30 && zoomedItem?.jobType !== 'rides') {
      const direction = touchEndY < touchStartY ? 'down' : 'up';
      const indicators = container.querySelectorAll('.swipe-indicator');
      indicators.forEach(indicator => {
        if (indicator.classList.contains(direction === 'down' ? 'bottom' : 'top')) {
          indicator.style.opacity = '1';
        }
      });
    }
  };

  const handleTouchEnd = () => {
    if (!touchStartX || !touchStartY) return;

    const verticalDistance = touchStartY - touchEndY;
    const horizontalDistance = touchStartX - touchEndX;
    const minSwipeDistance = 50; // Reduced for better responsiveness

    // Reset visual feedback
    const indicators = container.querySelectorAll('.swipe-indicator');
    indicators.forEach(indicator => {
      indicator.style.opacity = '';
    });

    // Handle vertical swipe (items) — ride cards show a map, skip so map can pan/zoom freely
    if (isVerticalSwipe && Math.abs(verticalDistance) > minSwipeDistance && zoomedItem?.jobType !== 'rides') {
      if (verticalDistance > 0) {
        // Swiped up - next item
        handleNextItem();
      } else {
        // Swiped down - previous item
        handlePrevItem();
      }
    }
    // Handle horizontal swipe (images)
    else if (isHorizontalSwipe && Math.abs(horizontalDistance) > minSwipeDistance) {
      if (horizontalDistance > 0) {
        // Swiped left - next image
        handleNextImage();
      } else {
        // Swiped right - previous image
        handlePrevImage();
      }
    }
    
    // Reset
    touchStartX = 0;
    touchStartY = 0;
    touchEndX = 0;
    touchEndY = 0;
    swipeDirection = null;
    isVerticalSwipe = false;
    isHorizontalSwipe = false;
  };
  
  container.addEventListener('touchstart', handleTouchStart, { passive: true });
  container.addEventListener('touchmove', handleTouchMove, { passive: true });
  container.addEventListener('touchend', handleTouchEnd, { passive: true });
  
  return () => {
    container.removeEventListener('touchstart', handleTouchStart);
    container.removeEventListener('touchmove', handleTouchMove);
    container.removeEventListener('touchend', handleTouchEnd);
  };
}, [zoomedItem, handleNextItem, handlePrevItem, handleNextImage, handlePrevImage, infoPanelOpen, restaurantPanelOpen, clusterItems, handleNextClusterItem, handlePrevClusterItem]);

useEffect(() => {
  if (!zoomedItem || clusterItems.length <= 1) return;
  
  let touchStartY = 0;
  let touchEndY = 0;

  const handleTouchStart = (e) => {
    touchStartY = e.changedTouches[0].screenY;
  };

  const handleTouchEnd = (e) => {
    touchEndY = e.changedTouches[0].screenY;
    handleSwipe();
  };

  const handleSwipe = () => {
    const swipeThreshold = 50;

    if (touchEndY < touchStartY - swipeThreshold) {
      // Swiped up → next item
      handleNextClusterItem();
    }

    if (touchEndY > touchStartY + swipeThreshold) {
      // Swiped down → previous item
      handlePrevClusterItem();
    }
  };
  
  const carousel = document.querySelector('.image-carousel');
  if (carousel) {
    carousel.addEventListener('touchstart', handleTouchStart);
    carousel.addEventListener('touchend', handleTouchEnd);
    
    return () => {
      carousel.removeEventListener('touchstart', handleTouchStart);
      carousel.removeEventListener('touchend', handleTouchEnd);
    };
  }
}, [zoomedItem, clusterItems, handleNextClusterItem, handlePrevClusterItem]);

useEffect(() => {
  const handlePopState = (e) => {
    if (zoomedItem) {
      e.preventDefault();
      window.history.pushState({ modal: true }, '');
      handleCloseZoom();
    } else if (mapOpen) {
      e.preventDefault();
      window.history.pushState({ modal: true }, '');
      setMapOpen(false);
    }
  };
  
  // Push state when opening map/zoom
  if (mapOpen || zoomedItem) {
    window.history.pushState({ modal: true }, '');
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }
}, [mapOpen, zoomedItem]);

// ADD: Lock scroll when map is open
useEffect(() => {
  if (mapOpen) {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    window.lastScrollPosition = scrollY;
    
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  } else {
    const scrollY = window.lastScrollPosition || 0;
    
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    
    window.scrollTo({
      top: scrollY,
      left: 0,
      behavior: 'instant'
    });
    
    delete window.lastScrollPosition;
  }
}, [mapOpen]);

// ADD: Function to handle map open
const handleOpenMap = () => {
  setMapOpen(true);
};

const openKalKodeQRCode = () => {
  setQrLinkCopied(false);
  setQrOverlay({
    image: KodeQR,
    title: 'KalKode',
    subtitle: 'Scan to discover local shops near you',
    linkUrl: 'https://kalkode.com',
    loading: false,
  });
};

const openShopQRCode = async () => {
  if (!shopData || !user?.uid) return;
  const shopId = user.uid;
  const publicUrl = getShopPublicUrl(shopId);

  setQrLinkCopied(false);
  setQrOverlay({
    image: shopData.qrCodeUrl || null,
    title: shopData.name || 'My Shop',
    subtitle: 'Scan to visit your shop on KalKode',
    linkUrl: publicUrl,
    loading: !shopData.qrCodeUrl,
  });

  if (!shopData.qrCodeUrl) {
    try {
      const qrCodeUrl = await getShopQrCode(shopId);
      setQrOverlay(prev => (prev && prev.linkUrl === publicUrl) ? { ...prev, image: qrCodeUrl, loading: false } : prev);
      setShopData(prev => (prev ? { ...prev, qrCodeUrl } : prev));
    } catch (err) {
      console.error('Failed to load shop QR code:', err);
      setQrOverlay(prev => (prev && prev.linkUrl === publicUrl) ? { ...prev, loading: false, error: true } : prev);
    }
  }
};

const closeQRCode = () => setQrOverlay(null);

const handleCopyQrLink = () => {
  if (!qrOverlay?.linkUrl) return;
  navigator.clipboard.writeText(qrOverlay.linkUrl).then(() => {
    setQrLinkCopied(true);
    setTimeout(() => setQrLinkCopied(false), 2000);
  }).catch(err => console.error('Failed to copy link:', err));
};

useEffect(() => {
  // Test Firestore connection on component mount
  const testConnection = async () => {
    try {
      const testDoc = await getDocs(collection(db, 'test'));
      console.log('✅ Firestore connection successful');
    } catch (error) {
      console.error('❌ Firestore connection failed:', error);
      
      if (error.code === 'permission-denied') {
        console.log('🔒 Check Firestore security rules');
      } else if (error.message.includes('BLOCKED')) {
        console.log('🚫 Request blocked by browser extension');
      }
    }
  };

  testConnection();
}, []);

// Update your refreshTheme function to also shuffle the Amharic font
const refreshTheme = () => {
  if (isRefreshing) return;

  // Spinner feedback is urgent — show it immediately, synchronously.
  setIsRefreshing(true);
  const styles = Object.values(WELCOME_STYLES);
  const otherStyles = styles.filter(style => style.id !== currentStyle.id);

  if (otherStyles.length > 0) {
    const randomStyle = otherStyles[Math.floor(Math.random() * otherStyles.length)];

    // The actual theme swap re-renders ~170 theme-aware styled-components
    // across the whole page — on slower mobile CPUs (this is what makes
    // Chrome on Android feel like it "hangs" far more than desktop/iOS)
    // that's real work. startTransition tells React this update isn't
    // urgent, so it can keep the spinner animating and the page scrollable
    // instead of blocking the main thread in one long synchronous commit.
    startTransition(() => {
      setCurrentStyle(randomStyle);

      // Also shuffle Amharic font if we're in Amharic locale
      if (isAmharicLocale) {
        setCurrentAmharicFont(getRandomAmharicFont());
      }

      if (isPinned) {
        setIsPinned(false);
      }
    });

    if (isPinned) {
      localStorage.removeItem('pinnedStyleId');
    }
  }

  setTimeout(() => setIsRefreshing(false), 500);
};

useEffect(() => {
  console.log('📍 Location effect triggered:', effectiveLocation);
  
  const handleLocationUpdate = async () => {
    if (!effectiveLocation) {
      console.log('⏳ Waiting for location data...');
      return;
    }

    const shouldUseAmharic = isEthiopiaOrEritrea(effectiveLocation);
    setIsAmharicLocale(shouldUseAmharic);
    if (shouldUseAmharic) {
      setCurrentAmharicFont(getRandomAmharicFont());
    }
  };

  handleLocationUpdate();
}, [effectiveLocation, activeTab]);

useEffect(() => {
  if (!effectiveLocation) return;
  
  // Only reload if the actual coordinates changed significantly
  const prevLocation = prevLocationRef.current;
  const shouldReload = !prevLocation || 
    Math.abs(prevLocation.latitude - effectiveLocation.latitude) > 0.001 ||
    Math.abs(prevLocation.longitude - effectiveLocation.longitude) > 0.001;
  
  if (shouldReload) {
    prevLocationRef.current = effectiveLocation;
    console.log('📍 Significant location change detected, loading content...');
    
    if (activeTab === 'featured') {
      loadCategorizedItems();
    } else if (activeTab === 'services' || activeTab === 'gigs') {
      loadCategorizedServices();
    }
  }
}, [effectiveLocation, activeTab]);



useEffect(() => {
  const rotateBackground = () => {
    setCurrentBgImage(prevBg => {
      const currentIndex = TREASURE_BACKGROUNDS.indexOf(prevBg);
      const nextIndex = (currentIndex + 1) % TREASURE_BACKGROUNDS.length;
      return TREASURE_BACKGROUNDS[nextIndex];
    });
  };

  const interval = setInterval(rotateBackground, 8000); // Change every 8 seconds
  return () => clearInterval(interval);
}, []);


// Note: reloading items on location/tab change is already handled by the
// "significant location change" effect above (guarded against GPS jitter)
// and the tab-switch effect further below (guarded against redundant
// refetches via hasData checks) — an unguarded duplicate used to live here
// and was a big part of why GPS live-tracking caused a reload every second.

const getStoredItemData = () => {
  // Try sessionStorage first
  try {
    const sessionData = sessionStorage.getItem('zoomItemData');
    if (sessionData) {
      const parsed = JSON.parse(sessionData);
      sessionStorage.removeItem('zoomItemData');
      return parsed;
    }
  } catch (error) {
    console.error('Error reading sessionStorage:', error);
  }

  // Try localStorage as fallback
  try {
    const localData = localStorage.getItem('zoomItemData');
    if (localData) {
      const parsed = JSON.parse(localData);
      localStorage.removeItem('zoomItemData');
      return parsed;
    }
  } catch (error) {
    console.error('Error reading localStorage:', error);
  }

  return null;
};

useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const shouldOpenZoom = urlParams.get('openZoom');
  const encodedData = urlParams.get('data');
  
  console.log('🔍 Checking for external zoom navigation:', {
    shouldOpenZoom,
    hasEncodedData: !!encodedData,
    encodedDataLength: encodedData?.length
  });
  
  if (shouldOpenZoom === 'true' && encodedData) {
    try {
      // Use base64 decoding
      const decodedData = atob(encodedData);
      const itemData = JSON.parse(decodedData);
      
      console.log('✅ Found item data from URL:', itemData);
      console.log('🖼️ Image URLs:', itemData.images);
      
      setZoomedItem(itemData);
      setOrderQuantity(1);
      setCurrentImageIndex(0);
      
      // Lock scroll
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      window.lastScrollPosition = scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      
      // Clean up URL but keep the data for handleCloseZoom
      navigate(`/?openZoom=true&data=${encodedData}`, { replace: true });
      
    } catch (error) {
      console.error('❌ Error parsing URL data:', error);
      
      // Fallback: try URI decoding if base64 fails
      try {
        const fallbackData = decodeURIComponent(encodedData);
        const itemData = JSON.parse(fallbackData);
        console.log('✅ Fallback parsing successful:', itemData);
        setZoomedItem(itemData);
        setOrderQuantity(1);
        setCurrentImageIndex(0);
        
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        window.lastScrollPosition = scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        
        navigate(`/?openZoom=true&data=${encodedData}`, { replace: true });
      } catch (fallbackError) {
        console.error('❌ Fallback parsing also failed:', fallbackError);
      }
    }
  }
}, [navigate]);

// ADD: Handle guest chat access
const handleGuestAccessChat = (chat) => {
  navigate(`/messages?chat=${chat.id}&guest=true`);
};


const handleLikeClick = async (item, userIsAuthenticated) => {
  // Always apply local optimistic update (both guests and logged-in users see the toggle)
  const localUpdate = (items) => items.map(i =>
    i.id === item.id && i.shopId === item.shopId
      ? {
          ...i,
          isLiked: !i.isLiked,
          likeCount: i.isLiked ? Math.max(0, (i.likeCount || 0) - 1) : (i.likeCount || 0) + 1
        }
      : i
  );

  if (item.isService) {
    setFeaturedServices(prev => localUpdate(prev));
    setServiceCategories(prev => {
      const updated = { ...prev };
      Object.keys(updated).forEach(cat => { updated[cat] = localUpdate(updated[cat]); });
      return updated;
    });
  } else {
    setFeaturedItems(prev => localUpdate(prev));
    setCategories(prev => {
      const updated = { ...prev };
      Object.keys(updated).forEach(cat => { updated[cat] = localUpdate(updated[cat]); });
      return updated;
    });
  }

  // Only persist to Firebase for logged-in users
  if (!userIsAuthenticated || !user?.uid) return;

  try {
    await toggleItemLike(item.shopId, item.id, user.uid, item.isService);
  } catch (error) {
    console.error('Error saving like:', error);
    // Revert on failure
    if (item.isService) {
      setFeaturedServices(prev => localUpdate(prev));
      setServiceCategories(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(cat => { updated[cat] = localUpdate(updated[cat]); });
        return updated;
      });
    } else {
      setFeaturedItems(prev => localUpdate(prev));
      setCategories(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(cat => { updated[cat] = localUpdate(updated[cat]); });
        return updated;
      });
    }
  }
};

const handleShopLikeClick = async (shop) => {
  const updater = (shops) => shops.map(s =>
    s.shopId === shop.shopId
      ? { ...s, isShopLiked: !s.isShopLiked, shopLikeCount: s.isShopLiked ? Math.max(0, (s.shopLikeCount || 0) - 1) : (s.shopLikeCount || 0) + 1 }
      : s
  );
  if (shop.isService) setFeedServiceShops(prev => updater(prev));
  else setFeedShops(prev => updater(prev));

  if (!isAuthenticated || !user?.uid) return;
  try {
    await toggleShopLike(shop.shopId, user.uid);
  } catch (error) {
    console.error('Error saving shop like:', error);
    if (shop.isService) setFeedServiceShops(prev => updater(prev));
    else setFeedShops(prev => updater(prev));
  }
};



useEffect(() => {
  if (!zoomedItem || window.innerWidth > 768) return; // Mobile only
  
  const container = document.querySelector('.zoom-container');
  if (!container) return;
  
  let lastTap = 0;
  let tapTimeout = null;
  
  const handleDoubleTap = (e) => {
    // Don't handle if touching controls
    if (e.target.closest('button') || 
        e.target.closest('.info-panel') ||
        e.target.closest('.overlay-quantity-control') ||
        e.target.closest('.overlay-order-button') ||
        e.target.closest('.overlay-store-info') ||
        e.target.closest('.carousel-dots') ||
        e.target.closest('.carousel-button')) {
      return;
    }
    
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTap;
    
    if (tapLength < 300 && tapLength > 0) {
      // Double tap detected!
      e.preventDefault();
      
      // Show heart animation at tap location
      const rect = container.getBoundingClientRect();
      const x = e.changedTouches[0].clientX - rect.left;
      const y = e.changedTouches[0].clientY - rect.top;
      
      showLikeAnimation(x, y);
      
      // Trigger like
      handleLikeClick(zoomedItem);
      
      // Reset
      lastTap = 0;
    } else {
      lastTap = currentTime;
    }
  };
  
  const showLikeAnimation = (x, y) => {
    const heart = document.createElement('div');
    heart.innerHTML = '❤️';
    heart.style.position = 'absolute';
    heart.style.left = `${x}px`;
    heart.style.top = `${y}px`;
    heart.style.fontSize = '3rem';
    heart.style.transform = 'translate(-50%, -50%) scale(0)';
    heart.style.transition = 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)';
    heart.style.pointerEvents = 'none';
    heart.style.zIndex = '1000';
    heart.style.filter = 'drop-shadow(0 4px 12px rgba(255, 0, 0, 0.5))';
    
    container.appendChild(heart);
    
    // Trigger animation
    requestAnimationFrame(() => {
      heart.style.transform = 'translate(-50%, -150%) scale(1.2)';
      heart.style.opacity = '0';
    });
    
    // Remove after animation
    setTimeout(() => {
      if (heart.parentNode) {
        heart.remove();
      }
    }, 600);
  };
  
  container.addEventListener('touchend', handleDoubleTap);
  
  return () => {
    container.removeEventListener('touchend', handleDoubleTap);
    if (tapTimeout) clearTimeout(tapTimeout);
  };
}, [zoomedItem, handleLikeClick]);

// In loadCategorizedItems function - Remove distance filtering
const loadCategorizedItems = async () => {
  if (isLoadingContent || isZoomOpen) {
    console.log('⏸️ Skipping reload - already loading or zoom open');
    return;
  }
  console.log('🔄 loadCategorizedItems called - sorting by closest first');
  setIsLoadingContent(true);

  try {
    // Only show the skeleton on the very first (empty-state) load. A later
    // call here is a silent refresh (e.g. GPS resolving after the faster
    // IP-based location already populated the feed) — flipping loading back
    // to true would yank already-visible content behind the skeleton again,
    // showing as a jarring flash/gap mid-page instead of updating quietly.
    const hasExistingItems = Object.values(categories).some(items => items.length > 0);
    if (!hasExistingItems) setLoading(true);
    setError(null);

    // Reuse the cached full-collection fetch when we already have one — it's
    // not location- or following-filter-dependent, so a Public/Following
    // toggle (or a silent location refresh) never needs to re-scan the
    // entire shops collection, just re-filter what's already in memory.
    let allItems = allFetchedItemsRef.current;
    const itemsStale = Date.now() - allFetchedItemsTimeRef.current > FEED_CACHE_TTL_MS;
    if (!allItems || itemsStale) {
      allItems = await getFeaturedItems(200);
      allFetchedItemsRef.current = allItems;
      allFetchedItemsTimeRef.current = Date.now();
    }

    // ✅ FILTER by following if followingFilter is 'following'
    let filteredItems = allItems.filter(item => {
      const isActive = !item.shopStatus ||
                       (item.shopStatus !== 'paused' && item.shopStatus !== 'deleted');

      const isVisible = !item.hidden && !item.deleted && item.visible !== false;
      
      const hasValidImages = item.images && 
                            Array.isArray(item.images) && 
                            item.images.length > 0 && 
                            item.images.filter(img => {
                              if (!img) return false;
                              if (typeof img === 'string') return img.trim() !== '';
                              if (typeof img === 'object') return img.url && img.url.trim() !== '';
                              return false;
                            }).length > 0;
      
      const hasValidPrice = item.price && !isNaN(parseFloat(item.price)) && parseFloat(item.price) > 0;
      // quantity == null means untracked/unlimited stock (show it); quantity
      // present and 0 means out of stock (hide it) — `!item.quantity` used to
      // treat those the same since 0 is falsy, letting 0-quantity items through.
      const hasStock = !item.deleted && (item.quantity == null || parseInt(item.quantity) > 0);
      // Exclude CSV-imported copies from the discovery feed — same "isNative"
      // check the old getFeaturedItems used to apply server-side.
      const isNative = !item.importedFrom;

      // ✅ NEW: Filter by following
      const matchesFollowFilter = followingFilter === 'public' ||
                                  (followingFilter === 'following' && followedShops.has(item.shopId));

      return isActive && isVisible && hasValidImages && hasValidPrice && hasStock && isNative && matchesFollowFilter;
    });

    console.log(`✅ Filtered items: ${filteredItems.length}/${allItems.length} (${followingFilter})`);

    // ✅ CHANGED: Calculate distances but DON'T filter by distance
    let itemsWithDistance = filteredItems;
    if (effectiveLocation) {
      itemsWithDistance = filteredItems.map(item => {
        let itemCoords = item.coordinates;

        // If shop has master addresses, pick the closest one to the user
        if (item.shopMasterAddresses?.length > 0) {
          let closestDist = Infinity;
          let closestCoords = null;
          item.shopMasterAddresses.forEach(addr => {
            if (addr.coordinates?.lat && addr.coordinates?.lng) {
              try {
                const d = getDistance(
                  { latitude: effectiveLocation.latitude, longitude: effectiveLocation.longitude },
                  { latitude: addr.coordinates.lat, longitude: addr.coordinates.lng }
                );
                if (d < closestDist) { closestDist = d; closestCoords = addr.coordinates; }
              } catch {}
            }
          });
          if (closestCoords) itemCoords = closestCoords;
        }

        if (!itemCoords && item.address) {
          const coordsMatch = item.address.match(/^(-?\d+\.?\d*),\s*(-?\d+\.?\d*)$/);
          if (coordsMatch) {
            itemCoords = {
              lat: parseFloat(coordsMatch[1]),
              lng: parseFloat(coordsMatch[2])
            };
          }
        }

        if (itemCoords?.lat && itemCoords?.lng) {
          try {
            const distanceInMeters = getDistance(
              { latitude: effectiveLocation.latitude, longitude: effectiveLocation.longitude },
              { latitude: itemCoords.lat, longitude: itemCoords.lng }
            );
            const distanceInMiles = (distanceInMeters / 1609.34).toFixed(1);

            let itemCity = null;
            if (item.location && typeof item.location === 'string') {
              const cityMatch = item.location.split(',')[0].trim();
              itemCity = cityMatch || null;
            } else if (item.city) {
              itemCity = item.city;
            }

            return {
              ...item,
              coordinates: itemCoords,
              distance: distanceInMeters,
              distanceInMiles,
              formattedDistance: `${distanceInMiles} mi`,
              itemCity
            };
          } catch (e) {
            console.warn('Error calculating distance for item:', e);
            return { ...item, distance: Infinity };
          }
        }
        return { ...item, distance: Infinity };
      });

      // ✅ CHANGED: Sort by proximity but keep ALL items
      itemsWithDistance.sort((a, b) => {
        const distA = a.distance !== undefined ? a.distance : Infinity;
        const distB = b.distance !== undefined ? b.distance : Infinity;
        
        if (distA === Infinity && distB === Infinity) return 0;
        if (distA === Infinity) return 1;
        if (distB === Infinity) return -1;
        
        return distA - distB;
      });
      
      console.log(`📊 Sorted ${itemsWithDistance.length} items by proximity (ALL items shown)`);

      // Reverse-geocode any item that has coordinates but no city stored —
      // nearby items need a city too now that cards show it instead of
      // distance. Promise cache in reverseGeocode() means identical
      // coordinates (e.g. every item from the same shop address) hit
      // Nominatim only once, not once per item.
      itemsWithDistance = await Promise.all(
        itemsWithDistance.map(async (item) => {
          if (
            !item.city &&
            item.coordinates?.lat != null &&
            item.coordinates?.lng != null
          ) {
            const geo = await reverseGeocode(item.coordinates.lat, item.coordinates.lng);
            if (geo?.city) {
              return { ...item, city: geo.city, state: geo.state || null, country: geo.country || null };
            }
          }
          return item;
        })
      );
    }

    // Get engagement data
    const userId = user?.uid;
    itemsWithDistance = await getMultiShopItemsEngagement(itemsWithDistance, userId);

    // Yield to the browser so the shimmer animation keeps painting before
    // the heavy synchronous categorisation/sorting work blocks the main thread.
    await new Promise(r => setTimeout(r, 0));

    // Only use items explicitly featured by their shop, max 7 per shop
    const featuredShopCount = {};
    const onlyFeatured = itemsWithDistance.filter(item => {
      if (!item.isFeatured) return false;
      const count = featuredShopCount[item.shopId] || 0;
      if (count >= 7) return false;
      featuredShopCount[item.shopId] = count + 1;
      return true;
    });

    const featuredItemsList = onlyFeatured;

    // Reverse map: unique item sub-category → store type label (ambiguous ones excluded)
    const subCatToStoreLabel = (() => {
      const counts = {};
      const map = {};
      STORE_TYPES.filter(t => t.id !== 'other' && t.id !== 'services').forEach(t => {
        t.categories.filter(c => c !== 'Other').forEach(c => {
          counts[c] = (counts[c] || 0) + 1;
          map[c] = t.label;
        });
      });
      Object.keys(map).forEach(c => { if (counts[c] > 1) delete map[c]; });
      return map;
    })();

    // Collect custom (seller-defined) category names not covered by any STORE_TYPE
    const customCategoryKeys = new Set();
    itemsWithDistance.forEach(item => {
      if (item.isDigital) return;
      if (STORE_TYPES.find(t => t.id === item.shopStoreType && t.id !== 'other')) return;
      if (item.categoryType && STORE_TYPES.find(t => t.id === item.categoryType && t.id !== 'other')) return;
      if (!subCatToStoreLabel[item.category] && item.category && item.category !== 'Other') {
        customCategoryKeys.add(item.category);
      }
    });

    const categorizedItems = Object.fromEntries([
      ...STORE_TYPES.map(t => [t.label, []]),
      ['Digital Products', []],
      ...[...customCategoryKeys].map(c => [c, []]),
    ]);

    itemsWithDistance.forEach(item => {
      if (item.isDigital) {
        categorizedItems['Digital Products'].push(item);
        return;
      }
      const storeType = STORE_TYPES.find(t => t.id === item.shopStoreType && t.id !== 'other');
      if (storeType) {
        categorizedItems[storeType.label].push(item);
        return;
      }
      const catType = item.categoryType && STORE_TYPES.find(t => t.id === item.categoryType && t.id !== 'other');
      if (catType) {
        categorizedItems[catType.label].push(item);
        return;
      }
      const inferred = subCatToStoreLabel[item.category];
      const customKey = !inferred && item.category && item.category !== 'Other' ? item.category : null;
      categorizedItems[inferred || customKey || '📦 Others'].push(item);
    });

    // 20 slots per category: spread across top 4 nearest shops, backfill from others
    const TOTAL_SLOTS = 20;
    const MAX_SHOPS = 4;
    Object.keys(categorizedItems).forEach(cat => {
      const byShop = {};
      categorizedItems[cat].forEach(item => {
        if (!byShop[item.shopId]) byShop[item.shopId] = [];
        byShop[item.shopId].push(item);
      });
      // Sort all shops by nearest item distance ascending
      const shopEntries = Object.entries(byShop).sort(([, aItems], [, bItems]) => {
        const aDist = Math.min(...aItems.map(i => i.distance ?? Infinity));
        const bDist = Math.min(...bItems.map(i => i.distance ?? Infinity));
        return aDist - bDist;
      });
      const topShops = shopEntries.slice(0, MAX_SHOPS);
      const slotsPerShop = Math.ceil(TOTAL_SLOTS / Math.max(topShops.length, 1));

      // First pass: take up to slotsPerShop from each top shop, featured first
      const result = [];
      const includedKeys = new Set();
      topShops.forEach(([, shopItems]) => {
        const sorted = [
          ...shopItems.filter(i => i.isFeatured),
          ...shopItems.filter(i => !i.isFeatured),
        ];
        sorted.slice(0, slotsPerShop).forEach(item => {
          const key = item.shopId + item.id;
          if (!includedKeys.has(key)) { result.push(item); includedKeys.add(key); }
        });
      });

      // Backfill: if under 20, pull from remaining shops (in distance order)
      if (result.length < TOTAL_SLOTS) {
        shopEntries.forEach(([, shopItems]) => {
          if (result.length >= TOTAL_SLOTS) return;
          const sorted = [
            ...shopItems.filter(i => i.isFeatured),
            ...shopItems.filter(i => !i.isFeatured),
          ];
          sorted.forEach(item => {
            if (result.length >= TOTAL_SLOTS) return;
            const key = item.shopId + item.id;
            if (!includedKeys.has(key)) { result.push(item); includedKeys.add(key); }
          });
        });
      }

      // Shuffle items within the same ~0.1 mi distance bucket so variety changes each load
      const buckets = {};
      result.forEach(item => {
        const b = Math.round((item.distance ?? 0) / 160);
        if (!buckets[b]) buckets[b] = [];
        buckets[b].push(item);
      });
      const shuffledResult = [];
      Object.keys(buckets).sort((a, b) => Number(a) - Number(b)).forEach(b => {
        const bucket = buckets[b];
        for (let i = bucket.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [bucket[i], bucket[j]] = [bucket[j], bucket[i]];
        }
        shuffledResult.push(...bucket);
      });
      categorizedItems[cat] = shuffledResult;
    });

    // Shuffle non-empty categories so the top category varies on each load; keep Others last
    const nonEmptyEntries = Object.entries(categorizedItems).filter(([k, v]) => v.length > 0 && !/others/i.test(k));
    const othersEntries = Object.entries(categorizedItems).filter(([k, v]) => v.length > 0 && /others/i.test(k));
    const emptyEntries = Object.entries(categorizedItems).filter(([, v]) => v.length === 0);
    for (let i = nonEmptyEntries.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [nonEmptyEntries[i], nonEmptyEntries[j]] = [nonEmptyEntries[j], nonEmptyEntries[i]];
    }
    // Ensure the topmost (2x) slot goes to a category with > 4 items
    const firstQualifiedIdx = nonEmptyEntries.findIndex(([, v]) => v.length > 4);
    if (firstQualifiedIdx > 0) {
      const [qualified] = nonEmptyEntries.splice(firstQualifiedIdx, 1);
      nonEmptyEntries.unshift(qualified);
    }
    setCategories(Object.fromEntries([...nonEmptyEntries, ...othersEntries, ...emptyEntries]));
    setFeaturedItems(featuredItemsList);

    // Group all items by shop for store-card feed
    const shopsMap = new Map();
    itemsWithDistance.forEach(item => {
      if (!shopsMap.has(item.shopId)) {
        shopsMap.set(item.shopId, {
          shopId: item.shopId,
          shopName: item.shopName || 'Shop',
          shopProfilePicture: item.shopProfilePicture || null,
          shopDescription: item.shopDescription || '',
          shopTheme: item.shopTheme || {},
          shopStoreType: item.shopStoreType || null,
          shopFollowersCount: item.shopFollowersCount || 0,
          shopLikeCount: 0,
          isShopLiked: false,
          items: []
        });
      }
      shopsMap.get(item.shopId).items.push(item);
    });
    const productShopsArr = Array.from(shopsMap.values());
    setFeedShops(productShopsArr);
    // Load shop-level engagement (likes) in background
    const productShopIds = productShopsArr.map(s => s.shopId);
    if (productShopIds.length > 0) {
      getShopsEngagement(productShopIds, user?.uid).then(engMap => {
        setFeedShops(prev => prev.map(s => ({
          ...s,
          shopLikeCount: engMap[s.shopId]?.likeCount ?? s.shopLikeCount,
          isShopLiked: engMap[s.shopId]?.isLiked ?? s.isShopLiked,
        })));
      }).catch(err => console.error('❌ Error loading shop engagement:', err));
    }

    setTotalItems(filteredItems.length);
    loadedFilterRef.current = followingFilter;

  } catch (error) {
    console.error('❌ Error loading categorized items:', error);
    setError('Failed to load items. Please try again later.');
  } finally {
    setIsLoadingContent(false);
    setLoading(false);
  }
};

// Add this function to your WelcomePage component:

const handleEventBooking = (event) => {
  if (!isAuthenticated) {
    // Store event for guest booking
    setPendingGuestOrder({
      type: 'event',
      event: event
    });
    setShowGuestInfoModal(true);
    return;
  }

  console.log('Booking event:', event);
  
  // Open chat with event organizer (similar to service order)
  setSelectedChatItem({
    ...event,
    isService: true, // Treat events like services for chat
    isEvent: true
  });
  
  // Set chat to open (this will trigger the OrderChat component)
  // You might need to handle this differently based on your chat implementation
  setChatOpen(true);
  
  // Alternatively, you could navigate to messages page
  // navigate(`/messages?shop=${event.shopId}&event=${event.id}`);
};

// UPDATE loadCategorizedServices - ADD image filtering
// In loadCategorizedServices function - Remove distance filtering
const loadCategorizedServices = async () => {
  try {
    setError(null);

    // Reuse the cached full-collection fetch when we already have one — see
    // the matching comment in loadCategorizedItems.
    let allServices = allFetchedServicesRef.current;
    const servicesStale = Date.now() - allFetchedServicesTimeRef.current > FEED_CACHE_TTL_MS;
    if (!allServices || servicesStale) {
      allServices = await getFeaturedServices(200);
      allFetchedServicesRef.current = allServices;
      allFetchedServicesTimeRef.current = Date.now();
    }

    const filteredServices = allServices.filter(service => {
      const isActive = !service.shopStatus ||
                       (service.shopStatus !== 'paused' && service.shopStatus !== 'deleted');
      
      const isVisible = !service.hidden && !service.deleted;
      
      const hasValidImages = service.images && 
                            Array.isArray(service.images) && 
                            service.images.length > 0 && 
                            service.images.filter(img => {
                              if (!img) return false;
                              if (typeof img === 'string') return img.trim() !== '';
                              if (typeof img === 'object') return img.url && img.url.trim() !== '';
                              return false;
                            }).length > 0;
      
      const hasContent = hasValidImages;
      const hasValidSlots = service.slots && !isNaN(parseInt(service.slots)) && parseInt(service.slots) > 0;
      const isNotDeleted = !service.deleted;

      const matchesFollowFilter = followingFilter === 'public' ||
                                  (followingFilter === 'following' && followedShops.has(service.shopId));

      return isActive && isVisible && hasContent && hasValidSlots && isNotDeleted && matchesFollowFilter;
    });

    console.log(`✅ Filtered services: ${filteredServices.length}/${allServices.length} (${followingFilter})`);

    // ✅ CHANGED: Calculate distances but DON'T filter by distance
    let servicesWithDistance = filteredServices;
    if (effectiveLocation) {
      servicesWithDistance = filteredServices.map(service => {
        let serviceCoords = service.coordinates;

        // If shop has master addresses, pick the closest one to the user
        if (service.shopMasterAddresses?.length > 0) {
          let closestDist = Infinity;
          let closestCoords = null;
          service.shopMasterAddresses.forEach(addr => {
            if (addr.coordinates?.lat && addr.coordinates?.lng) {
              try {
                const d = getDistance(
                  { latitude: effectiveLocation.latitude, longitude: effectiveLocation.longitude },
                  { latitude: addr.coordinates.lat, longitude: addr.coordinates.lng }
                );
                if (d < closestDist) { closestDist = d; closestCoords = addr.coordinates; }
              } catch {}
            }
          });
          if (closestCoords) serviceCoords = closestCoords;
        }

        if (!serviceCoords && service.address) {
          const coordsMatch = service.address.match(/^(-?\d+\.?\d*),\s*(-?\d+\.?\d*)$/);
          if (coordsMatch) {
            serviceCoords = {
              lat: parseFloat(coordsMatch[1]),
              lng: parseFloat(coordsMatch[2])
            };
          }
        }

        if (serviceCoords?.lat && serviceCoords?.lng) {
          try {
            const distanceInMeters = getDistance(
              { latitude: effectiveLocation.latitude, longitude: effectiveLocation.longitude },
              { latitude: serviceCoords.lat, longitude: serviceCoords.lng }
            );
            const distanceInMiles = (distanceInMeters / 1609.34).toFixed(1);

            let itemCity = null;
            if (service.location && typeof service.location === 'string') {
              const cityMatch = service.location.split(',')[0].trim();
              itemCity = cityMatch || null;
            } else if (service.city) {
              itemCity = service.city;
            }

            return {
              ...service,
              coordinates: serviceCoords,
              distance: distanceInMeters,
              distanceInMiles,
              formattedDistance: `${distanceInMiles} mi`,
              itemCity
            };
          } catch (e) {
            console.warn('Error calculating distance for service:', e);
            return { ...service, distance: Infinity };
          }
        }
        return { ...service, distance: Infinity };
      });

      // ✅ CHANGED: Sort by proximity but keep ALL services
      servicesWithDistance.sort((a, b) => {
        const distA = a.distance !== undefined ? a.distance : Infinity;
        const distB = b.distance !== undefined ? b.distance : Infinity;
        
        if (distA === Infinity && distB === Infinity) return 0;
        if (distA === Infinity) return 1;
        if (distB === Infinity) return -1;
        
        return distA - distB;
      });
      
      console.log(`📊 Sorted ${servicesWithDistance.length} services by proximity (ALL services shown)`);

      // Reverse-geocode any service that has coordinates but no city stored —
      // mirrors the same step in loadCategorizedItems so service cards can
      // show a city too. Promise cache in reverseGeocode() means identical
      // coordinates hit Nominatim only once.
      servicesWithDistance = await Promise.all(
        servicesWithDistance.map(async (service) => {
          if (
            !service.city &&
            service.coordinates?.lat != null &&
            service.coordinates?.lng != null
          ) {
            const geo = await reverseGeocode(service.coordinates.lat, service.coordinates.lng);
            if (geo?.city) {
              return { ...service, city: geo.city, state: geo.state || null, country: geo.country || null };
            }
          }
          return service;
        })
      );
    }

    // Get engagement data
    const userId = user?.uid;
    servicesWithDistance = await getMultiShopItemsEngagement(servicesWithDistance, userId);

    // ✅ CHANGED: Featured services - first 10 services (no distance filter)
    const featuredServicesList = servicesWithDistance.slice(0, 30);

    // Group by seller-defined category first; fall back to jobType system label
    const categorizedServices = {};
    servicesWithDistance.forEach(service => {
      const customCat = service.category && service.category !== 'Other' ? service.category : null;
      const jobLabel = service.jobType && JOB_TYPE_LABEL[service.jobType] && service.jobType !== 'other'
        ? JOB_TYPE_LABEL[service.jobType]
        : null;
      const label = customCat || jobLabel || '💼 Other';
      if (!categorizedServices[label]) categorizedServices[label] = [];
      categorizedServices[label].push(service);
    });

    // Cap each category at 100 (30 shown by default, rest revealed via
    // "Show more" — mirrors ProductsTab's loadCategorizedItems/20-cap
    // pattern), shuffle within same ~0.1 mi distance bucket so variety
    // changes each load while staying ordered by proximity overall, then
    // drop empty ones.
    Object.keys(categorizedServices).forEach(cat => {
      const capped = categorizedServices[cat].slice(0, 100);

      const buckets = {};
      capped.forEach(service => {
        const b = Math.round((service.distance ?? 0) / 160);
        if (!buckets[b]) buckets[b] = [];
        buckets[b].push(service);
      });
      const shuffled = [];
      Object.keys(buckets).sort((a, b) => Number(a) - Number(b)).forEach(b => {
        const bucket = buckets[b];
        for (let i = bucket.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [bucket[i], bucket[j]] = [bucket[j], bucket[i]];
        }
        shuffled.push(...bucket);
      });

      categorizedServices[cat] = shuffled;
      if (categorizedServices[cat].length === 0) delete categorizedServices[cat];
    });

    // Shuffle non-empty categories so the top category varies on each load
    // (mirrors ProductsTab's loadCategorizedItems); keep Others last.
    const svcCategoryEntries = Object.entries(categorizedServices);
    const svcOtherEntries = svcCategoryEntries.filter(([k]) => /\bothers?\b/i.test(k));
    const svcRestEntries = svcCategoryEntries.filter(([k]) => !/\bothers?\b/i.test(k));
    for (let i = svcRestEntries.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [svcRestEntries[i], svcRestEntries[j]] = [svcRestEntries[j], svcRestEntries[i]];
    }
    // Ensure the topmost slot goes to a category with > 4 items
    const svcFirstQualifiedIdx = svcRestEntries.findIndex(([, v]) => v.length > 4);
    if (svcFirstQualifiedIdx > 0) {
      const [qualified] = svcRestEntries.splice(svcFirstQualifiedIdx, 1);
      svcRestEntries.unshift(qualified);
    }
    setServiceCategories(Object.fromEntries([...svcRestEntries, ...svcOtherEntries]));
    setFeaturedServices(featuredServicesList);

    // Group all services by shop for service store-card feed
    const serviceShopsMap = new Map();
    servicesWithDistance.forEach(service => {
      if (!serviceShopsMap.has(service.shopId)) {
        serviceShopsMap.set(service.shopId, {
          shopId: service.shopId,
          shopName: service.shopName || 'Shop',
          shopProfilePicture: service.shopProfilePicture || null,
          shopDescription: service.shopDescription || '',
          shopTheme: service.shopTheme || {},
          shopStoreType: service.shopStoreType || null,
          shopFollowersCount: service.shopFollowersCount || 0,
          shopLikeCount: 0,
          isShopLiked: false,
          isService: true,
          items: []
        });
      }
      serviceShopsMap.get(service.shopId).items.push({ ...service, isService: true });
    });
    const serviceShopsArr = Array.from(serviceShopsMap.values());
    setFeedServiceShops(serviceShopsArr);
    const serviceShopIds = serviceShopsArr.map(s => s.shopId);
    if (serviceShopIds.length > 0) {
      getShopsEngagement(serviceShopIds, user?.uid).then(engMap => {
        setFeedServiceShops(prev => prev.map(s => ({
          ...s,
          shopLikeCount: engMap[s.shopId]?.likeCount ?? s.shopLikeCount,
          isShopLiked: engMap[s.shopId]?.isLiked ?? s.isShopLiked,
        })));
      }).catch(err => console.error('❌ Error loading service shop engagement:', err));
    }

  } catch (error) {
    console.error('Error loading categorized services:', error);
    setError('Failed to load services. Please try again later.');
  }
};

const saveLocationToStorage = (location) => {
  if (location?.isFallback) {
    // Don't persist the last-resort hardcoded fallback for a full LOCATION_EXPIRY —
    // a transient provider hiccup would otherwise strand the user on the wrong
    // default (e.g. Houston) for 24h instead of retrying real geolocation on
    // their next visit.
    console.log('⚠️ Not caching fallback location — will retry real geolocation next time');
    return;
  }
  try {
    localStorage.setItem(LOCATION_STORAGE_KEY, JSON.stringify(location));
    localStorage.setItem(LOCATION_TIMESTAMP_KEY, Date.now().toString());
    console.log('💾 Saved location to localStorage:', location);
  } catch (error) {
    console.error('Failed to save location:', error);
  }
};

const getLocationFromStorage = () => {
  try {
    const stored = localStorage.getItem(LOCATION_STORAGE_KEY);
    const timestamp = localStorage.getItem(LOCATION_TIMESTAMP_KEY);
    
    if (!stored || !timestamp) {
      console.log('📍 No stored location found');
      return null;
    }
    
    const age = Date.now() - parseInt(timestamp);
    if (age > LOCATION_EXPIRY) {
      console.log('⏰ Stored location expired');
      localStorage.removeItem(LOCATION_STORAGE_KEY);
      localStorage.removeItem(LOCATION_TIMESTAMP_KEY);
      return null;
    }
    
    const location = JSON.parse(stored);
    console.log('✅ Retrieved stored location:', location);
    return location;
  } catch (error) {
    console.error('Failed to retrieve location:', error);
    return null;
  }
};

const clearLocationFromStorage = () => {
  localStorage.removeItem(LOCATION_STORAGE_KEY);
  localStorage.removeItem(LOCATION_TIMESTAMP_KEY);
  console.log('🗑️ Cleared stored location');
};

// Ordered fallback chain — each entry's parse() returns a normalized
// { latitude, longitude, city, region, country } or null if the response
// is missing/invalid, so a provider outage or rate-limit doesn't silently
// hand back nonsense coordinates.
const IP_LOCATION_PROVIDERS = [
  {
    name: 'ipapi.co',
    url: 'https://ipapi.co/json/',
    parse: (data) => {
      if (!data || data.error || !data.latitude || !data.longitude) return null;
      return {
        latitude: data.latitude,
        longitude: data.longitude,
        city: data.city,
        region: data.region,
        country: data.country_name,
      };
    },
  },
  {
    name: 'ipwho.is',
    url: 'https://ipwho.is/',
    parse: (data) => {
      if (!data?.success || !data.latitude || !data.longitude) return null;
      return {
        latitude: data.latitude,
        longitude: data.longitude,
        city: data.city,
        region: data.region,
        country: data.country,
      };
    },
  },
  {
    name: 'geojs.io',
    url: 'https://get.geojs.io/v1/ip/geo.json',
    parse: (data) => {
      const latitude = parseFloat(data?.latitude);
      const longitude = parseFloat(data?.longitude);
      if (!data || Number.isNaN(latitude) || Number.isNaN(longitude)) return null;
      return {
        latitude,
        longitude,
        city: data.city,
        region: data.region,
        country: data.country,
      };
    },
  },
];

// Fetch with a hard timeout so one slow/hanging provider doesn't stall
// location detection — move on to the next provider instead.
const fetchIPProviderJSON = async (url, timeoutMs = 5000) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return await response.json();
  } finally {
    clearTimeout(timer);
  }
};

const getIPBasedLocation = async () => {
  for (const provider of IP_LOCATION_PROVIDERS) {
    try {
      console.log(`🌐 Fetching IP-based location from ${provider.name}...`);
      const data = await fetchIPProviderJSON(provider.url);
      const parsed = provider.parse(data);
      if (!parsed) throw new Error('Invalid or incomplete location data');

      const location = { ...parsed, isIPBased: true };
      console.log(`✅ IP location resolved via ${provider.name}:`, location);

      // ✅ Immediately show city in UI
      const displayText = `${location.city}, ${location.region || location.country}`;
      setCityRegion(displayText);
      setCityInputValue(displayText);

      return location;
    } catch (error) {
      console.warn(`⚠️ IP location provider ${provider.name} failed:`, error.message);
      // fall through to the next provider
    }
  }

  // Every provider failed (outage, rate limit, or all timed out) — last-resort
  // fallback. saveLocationToStorage() knows not to cache this so the next
  // visit retries real geolocation instead of being stuck here.
  console.error('❌ All IP location providers failed. Using fallback location: Houston, TX');
  const fallbackLocation = {
    latitude: 29.7604,
    longitude: -95.3698,
    city: 'Houston',
    region: 'Texas',
    country: 'United States',
    isIPBased: true,
    isFallback: true
  };

  setCityRegion('Houston, Texas');
  setCityInputValue('Houston, Texas');

  return fallbackLocation;
};




useEffect(() => {
  const handleClickOutside = (event) => {
    if (sortMenuOpen && !event.target.closest('.sort-container')) {
      setSortMenuOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [sortMenuOpen]);

const applySorting = (items, sortType) => {
  let sortedItems = [...items];
  
  switch (sortType) {
    case 'proximity':
      // item.distance is computed against effectiveLocation (the IP/GPS
      // hybrid used everywhere else in this file) — gate on that, not the
      // separate one-shot userLocation, which can still be null even when
      // we already have a precise GPS fix (e.g. via the map's nav icon),
      // causing a pointless repeat permission prompt and a no-op sort.
      if (!effectiveLocation) {
        requestLocation();
        return sortedItems;
      }
      // Sort by distance (closest first) - no distance filter
      sortedItems.sort((a, b) => {
        const distA = a.distance || Infinity;
        const distB = b.distance || Infinity;
        return distA - distB;
      });
      break;
      
    case 'price-low':
      // REMOVED 30-mile filter - sort all items by price (low to high)
      sortedItems.sort((a, b) => {
        const priceA = parseFloat(a.price) || 0;
        const priceB = parseFloat(b.price) || 0;
        return priceA - priceB;
      });
      break;
      
    case 'price-high':
      // REMOVED 30-mile filter - sort all items by price (high to low)
      sortedItems.sort((a, b) => {
        const priceA = parseFloat(a.price) || 0;
        const priceB = parseFloat(b.price) || 0;
        return priceB - priceA;
      });
      break;
      
    case 'recent':
    default:
      // REMOVED 30-mile filter - sort all items by most recent
      sortedItems.sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
        const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
        return dateB - dateA;
      });
      break;
  }
  
  return sortedItems;
};

const getSortLabel = (sortType) => {
  switch (sortType) {
    case 'proximity': return 'Closest First';
    case 'price-low': return 'Price: Low to High';
    case 'price-high': return 'Price: High to Low';
    case 'recent':
    default: return 'Most Recent';
  }
};

const convertCoordsToCity = async (lat, lon) => {
  try {
    setIsConvertingToCity(true);
    setError(null);
    
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&zoom=10&addressdetails=1`,
      {
        headers: {
          'Accept': 'application/json',
          'User-Agent': 'KalKode Marketplace'
        }
      }
    );
    
    if (!response.ok) {
      throw new Error('Failed to fetch location data');
    }
    
    const data = await response.json();
    console.log('Nominatim response:', data);
    
    if (!data || !data.address) {
      setCityRegion('Not available');
      setCityInputValue('');
      return null;
    }
    
    const address = data.address;
    const city = address.city || address.town || address.village || address.county;
    const state = address.state;
    
    // Major cities list
    const majorCities = [
      'Houston', 'Dallas', 'Austin', 'San Antonio', 'Fort Worth',
      'Los Angeles', 'New York', 'Chicago', 'Phoenix', 'Philadelphia',
      'San Diego', 'San Jose', 'Jacksonville', 'Columbus', 'Charlotte'
    ];
    
    let locationString = '';
    
    if (city && majorCities.some(major => city.includes(major))) {
      const cityName = majorCities.find(major => city.includes(major));
      
      const cityCenterResponse = await fetch(
        `https://nominatim.openstreetmap.org/search?city=${cityName}&state=${state}&format=json&limit=1`,
        {
          headers: {
            'Accept': 'application/json',
            'User-Agent': 'KalKode Marketplace'
          }
        }
      );
      
      const cityCenterData = await cityCenterResponse.json();
      
      if (cityCenterData && cityCenterData[0]) {
        const centerLat = parseFloat(cityCenterData[0].lat);
        const centerLon = parseFloat(cityCenterData[0].lon);
        
        const direction = getDirection(lat, lon, centerLat, centerLon);
        locationString = `${direction} ${cityName}, ${getStateAbbreviation(state)}`;
      } else {
        locationString = `${cityName}, ${getStateAbbreviation(state)}`;
      }
    } else if (state) {
      const stateCenterResponse = await fetch(
        `https://nominatim.openstreetmap.org/search?state=${state}&country=USA&format=json&limit=1`,
        {
          headers: {
            'Accept': 'application/json',
            'User-Agent': 'KalKode Marketplace'
          }
        }
      );
      
      const stateCenterData = await stateCenterResponse.json();
      
      if (stateCenterData && stateCenterData[0]) {
        const centerLat = parseFloat(stateCenterData[0].lat);
        const centerLon = parseFloat(stateCenterData[0].lon);
        
        const direction = getDirection(lat, lon, centerLat, centerLon);
        locationString = city ? 
          `${city}, ${direction} ${getStateAbbreviation(state)}` :
          `${direction} ${getStateAbbreviation(state)}`;
      } else {
        locationString = city ? 
          `${city}, ${getStateAbbreviation(state)}` :
          getStateAbbreviation(state);
      }
    } else {
      locationString = city || 'Unknown Location';
    }
    
    setCityRegion(locationString);
    setCityInputValue(locationString);
    
    console.log(`Coordinates ${lat}, ${lon} → ${locationString}`);
    
    return locationString; // ✅ Return the city name
    
  } catch (error) {
    console.error('Error converting coordinates to city:', error);
    setCityRegion('Error');
    setCityInputValue('');
    setError('Failed to get location information');
    return null;
  } finally {
    setIsConvertingToCity(false);
  }
};

// Helper function to determine direction (N, S, E, W, NE, NW, SE, SW)
const getDirection = (lat1, lon1, lat2, lon2) => {
  const latDiff = lat1 - lat2;
  const lonDiff = lon1 - lon2;
  
  const absLatDiff = Math.abs(latDiff);
  const absLonDiff = Math.abs(lonDiff);
  
  // If differences are very small, consider it center
  if (absLatDiff < 0.1 && absLonDiff < 0.1) {
    return '';
  }
  
  // Determine primary direction
  let direction = '';
  
  // North/South
  if (absLatDiff > absLonDiff * 0.5) {
    direction += latDiff > 0 ? 'N' : 'S';
  }
  
  // East/West
  if (absLonDiff > absLatDiff * 0.5) {
    direction += lonDiff > 0 ? 'E' : 'W';
  }
  
  return direction || 'Central';
};

// Helper function to get state abbreviations
const getStateAbbreviation = (stateName) => {
  const stateMap = {
    'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR',
    'California': 'CA', 'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE',
    'Florida': 'FL', 'Georgia': 'GA', 'Hawaii': 'HI', 'Idaho': 'ID',
    'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS',
    'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD',
    'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS',
    'Missouri': 'MO', 'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV',
    'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM', 'New York': 'NY',
    'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK',
    'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
    'South Dakota': 'SD', 'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT',
    'Vermont': 'VT', 'Virginia': 'VA', 'Washington': 'WA', 'West Virginia': 'WV',
    'Wisconsin': 'WI', 'Wyoming': 'WY'
  };
  
  return stateMap[stateName] || stateName;
};


useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const encodedCart = params.get('cart');
  
  if (encodedCart) {
    try {
      // Decode cart data from URL
      const cartData = JSON.parse(atob(encodedCart));
      console.log('📦 Received cart from public shop via URL:', cartData);
      
      // Set cart items
      setCartItems(cartData.items);
      
      // ✅ NEW: Auto-process if user is authenticated
      if (isAuthenticated && user?.uid) {
        console.log('🚀 User is authenticated - auto-processing cart orders...');
        
        // Clean up URL immediately
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
        
        // Auto-process the cart
        handleAutoProcessCartOrders(cartData.items);
      } else {
        // Not authenticated - show cart dropdown for manual checkout
        console.log('👤 User not authenticated - showing cart for manual checkout');
        setShowCartDropdown(true);
        
        // Clean up URL
        const newUrl = window.location.pathname;
        window.history.replaceState({}, '', newUrl);
      }
      
    } catch (error) {
      console.error('Error processing transferred cart:', error);
      // Clean up URL on error
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }
}, [isAuthenticated, user]);

// Find and update this function:
const handleAutoProcessCartOrders = async (items) => {
  console.log('🚀 Auto-processing cart orders for authenticated user');
  
  try {
    // Group items by shop
    const itemsByShop = items.reduce((acc, item) => {
      if (!acc[item.shopId]) {
        acc[item.shopId] = [];
      }
      acc[item.shopId].push(item);
      return acc;
    }, {});
    
    // Process each shop's items
    const chatIds = [];
    
    for (const [shopId, shopItems] of Object.entries(itemsByShop)) {
      console.log(`📤 Processing orders for shop ${shopId}:`, shopItems);
      
      // Add items to cart one by one
      for (const item of shopItems) {
        try {
          const result = await TransactionService.addToCart(
            item.id,
            shopId,
            parseFloat(item.price),
            item.cartQuantity,
            'inperson',
            item.isService || false
          );
          
          console.log(`✅ Added to cart: ${result.transactionId}`);
          
          if (result.transactionId && !chatIds.includes(result.transactionId)) {
            chatIds.push(result.transactionId);
          }
        } catch (error) {
          console.error(`❌ Error adding ${item.name} to cart:`, error);
        }
      }
      
      // Send the cart for this shop
      if (chatIds.length > 0) {
        const latestChatId = chatIds[chatIds.length - 1];
        
        try {
          await TransactionService.sendCart(latestChatId, 'authenticated');
          console.log(`✅ Cart sent successfully for shop ${shopId}`);
        } catch (error) {
          console.error(`❌ Error sending cart for shop ${shopId}:`, error);
        }
      }
    }
    
    // Clear cart
    setCartItems([]);
    
    // Navigate to messages immediately
    if (chatIds.length > 0) {
      console.log('✅ All orders processed - navigating to messages');
      navigate(`/messages?chat=${chatIds[0]}`);
    } else {
      console.error('❌ No chat IDs generated');
      alert('Error processing orders. Please try again.');
    }
    
  } catch (error) {
    console.error('❌ Error auto-processing orders:', error);
    alert('Some orders failed to process. Please check your messages.');
    // Still navigate to messages if any succeeded
    navigate('/messages');
  }
};

// Update handleGuestInfoSubmit:
const handleGuestInfoSubmit = async (guestInfo) => {
  if (!pendingGuestOrder) return;
  
  try {
    console.log('🎭 Creating guest order/cart:', {
      guestInfo,
      pendingOrder: pendingGuestOrder
    });
    
    if (pendingGuestOrder.useCart) {
      // Create guest cart via unified API
      const response = await fetch('/api/guest-operations', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          operation: 'create_cart',
          itemId: pendingGuestOrder.itemId,
          sellerId: pendingGuestOrder.shopId,
          unitPrice: parseFloat(pendingGuestOrder.price),
          requestedQuantity: parseInt(pendingGuestOrder.quantity),
          meetupType: 'inperson',
          guestInfo: {
            guestId: guestInfo.guestId,
            firstName: guestInfo.firstName,
            lastName: guestInfo.lastName,
            phoneNumber: guestInfo.phoneNumber,
            displayName: guestInfo.displayName
          }
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create guest cart');
      }

      const result = await response.json();
      console.log('✅ Guest cart created:', result);

      // Store guest session
      localStorage.setItem('guest_session', JSON.stringify({
        guestId: guestInfo.guestId,
        displayName: guestInfo.displayName,
        phoneNumber: guestInfo.phoneNumber,
        expiresAt: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString() // 24 hours
      }));
      
      // Navigate to cart chat
      navigate(`/messages?chat=${result.chatId}&guest=true`);
      
    } else {
      // Existing service order code
      const apiEndpoint = '/api/create-guest-order';
      
      console.log(`📡 Calling ${apiEndpoint} for service order...`);
      
      // Call service order API
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          itemId: pendingGuestOrder.itemId,
          sellerId: pendingGuestOrder.shopId,
          unitPrice: parseFloat(pendingGuestOrder.price),
          requestedQuantity: parseInt(pendingGuestOrder.quantity),
          meetupType: 'inperson',
          guestInfo: {
            guestId: guestInfo.guestId,
            firstName: guestInfo.firstName,
            lastName: guestInfo.lastName,
            phoneNumber: guestInfo.phoneNumber,
            displayName: guestInfo.displayName
          },
          isService: pendingGuestOrder.isService
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Failed to create guest ${pendingGuestOrder.isService ? 'service order' : 'order'}`);
      }

      const result = await response.json();
      console.log('✅ API Response for service order:', result);

      // Store guest session
      localStorage.setItem('guest_session', JSON.stringify({
        guestId: guestInfo.guestId,
        displayName: guestInfo.displayName,
        phoneNumber: guestInfo.phoneNumber,
        expiresAt: result.expiresAt
      }));
      
      // Navigate to messages
      const chatId = result.chatId || result.transactionId;
      navigate(`/messages?chat=${chatId}&guest=true`);
    }
    
  } catch (error) {
    console.error('Error creating guest order:', error);
    alert('Error placing order: ' + error.message);
  } finally {
    setPendingGuestOrder(null);
  }
};

const upgradeToGPS = async () => {
  try {
    setIsConvertingToCity(true);
    setError(null);
    
    console.log('📍 Upgrading to GPS location...');
    
    const position = await new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation not supported'));
        return;
      }
      
      navigator.geolocation.getCurrentPosition(
        (position) => resolve(position),
        (error) => reject(error),
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
    
    const gpsLocation = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      isIPBased: false,
      timestamp: Date.now()
    };
    
    console.log('📍 Got GPS location:', gpsLocation);
    
    const cityName = await convertCoordsToCity(
      gpsLocation.latitude, 
      gpsLocation.longitude
    );
    
    gpsLocation.city = cityName;
    saveLocationToStorage(gpsLocation);
    setEffectiveLocation(gpsLocation);
    setIsIPLocation(false);
    setCityRegion(cityName);
    
    const shouldUseAmharic = isEthiopiaOrEritrea(gpsLocation);
    setIsAmharicLocale(shouldUseAmharic);
    if (shouldUseAmharic) {
      setCurrentAmharicFont(getRandomAmharicFont());
    }
    
    // Show toast notification
    setLocationToastMessage('📍 Using precise GPS location');
    setShowLocationToast(true);
    setTimeout(() => setShowLocationToast(false), 3000);
    
    console.log('🔄 Reloading items with GPS location...');
    if (activeTab === 'featured') {
      await loadCategorizedItems();
    } else if (activeTab === 'services' || activeTab === 'gigs') {
      await loadCategorizedServices();
    }

    console.log('✅ GPS upgrade complete');
    
  } catch (error) {
    console.error('Error getting GPS location:', error);
    setError('Could not get precise location. Please enable location services.');
  } finally {
    setIsConvertingToCity(false);
  }
};

const handleCommunityPostLike = async (post) => {
  if (!isAuthenticated || !user?.uid) {
    const returnUrl = encodeURIComponent(window.location.href);
    const message = encodeURIComponent('Please log in to like posts');
    window.location.href = `https://kalkode.com/auth?mode=login&from=${returnUrl}&message=${message}`;
    return;
  }

  const uid = user.uid;
  // The card list reads isLiked from engagement.likes.includes(uid), not from a
  // plain isLiked flag — toggling isLiked alone (the old code) silently had no
  // visible effect. Set both: engagement.likes (what the list checks) and
  // isLiked (what the zoomed overlay's button checks), so a like is reflected
  // wherever this post happens to be showing.
  const toggleLike = (p) => {
    if (p.id !== post.id || p.shopId !== post.shopId) return p;
    const likes = p.engagement?.likes || [];
    const wasLiked = likes.includes(uid);
    const newLikes = wasLiked ? likes.filter(id => id !== uid) : [...likes, uid];
    return {
      ...p,
      isLiked: !wasLiked,
      engagement: { ...p.engagement, likes: newLikes, likeCount: newLikes.length },
    };
  };
  const sameItem = (p) => p && p.id === post.id && p.shopId === post.shopId;

  // Optimistic update — a post can be showing in any of these lists (media
  // tab's followed/nearby feed, the user's own posts, or the events tab), plus
  // the zoomed-in overlay if that's the post currently open.
  setFriendsPosts(prev => prev.map(toggleLike));
  setUserOwnPosts(prev => prev.map(toggleLike));
  setEventPosts(prev => prev.map(toggleLike));
  setZoomedItem(prev => (sameItem(prev) ? toggleLike(prev) : prev));

  try {
    await toggleCommunityPostLike(post.shopId, post.id, uid);
  } catch (error) {
    console.error('Error liking post:', error);
    // Revert on error
    setFriendsPosts(prev => prev.map(p => (sameItem(p) ? post : p)));
    setUserOwnPosts(prev => prev.map(p => (sameItem(p) ? post : p)));
    setEventPosts(prev => prev.map(p => (sameItem(p) ? post : p)));
    setZoomedItem(prev => (sameItem(prev) ? post : prev));
  }
};

const revertToIP = async () => {
  try {
    setIsConvertingToCity(true);
    setError(null);
    
    console.log('🔄 Reverting to IP-based location...');
    
    // Clear stored location
    clearLocationFromStorage();
    
    // Fetch fresh IP location
    const ipLocation = await getIPBasedLocation();
    
    if (ipLocation) {
      console.log('✅ Reverted to IP location:', ipLocation);
      
      // Update state
      setEffectiveLocation(ipLocation);
      setIsIPLocation(true);
      
      // Check Amharic locale
      const shouldUseAmharic = isEthiopiaOrEritrea(ipLocation);
      setIsAmharicLocale(shouldUseAmharic);
      if (shouldUseAmharic) {
        setCurrentAmharicFont(getRandomAmharicFont());
      }
      
      // Save to localStorage
      saveLocationToStorage(ipLocation);
      
      // Show toast notification
      setLocationToastMessage('🌐 Using IP location');
      setShowLocationToast(true);
      setTimeout(() => setShowLocationToast(false), 3000);
      
      // Manually reload items with IP location
      console.log('🔄 Reloading items with IP location...');
      if (activeTab === 'featured') {
        await loadCategorizedItems();
      } else if (activeTab === 'services' || activeTab === 'gigs') {
        await loadCategorizedServices();
      }
      
      console.log('✅ IP revert complete');
    } else {
      console.error('❌ Failed to get IP location');
      setError('Could not get IP location');
    }
    
  } catch (error) {
    console.error('Error reverting to IP:', error);
    setError('Failed to get location');
  } finally {
    setIsConvertingToCity(false);
  }
};


  // Handle opening shop
  const handleOpenShop = () => {
    navigate('/shop/create/template');
  };

  {!isIPLocation && cityRegion && (
  <button
    className="location-icon-btn"
    onClick={() => {
      clearLocationFromStorage();
      setCityRegion('');
      setCityInputValue('');
      setEffectiveLocation(null);
      setIsIPLocation(false);
      // This will trigger the useEffect to fetch IP location again
    }}
    title="Clear saved location"
    style={{ opacity: 0.6 }}
  >
    <X size={16} />
  </button>
)}

  // Toggle pin style
  const togglePinStyle = () => {
    if (isPinned) {
      localStorage.removeItem('pinnedStyleId');
      setIsPinned(false);
      
      const styles = Object.values(WELCOME_STYLES).filter(
        style => style.id !== currentStyle.id
      );

      if (styles.length > 0) {
        const randomStyle = styles[Math.floor(Math.random() * styles.length)];
        startTransition(() => setCurrentStyle(randomStyle));
      }
    } else {
      localStorage.setItem('pinnedStyleId', currentStyle.id.toString());
      setIsPinned(true);
    }
  };

  useEffect(() => {
  const initLocation = async () => {
    console.log('🔍 Initializing location (one-time)...');
    
    // Check localStorage first (instant)
    const cached = localStorage.getItem(LOCATION_STORAGE_KEY);
    const timestamp = localStorage.getItem(LOCATION_TIMESTAMP_KEY);
    
    if (cached && timestamp) {
      const age = Date.now() - parseInt(timestamp);
      if (age < LOCATION_EXPIRY) {
        const location = JSON.parse(cached);
        console.log('✅ Using cached location:', location);
        
        setEffectiveLocation(location);
        setIsIPLocation(location.isIPBased || false);
        
        // Set Amharic locale immediately
        const shouldUseAmharic = isEthiopiaOrEritrea(location);
        setIsAmharicLocale(shouldUseAmharic);
        if (shouldUseAmharic) {
          setCurrentAmharicFont(getRandomAmharicFont());
        }
        
        // Set display text
        if (location.city) {
          const displayText = location.isIPBased 
            ? `${location.city}, ${location.region || location.country}`
            : location.city;
          setCityRegion(displayText);
        }
        
        return; // STOP - Use cached location
      }
    }
    
    // No valid cache - fetch IP location
    console.log('🌐 Fetching IP location...');
    const ipLocation = await getIPBasedLocation();
    
    if (ipLocation) {
      setEffectiveLocation(ipLocation);
      setIsIPLocation(true);
      
      // Set Amharic locale immediately
      const shouldUseAmharic = isEthiopiaOrEritrea(ipLocation);
      setIsAmharicLocale(shouldUseAmharic);
      if (shouldUseAmharic) {
        setCurrentAmharicFont(getRandomAmharicFont());
      }
      
      // Save to localStorage
      saveLocationToStorage(ipLocation);
      
      console.log('✅ IP location set:', ipLocation);
    }
  };
  
  initLocation();
}, []);


  // Get location display text
  const getLocationDisplayText = () => {
    if (!userLocation) {
      return "Location: Not available";
    }
    return `Location: ${userLocation.latitude.toFixed(4)}, ${userLocation.longitude.toFixed(4)}`;
  };

  // Search featured items
  

  const handleRowScroll = (categoryName, rowNumber, scrollLeft) => {
    const row1Id = `${categoryName}-row1`;
    const row2Id = `${categoryName}-row2`;
    
    const row1Element = document.getElementById(row1Id);
    const row2Element = document.getElementById(row2Id);
    
    if (rowNumber === 1 && row2Element) {
      row2Element.scrollLeft = scrollLeft;
    } else if (rowNumber === 2 && row1Element) {
      row1Element.scrollLeft = scrollLeft;
    }
  };

  

  // Fetch nearby items
  const fetchNearbyItems = async () => {
    // Prefer the precise one-shot GPS fix (userLocation) when we have it,
    // but fall back to effectiveLocation (IP, or GPS obtained via the map's
    // nav icon) rather than erroring out — the two are rarely both null.
    const originLocation = userLocation || effectiveLocation;
    if (!originLocation) {
      setError('Location information is not available');
      setSearching(false);
      return;
    }

    try {
      setLoading(true);
      const shopsRef = collection(db, 'shops');
      const snapshot = await getDocs(shopsRef);

      let itemsInRadius = [];
      const currentUserId = user?.uid;
      
      snapshot.docs.forEach(doc => {
        const shopData = doc.data();
        
        if (doc.id === currentUserId) {
          return;
        }
        
        if (shopData?.items && Array.isArray(shopData.items)) {
          shopData.items
            .filter(item => !item.deleted && !item.importedFrom)
            .forEach(item => {
              // Build list of all coordinates to check (multi-location aware)
              const allCoords = [];
              if (item.locations?.length > 0) {
                item.locations.forEach(l => {
                  if (l.coordinates?.lat && l.coordinates?.lng) allCoords.push(l.coordinates);
                });
              }
              if (allCoords.length === 0) {
                let c = item.coordinates;
                if (!c && item.address) {
                  const m = item.address.match(/^(-?\d+\.?\d*),\s*(-?\d+\.?\d*)$/);
                  if (m) c = { lat: parseFloat(m[1]), lng: parseFloat(m[2]) };
                }
                if (c?.lat && c?.lng) allCoords.push(c);
              }

              if (allCoords.length > 0) {
                try {
                  // Use nearest location to the user
                  let minDist = Infinity, bestCoords = allCoords[0];
                  allCoords.forEach(coords => {
                    const d = getDistance(
                      { latitude: originLocation.latitude, longitude: originLocation.longitude },
                      { latitude: coords.lat, longitude: coords.lng }
                    );
                    if (d < minDist) { minDist = d; bestCoords = coords; }
                  });

                  const distanceInMiles = (minDist / 1609.34).toFixed(1);
                  itemsInRadius.push({
                    ...item,
                    shopId: doc.id,
                    shopName: shopData.name || 'Unknown Shop',
                    coordinates: bestCoords,
                    distance: minDist,
                    distanceInMiles,
                    formattedDistance: `${distanceInMiles} mi`,
                    theme: shopData.theme
                  });
                } catch (e) {
                  console.warn('Error calculating distance for item:', e);
                }
              }
            });
        }
      });
  
      itemsInRadius.sort((a, b) => a.distance - b.distance);
      itemsInRadius = itemsInRadius.slice(0, 30);
  
      setNearbyItems(itemsInRadius);
      setHasSearched(true);
      
      if (itemsInRadius.length === 0) {
        setError('No items found in your area');
      }
    } catch (error) {
      console.error('Error fetching nearby items:', error);
      setError('Failed to load nearby items. Please try again later.');
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  // Handle live location
  const handleLiveLocation = () => {
    setSearching(true);
    setError(null);

    if (userLocation || effectiveLocation) {
      fetchNearbyItems();
      setHasSearched(true);
    } else {
      requestLocation();
    }
  };

  // Handle address search
  const handleAddressSearch = async () => {
    if (!searchAddress.trim()) {
      setError('Please enter an address');
      return;
    }
  
    setSearching(true);
    setError(null);
    setHasSearched(true);
    
    try {
      const encodedAddress = encodeURIComponent(searchAddress);
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${encodedAddress}&format=json&limit=1`,
        {
          headers: {
            'Accept': 'application/json',
            'User-Agent': 'KalKode Marketplace'
          }
        }
      );
      
      const data = await response.json();
  
      if (data && data[0]) {
        const coordinates = {
          latitude: parseFloat(data[0].lat),
          longitude: parseFloat(data[0].lon)
        };
        
        await fetchNearbyItems(coordinates);
      } else {
        throw new Error('Location not found. Please try a different address.');
      }
  
    } catch (error) {
      console.error('Error searching address:', error);
      setError(error.message || 'Unable to search this location. Please try again.');
    } finally {
      setSearching(false);
    }
  };

const searchServices = async (searchTerm) => {
  if (!searchTerm.trim()) {
    setServiceSearchResults([]);
    setHasServiceSearchResults(false);
    return;
  }

  try {
    setIsSearching(true);
    setError(null);
  
    const shopsRef = collection(db, 'shops');
    const snapshot = await getDocs(shopsRef);

    let allMatchingServices = [];
    const currentUserId = user?.uid;
    
    snapshot.docs.forEach(doc => {
      const shopData = doc.data();
      
      if (doc.id === currentUserId) {
        return;
      }
      
      if (shopData?.services && Array.isArray(shopData.services)) {
        shopData.services
          .filter(service => !service.deleted)
          .forEach(service => {
            const serviceName = (service.name || '').toLowerCase();
            const serviceDescription = (service.description || '').toLowerCase();
            const searchLower = searchTerm.toLowerCase();
            
            if (serviceName.includes(searchLower) || serviceDescription.includes(searchLower)) {
              allMatchingServices.push({
                ...service,
                shopId: doc.id,
                shopName: shopData.name || 'Unknown Shop',
                shopTheme: shopData.theme,
                isService: true
              });
            }
          });
      }
    });
  
    if (effectiveLocation) {
      allMatchingServices = allMatchingServices.map(service => {
        const coordsList = service.locations?.length > 0
          ? service.locations.map(l => l.coordinates).filter(c => c?.lat && c?.lng)
          : (service.coordinates?.lat && service.coordinates?.lng ? [service.coordinates] : []);
        if (coordsList.length > 0) {
          try {
            let minDist = Infinity, bestCoords = coordsList[0];
            coordsList.forEach(c => {
              const d = getDistance(
                { latitude: effectiveLocation.latitude, longitude: effectiveLocation.longitude },
                { latitude: c.lat, longitude: c.lng }
              );
              if (d < minDist) { minDist = d; bestCoords = c; }
            });
            const distanceInMiles = (minDist / 1609.34).toFixed(1);
            let itemCity = service.city || null;
            if (!itemCity && service.location && typeof service.location === 'string') {
              itemCity = service.location.split(',')[0].trim() || null;
            }
            return {
              ...service,
              coordinates: bestCoords,
              distance: minDist,
              distanceInMiles,
              formattedDistance: `${distanceInMiles} mi`,
              itemCity
            };
          } catch (e) {
            console.warn('Error calculating distance for service:', e);
            return service;
          }
        }
        return service;
      });
    }
  
    setServiceSearchResults(allMatchingServices);
    setHasServiceSearchResults(true);
    
    if (allMatchingServices.length === 0) {
      setError(`No services found matching "${searchTerm}"`);
    }
  } catch (error) {
    console.error('Error searching services:', error);
    setError('Failed to search services. Please try again later.');
  } finally {
    setIsSearching(false);
  }
};

const searchProducts = async (searchTerm) => {
  if (!searchTerm.trim()) {
    setProductSearchResults([]);
    setHasProductSearchResults(false);
    return;
  }

  try {
    setIsSearching(true);
    setError(null);
  
    const shopsRef = collection(db, 'shops');
    const snapshot = await getDocs(shopsRef);

    let allMatchingItems = [];
    const currentUserId = user?.uid;
    
    snapshot.docs.forEach(doc => {
      const shopData = doc.data();
      
      if (doc.id === currentUserId) {
        return;
      }
      
      if (shopData?.items && Array.isArray(shopData.items)) {
        shopData.items
          .filter(item => !item.deleted && !item.importedFrom)
          .forEach(item => {
            const itemName = (item.name || '').toLowerCase();
            const itemDescription = (item.description || '').toLowerCase();
            const searchLower = searchTerm.toLowerCase();
            
            if (itemName.includes(searchLower) || itemDescription.includes(searchLower)) {
              allMatchingItems.push({
                ...item,
                shopId: doc.id,
                shopName: shopData.name || 'Unknown Shop',
                shopTheme: shopData.theme
              });
            }
          });
      }
    });
  
    if (effectiveLocation) {
      allMatchingItems = allMatchingItems.map(item => {
        const coordsList = item.locations?.length > 0
          ? item.locations.map(l => l.coordinates).filter(c => c?.lat && c?.lng)
          : (item.coordinates?.lat && item.coordinates?.lng ? [item.coordinates] : []);
        if (coordsList.length > 0) {
          try {
            let minDist = Infinity, bestCoords = coordsList[0];
            coordsList.forEach(c => {
              const d = getDistance(
                { latitude: effectiveLocation.latitude, longitude: effectiveLocation.longitude },
                { latitude: c.lat, longitude: c.lng }
              );
              if (d < minDist) { minDist = d; bestCoords = c; }
            });
            const distanceInMiles = (minDist / 1609.34).toFixed(1);
            let itemCity = item.city || null;
            if (!itemCity && item.location && typeof item.location === 'string') {
              itemCity = item.location.split(',')[0].trim() || null;
            }
            return {
              ...item,
              coordinates: bestCoords,
              distance: minDist,
              distanceInMiles,
              formattedDistance: `${distanceInMiles} mi`,
              itemCity
            };
          } catch (e) {
            console.warn('Error calculating distance for item:', e);
            return item;
          }
        }
        return item;
      });
    }
  
    setProductSearchResults(allMatchingItems);
    setHasProductSearchResults(true);
    
    if (allMatchingItems.length === 0) {
      setError(`No items found matching "${searchTerm}"`);
    }
  } catch (error) {
    console.error('Error searching items:', error);
    setError('Failed to search items. Please try again later.');
  } finally {
    setIsSearching(false);
  }
};

// ✅ ADD: Get active search term
const getActiveSearchTerm = () => {
  switch (activeTab) {
    case 'featured': return productSearchTerm;
    case 'services':
    case 'gigs': return serviceSearchTerm;
    case 'media': return mediaSearchTerm;
    default: return '';
  }
};

// ✅ ADD: Set active search term
const setActiveSearchTerm = (value) => {
  switch (activeTab) {
    case 'featured':
      setProductSearchTerm(value);
      break;
    case 'services':
    case 'gigs':
      setServiceSearchTerm(value);
      break;
    case 'media':
      setMediaSearchTerm(value);
      break;
  }
};

// ✅ ADD: Handle search based on active tab
const handleSearch = () => {
  switch (activeTab) {
    case 'featured':
      if (productSearchTerm.trim()) {
        searchProducts(productSearchTerm);
      }
      break;
    case 'services':
    case 'gigs':
      if (serviceSearchTerm.trim()) {
        searchServices(serviceSearchTerm);
      }
      break;
    case 'media':
      // Media search coming soon
      break;
  }
};

// ✅ ADD: Clear search based on active tab
const handleClearSearch = () => {
  switch (activeTab) {
    case 'featured':
      setProductSearchTerm('');
      setProductSearchResults([]);
      setHasProductSearchResults(false);
      break;
    case 'services':
    case 'gigs':
      setServiceSearchTerm('');
      setServiceSearchResults([]);
      setHasServiceSearchResults(false);
      break;
    case 'media':
      setMediaSearchTerm('');
      setMediaSearchResults([]);
      setHasMediaSearchResults(false);
      break;
  }
  setError(null);
};

// ✅ ADD: Check if current tab has search results
const hasActiveSearchResults = () => {
  switch (activeTab) {
    case 'featured': return hasProductSearchResults;
    case 'services':
    case 'gigs': return hasServiceSearchResults;
    case 'media': return hasMediaSearchResults;
    default: return false;
  }
};

  // Adjust quantity
  const adjustQuantity = (delta) => {
    const maxQuantity = parseInt(
      zoomedItem.isService ? 
        zoomedItem.slots : 
        zoomedItem.quantity
    ) || 1;
    
    const newQuantity = Math.max(1, Math.min(maxQuantity, orderQuantity + delta));
    setOrderQuantity(newQuantity);
  };

  // Direct order — skips cart, immediately creates transaction and goes to chat
  const [orderingItemId, setOrderingItemId] = useState(null);

  // No-login guest checkout — posts straight to the backend (no Firebase
  // auth involved at all) and shows a confirmation instead of navigating to
  // a chat, since the guest never gets chat access; the seller sees the
  // order in their own Messages.
  const [guestOrderResult, setGuestOrderResult] = useState(null); // { status: 'success'|'error', itemName, total, email, message }
  const [guestOrderSubmitting, setGuestOrderSubmitting] = useState(false);

  const handleGuestOrder = async (item, formData) => {
    if (guestOrderSubmitting) return;
    const { guestInfo, ...itemFormData } = formData || {};
    const orderPrice = itemFormData?.totalPrice != null ? itemFormData.totalPrice : item.price;
    const isService = !!(item.serviceTab || item.isService || item.jobType);

    setGuestOrderSubmitting(true);
    try {
      const response = await fetch('/api/create-guest-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          itemId: item.id,
          sellerId: item.shopId,
          unitPrice: parseFloat(orderPrice) || 0,
          requestedQuantity: 1,
          meetupType: item.isDigital ? 'digital' : 'inperson',
          isService,
          guestInfo: {
            name: guestInfo?.name || '',
            phone: guestInfo?.phone || '',
            email: guestInfo?.email || '',
            address: guestInfo?.address || '',
            notes: guestInfo?.notes || '',
          },
        }),
      });
      const result = await response.json();
      if (!response.ok || !result.success) {
        throw new Error(result.error || 'Could not place order');
      }

      setZoomedItem(null);
      setShowZoomedOrderForm(false);
      setGuestOrderResult({
        status: 'success',
        itemName: item.name,
        total: result.costs?.total,
        email: guestInfo?.email || '',
      });
    } catch (err) {
      console.error('Guest order failed:', err);
      setGuestOrderResult({ status: 'error', message: err.message || 'Could not place order' });
    } finally {
      setGuestOrderSubmitting(false);
    }
  };

  const handleDirectOrder = async (item, formData) => {
    // "Sign Up" cards redirect off-site instead of running the order flow
    if (item.ctaStyle === 'signup' && item.externalLink) {
      window.open(item.externalLink, '_blank', 'noopener,noreferrer');
      return;
    }
    // Service bookings compute a duration-aware total in OrderFormPanel (hourly × duration,
    // or a flat total when the seller set pricingType to 'total') — use it when present.
    const orderPrice = formData?.totalPrice != null ? formData.totalPrice : item.price;
    if (!isAuthenticated) {
      sessionStorage.setItem('kk_pending_order', JSON.stringify({
        itemId: item.id,
        shopId: item.shopId,
        price: orderPrice,
        isService: !!(item.serviceTab || item.isService || item.jobType),
        isDigital: !!item.isDigital,
        formData: formData || null,
        itemName: item.name || '',
        itemImage: item.images?.[0] || null,
        shopName: item.shopName || 'Shop',
      }));
      handleGoogleSignIn();
      return;
    }

    if (orderingItemId === item.id) return;
    const isService = !!(item.serviceTab || item.isService || item.jobType);
    const meetupType = item.isDigital ? 'digital' : 'inperson';
    const unitPrice = parseFloat(orderPrice) || 0;
    const customization = formData && Object.keys(formData).length > 0 ? { orderDetails: formData } : null;

    // Build a client-only skeleton chat and jump to the chat body immediately —
    // the real Firestore writes happen in the background and stream in once ready.
    const optimisticChat = buildOptimisticChat({
      item, sellerId: item.shopId, sellerName: item.shopName || 'Shop',
      unitPrice, requestedQuantity: 1, isService,
      buyerId: user.uid, buyerName: user.displayName || user.email || 'You',
      buyerProfilePic: user.photoURL || null, isGuest: !!user.isAnonymous,
      customization,
      sellerShopPic: item.shopProfile || null,
    });
    navigate(`/messages?chat=${optimisticChat.id}`, { state: { optimisticChat } });

    const goToRealChat = (realId) => navigate(`/messages?chat=${realId}`, {
      replace: true,
      state: {
        optimisticChat: {
          ...optimisticChat, id: realId, transactionId: realId, chatId: realId,
          __pendingCreation: false,
        },
      },
    });

    try {
      setOrderingItemId(item.id);
      if (zoomedItem) {
        setZoomedItem(null);
        setShowZoomedOrderForm(false);
        const scrollY = document.body.getAttribute('data-scroll-y') || '0';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.body.removeAttribute('data-scroll-y');
        window.scrollTo(0, parseInt(scrollY));
      }

      if (item.serviceTab === 'need') {
        const result = await TransactionService.claimJobTransaction(item, item.shopId, customization);
        if (result?.transactionId) goToRealChat(result.transactionId);
        return;
      }

      const existing = await TransactionService.addItemToActiveOrder(
        item.id, item.shopId, unitPrice, 1, isService, !!item.isDigital, customization
      );
      if (existing?.chatId) { goToRealChat(existing.chatId); return; }

      const result = await TransactionService.initiateQuantityTransaction(
        item.id, item.shopId, unitPrice, 1, meetupType, isService, customization
      );
      if (result?.transactionId) goToRealChat(result.transactionId);
    } catch (err) {
      console.error('Direct order failed:', err);
      alert('Could not place order: ' + (err.message || 'Unknown error'));
      navigate(-1);
    } finally {
      setOrderingItemId(null);
    }
  };

  // Guest form submit: store name/email hint + pending order, then trigger Google sign-in
  const handleGuestSignIn = (item, guestInfo, formData) => {
    const { name, email } = guestInfo || {};
    const orderPrice = formData?.totalPrice != null ? formData.totalPrice : item.price;
    sessionStorage.setItem('kk_pending_order', JSON.stringify({
      itemId: item.id,
      shopId: item.shopId,
      price: orderPrice,
      isService: !!(item.serviceTab || item.isService || item.jobType),
      isDigital: !!item.isDigital,
      formData: formData || null,
      itemName: item.name || '',
      itemImage: item.images?.[0] || null,
      shopName: item.shopName || 'Shop',
    }));
    if (name) sessionStorage.setItem('kk_guest_name', name);
    if (email) sessionStorage.setItem('kk_guest_email', email);
    handleGoogleSignIn();
  };

  // After login, auto-process any pending order that was triggered while unauthenticated
  useEffect(() => {
    if (!isAuthenticated || !user?.uid) return;
    const pending = sessionStorage.getItem('kk_pending_order');
    if (!pending) return;
    sessionStorage.removeItem('kk_pending_order');
    try {
      const { itemId, shopId, price, isService, isDigital, formData, itemName, itemImage, shopName } = JSON.parse(pending);
      const meetupType = isDigital ? 'digital' : 'inperson';
      const unitPrice = parseFloat(price) || 0;
      const customization = formData && Object.keys(formData).length > 0 ? { orderDetails: formData } : null;

      const optimisticChat = buildOptimisticChat({
        item: { id: itemId, name: itemName, images: itemImage ? [itemImage] : [] },
        sellerId: shopId, sellerName: shopName || 'Shop',
        unitPrice, requestedQuantity: 1, isService: !!isService,
        buyerId: user.uid, buyerName: user.displayName || user.email || 'You',
        buyerProfilePic: user.photoURL || null, isGuest: !!user.isAnonymous,
        customization,
      });
      navigate(`/messages?chat=${optimisticChat.id}`, { state: { optimisticChat } });

      const goToRealChat = (realId) => navigate(`/messages?chat=${realId}`, {
        replace: true,
        state: {
          optimisticChat: {
            ...optimisticChat, id: realId, transactionId: realId, chatId: realId,
            __pendingCreation: false,
          },
        },
      });

      TransactionService.addItemToActiveOrder(itemId, shopId, unitPrice, 1, !!isService, !!isDigital, customization)
        .then(existing => {
          if (existing?.chatId) { goToRealChat(existing.chatId); return; }
          return TransactionService.initiateQuantityTransaction(itemId, shopId, unitPrice, 1, meetupType, !!isService, customization);
        })
        .then(result => { if (result?.transactionId) goToRealChat(result.transactionId); })
        .catch(err => { console.error('Pending order failed:', err); navigate(-1); });
    } catch (e) { console.error('Error parsing pending order:', e); }
  }, [isAuthenticated, user?.uid]);

  // Handle order click (legacy — now delegates to handleDirectOrder)
  const handleOrderClick = (item) => {
    handleDirectOrder(item);
  };

  // Card-level order button: zoom the item first, then open the form (or sign in) in the zoomed view
  const handleCardOrderClick = (item) => {
    if (needsOrderForm(item)) {
      shouldOpenFormOnZoom.current = true;
      handleItemClick(item);
    } else {
      handleDirectOrder(item, null);
    }
  };

  // Handle close chat
  const handleCloseChat = () => {
    setChatOpen(false);
    setSelectedChatItem(null);
    
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.removeAttribute('data-scroll-y');
  };

  // Handle inquire click
  const handleInquireClick = () => {
    alert('Inquiry feature coming soon!');
  };

  // Handle logout
  const handleLogout = async () => {
  try {
    console.log('🔓 Logging out...');
    
    // Clear PWA session data if in PWA mode
    const isPWAMode = localStorage.getItem('pwa_mode') === 'true';
    if (isPWAMode) {
      localStorage.removeItem('pwa_user_id');
      localStorage.removeItem('pwa_login_timestamp');
      localStorage.removeItem('pwa_last_active');
      console.log('🔓 PWA session cleared');
    }
    
    // Clear local state immediately
    setShopData(null);
    clearFeedCache();

    // Sign out from Firebase
    await signOut(auth);
    
    console.log('✅ Logout successful');
    
    // Clear location to prevent cached data
    window.location.href = '/';
    
  } catch (error) {
    console.error('❌ Error signing out:', error);
    alert('Error logging out. Please try again.');
  }
};

  // Handle login
  const handleLogin = () => {
    localStorage.removeItem('guest_session');
    navigate('/auth', { 
      state: { 
        mode: 'login',
        from: window.location.pathname
      }
    });
  };

  // Effects
  useEffect(() => {
    const fetchShopData = async () => {
      if (user && user.uid) {
        try {
          const data = await getShopData(user.uid);
          setShopData(data);
        } catch (error) {
          console.error('Error fetching shop data:', error);
        }
      }
    };
    
    if (isAuthenticated) {
      fetchShopData();
    }
  }, [user, isAuthenticated]);

  

  // Theme (pinned or random) is now chosen synchronously in the currentStyle/isPinned
  // useState initializers above — no mount effect needed here anymore.

  useEffect(() => {
    if (activeTab === 'nearby' && userLocation) {
      fetchNearbyItems();
      setHasSearched(true);
    }
  }, [activeTab, userLocation]);

  useEffect(() => {
    if (locationPermission === 'pending') {
      requestLocation();
    }
  }, []);

  useEffect(() => {
    if (userLocation) {
      if (activeTab === 'nearby') {
        fetchNearbyItems();
        setHasSearched(true);
      }

      if (activeTab === 'featured') {
        const hasData = Object.values(categories).some(items => items.length > 0);
        const filterChanged = loadedFilterRef.current !== followingFilter;
        if (!hasData || filterChanged) {
          loadCategorizedItems();
          loadCategorizedServices();
        }
      }

      setUpdatingLocation(false);
    }
  }, [userLocation, activeTab]);

  useEffect(() => {
  const initializeContent = async () => {
    // Already hydrated everything from a previous mount this session (see
    // feedCache) — skip the reload entirely, just like navigating back to a
    // tab that's already loaded.
    if (hydratedFromCacheRef.current) {
      console.log('⚡ Feed already loaded this session — skipping reload');
      setLoading(false);
      return;
    }

    // Deliberately NOT gated on effectiveLocation: items/services render
    // fine without a distance badge for the half-second it takes IP geo (or
    // the 24h-cached value) to resolve, and the separate "significant
    // location change" effect re-sorts/re-labels them the moment it does.
    // Blocking the skeleton on that network round-trip was pure wasted wait.
    console.log('🚀 Initial content load — not waiting on location');

    try {
      setLoading(true);

      await Promise.all([
        loadCategorizedItems(),
        loadCategorizedServices(),
        loadEventsContent(),
        loadMediaContent()
      ]);

      console.log('✅ All initial content loaded (Products, Services, Events, Media)');
    } catch (error) {
      console.error('❌ Error loading initial content:', error);
      setError('Failed to load content. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  initializeContent();
  // Run once on mount only — re-running this full 4-way preload on every
  // later effectiveLocation tick was the other half of the duplicate-fetch
  // problem; the "significant location change" effect already handles
  // re-sorting items/services once a better location comes in.
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

// Fires in parallel with (and resolves well before) the full pipeline above
// — a tiny, already-indexed query with no distance/categorization/engagement
// work attached, just enough to put a handful of real cards on screen the
// instant the page mounts instead of a blank skeleton. Skipped entirely when
// a cached feed already hydrated the page with real data synchronously.
useEffect(() => {
  if (cachedFeed) return;
  (async () => {
    try {
      const isDisplayable = (entry) => {
        const hasImages = entry.images && entry.images.some(img => img && (typeof img === 'string' ? img.trim() : img.url));
        const hasValidPrice = entry.price && !isNaN(parseFloat(entry.price)) && parseFloat(entry.price) > 0;
        return hasImages && hasValidPrice && !entry.deleted && !entry.hidden && entry.visible !== false && !entry.importedFrom;
      };
      const [items, services] = await Promise.all([
        getFeaturedItems(QUICK_PREVIEW_COUNT),
        getFeaturedServices(QUICK_PREVIEW_COUNT),
      ]);
      setQuickPreviewItems((items || []).filter(isDisplayable));
      setQuickPreviewServices((services || []).filter(isDisplayable));
    } catch (e) {
      console.warn('Quick preview fetch failed (non-fatal, skeleton will show instead):', e);
    }
  })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

// Rough category label for a single preview item — same STORE_TYPES mapping
// loadCategorizedItems uses, simplified (no custom-category/"Others" sub-
// category reconciliation) since this only ever runs over the handful of
// quick-preview items, not the full feed.
const inferPreviewCategoryLabel = (entry) => {
  if (entry.isDigital) return 'Digital Products';
  const storeType = STORE_TYPES.find(t => t.id === entry.shopStoreType && t.id !== 'other');
  if (storeType) return storeType.label;
  const catType = entry.categoryType && STORE_TYPES.find(t => t.id === entry.categoryType && t.id !== 'other');
  if (catType) return catType.label;
  return entry.category && entry.category !== 'Other' ? entry.category : '📦 Others';
};

// Category headers to show immediately while the real, fully-categorized
// feed is still loading — grouped from the same small quick-preview batch
// used for the instant item-card preview, so the headers that appear match
// what's actually about to load in. Rendered collapsed; see ProductsTab's
// unified category loop for how these hand off to the real `categories`
// once loading finishes.
const previewCategories = useMemo(() => {
  const map = {};
  quickPreviewItems.forEach(entry => {
    const label = inferPreviewCategoryLabel(entry);
    (map[label] || (map[label] = [])).push(entry);
  });
  return map;
}, [quickPreviewItems]);

const previewServiceCategories = useMemo(() => {
  const map = {};
  quickPreviewServices.forEach(entry => {
    const label = inferPreviewCategoryLabel(entry);
    (map[label] || (map[label] = [])).push(entry);
  });
  return map;
}, [quickPreviewServices]);

// If the feed cache we hydrated from was written under a different signed-in
// identity (e.g. a guest logged in, or switched accounts without going
// through handleLogout's clearFeedCache), the personalized slices (own/
// following posts) belong to someone else — drop the cache and let the
// normal load effects refetch for the current user.
useEffect(() => {
  const currentUserId = user?.uid || null;
  if (hydratedFromCacheRef.current && cachedFeed && cachedFeed.userId !== currentUserId) {
    clearFeedCache();
    hydratedFromCacheRef.current = false;
    setCategories(defaultCategories());
    setServiceCategories({});
    setFeaturedItems([]);
    setFeaturedServices([]);
    setEventPosts([]);
    setFriendsPosts([]);
    setUserOwnPosts([]);
    setTotalItems(0);
    setLoading(true);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [user?.uid]);

// Keep the feed cache in sync so the next mount (e.g. after visiting a shop
// and coming back) can hydrate instantly instead of refetching.
useEffect(() => {
  setFeedCache({
    userId: user?.uid || null,
    activeTab,
    visitedTabs: Array.from(visitedTabs),
    followingFilter,
    categories,
    serviceCategories,
    featuredItems,
    featuredServices,
    eventPosts,
    friendsPosts,
    userOwnPosts,
    totalItems,
  });
}, [user?.uid, activeTab, visitedTabs, followingFilter, categories, serviceCategories,
    featuredItems, featuredServices, eventPosts, friendsPosts, userOwnPosts, totalItems]);

// Restore scroll position once when hydrating from a cached session, and save
// it on unmount (e.g. navigating to a shop page) so coming back lands in the
// same spot instead of snapping to the top.
useEffect(() => {
  if (cachedFeed?.scrollY) {
    const id = requestAnimationFrame(() => {
      window.scrollTo(0, cachedFeed.scrollY);
    });
    return () => cancelAnimationFrame(id);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

useEffect(() => {
  return () => {
    setFeedCache({ scrollY: window.scrollY });
  };
}, []);

// Keep the existing tab-switching effect, but modify it to NOT reload if already loaded
useEffect(() => {
  if (!effectiveLocation) {
    console.log('⏳ Cannot load items - waiting for location');
    return;
  }

  const loadTabContent = async () => {
    try {
      switch (activeTab) {
        case 'featured': {
          const hasData = Object.values(categories).some(items => items.length > 0);
          const filterChanged = loadedFilterRef.current !== followingFilter;
          if (hasData && !filterChanged) break;
          // A Public/Following toggle with the raw fetch already cached is a
          // fast client-side re-filter, not a real reload — skip the skeleton
          // flash so it feels like filtering, not a page reload.
          const isCachedFilterSwitch = filterChanged && !!allFetchedItemsRef.current && !!allFetchedServicesRef.current;
          if (!isCachedFilterSwitch) setLoading(true);
          // Run both in parallel so service-only brands appear in "Brands Near You" at the same time as product brands
          await Promise.all([
            loadCategorizedItems(),
            loadCategorizedServices(),
          ]);
          break;
        }
        case 'services':
        case 'gigs': {
          const hasData = Object.keys(serviceCategories).length > 0;
          if (!hasData) await loadCategorizedServices();
          break;
        }
        case 'media':
          setLoading(false);
          break;
        default:
          setLoading(false);
      }
    } catch (error) {
      console.error(`Error loading ${activeTab} content:`, error);
      setError('Failed to load content. Please try again later.');
      setLoading(false);
    }
  };

  loadTabContent();
}, [activeTab, followingFilter]);

  // Ping animation effect (disabled on mobile for performance)
  useEffect(() => {
    if (window.innerWidth < 768) return;
    
    const container = document.querySelector('.page-container');
    if (!container) return;

    const createPing = () => {
      const ping = document.createElement('div');
      ping.className = 'ping';
      
      ping.style.left = `${Math.random() * 100}%`;
      ping.style.top = `${Math.random() * 100}%`;
      ping.style.zIndex = '0';
      
      container.appendChild(ping);
      
      setTimeout(() => {
        if (ping && ping.parentNode) {
          ping.remove();
        }
      }, 3000);
    };

    const createPingGroup = (count) => {
      for (let i = 0; i < count; i++) {
        setTimeout(() => {
          createPing();
        }, i * 200);
      }
    };

    const pingCounts = [10, 30, 20];
    let currentIndex = 0;

    const interval = setInterval(() => {
      const count = pingCounts[currentIndex];
      createPingGroup(count);
      currentIndex = (currentIndex + 1) % pingCounts.length;
    }, 3000);
    
    return () => {
      clearInterval(interval);
      const pings = container.getElementsByClassName('ping');
      while (pings.length > 0) {
        pings[0].remove();
      }
    };
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.removeAttribute('data-scroll-y');
      
      if (sliderAnimationRef.current) {
        cancelAnimationFrame(sliderAnimationRef.current);
      }
    };
  }, []);

  const handleMapGPSUpdate = useCallback(async (gpsData) => {
  // Check if reverting to IP
  if (gpsData?.revertToIP) {
    console.log('🔄 Map requesting revert to IP location...');
    await revertToIP();
    return;
  }
  
  console.log('📍 GPS update from map:', gpsData);
  
  try {
    // Convert GPS to city
    const cityName = await convertCoordsToCity(
      gpsData.latitude, 
      gpsData.longitude
    );
    
    const updatedLocation = {
      ...gpsData,
      city: cityName,
      isIPBased: false,
      timestamp: Date.now()
    };
    
    // Update effective location
    setEffectiveLocation(updatedLocation);
    setIsIPLocation(false);
    
    // Save to localStorage
    saveLocationToStorage(updatedLocation);
    
    // Show toast
    setLocationToastMessage(`📍 Using GPS: ${cityName || 'Location updated'}`);
    setShowLocationToast(true);
    setTimeout(() => setShowLocationToast(false), 3000);
    
    // Reload items with new location
    console.log('🔄 Reloading items with GPS location...');
    if (activeTab === 'featured') {
      await loadCategorizedItems();
    } else if (activeTab === 'services' || activeTab === 'gigs') {
      await loadCategorizedServices();
    }

  } catch (error) {
    console.error('❌ Error processing GPS update:', error);
  }
}, [activeTab, loadCategorizedItems, loadCategorizedServices, revertToIP]);

const renderWelcomeContent = () => {
  return (
    <>
      {isAuthenticated && shopData ? (
        <>
          <ProfileSection style={{ marginBottom: '0.5rem' }}>
            {/* Profile Image - Now shows on both mobile and desktop */}
            <ProfileImage theme={currentStyle}>
              {shopData.profile ? (
                <img src={shopData.profile} alt={shopData.name || 'Shop Profile'} loading="lazy" decoding="async" />
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  background: currentStyle?.colors?.accent || '#800000',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontSize: '2rem'
                }}>
                  {(shopData.name?.charAt(0) || user.email?.charAt(0) || 'S').toUpperCase()}
                </div>
              )}
            </ProfileImage>
            
            {/* Shop Name — click to view this shop's QR code */}
            <ShopName theme={currentStyle} onClick={openShopQRCode} style={{ cursor: 'pointer' }}>
              {shopData.name || 'My Shop'}
            </ShopName>

          </ProfileSection>
        </>
      ) : (
        <>
          {/* Non-authenticated Welcome Section */}
          <ProfileSection style={{ marginBottom: '0.5rem' }}>
            <WelcomeKalKode 
              theme={currentStyle}
              onClick={openKalKodeQRCode}
              style={{ cursor: 'pointer' }}
            >
              {isAmharicLocale ? (
                <>
                  <AmharicText className={currentAmharicFont}>ቃል</AmharicText>KODE
                </>
              ) : (
                'KALKODE'
              )}
            </WelcomeKalKode>


            <MarketplaceSubtext style={{ fontSize: '0.875rem' }} theme={currentStyle}>
              Community Marketplace
            </MarketplaceSubtext>

            <ActionButtonContainer>
              <ActionButton theme={currentStyle} onClick={handleOpenShop}>
                🚀 Sign Up
              </ActionButton>
              <SignInButton onClick={handleGoogleSignIn}>
                <img
                  src="https://cdn.cdnlogo.com/logos/g/35/google-icon.svg"
                  alt="Google"
                />
                Sign In
              </SignInButton>
            </ActionButtonContainer>
          </ProfileSection>
        </>
      )}
    </>
  );
};

  if (!currentStyle) return null;

    return (
    <PageContainer className="page-container" theme={currentStyle}>
      <Header theme={currentStyle} $isAuthenticated={isAuthenticated} $visible={headerVisible}>
  {/* Left: Logo, Title, and PWA Install */}
  <HeaderLeft onClick={() => navigate('/')}>
    <LogoImage src={logo} alt="KalKode Logo" />
    {isAuthenticated && (
      <HeaderTitle 
        theme={currentStyle}
        onClick={(e) => {
          e.stopPropagation();
          openKalKodeQRCode();
        }}
        style={{ cursor: 'pointer' }}
      >
        {isAmharicLocale ? (
          <>
            <AmharicText className={currentAmharicFont}>ቃል</AmharicText>Kode
          </>
        ) : (
          'KALKODE'
        )}
      </HeaderTitle>
    )}
    
  </HeaderLeft>

  {/* Right: Controls */}
  <HeaderControls>
    <HeaderButton
      as="a"
      href="https://www.instagram.com/kalskode/"
      target="_blank"
      rel="noopener noreferrer"
      theme={currentStyle}
      title="Instagram"
    >
      <Instagram size={20} />
    </HeaderButton>
    {showPWAInstall && (
      <PWAInstallButton
        onClick={(e) => {
          e.stopPropagation();
          handlePWAInstall();
        }}
        theme={currentStyle}
        title="Install KalKode App"
      >
        <Download size={20} />
        <PWAInstallTooltip theme={currentStyle}>
          Install App
        </PWAInstallTooltip>
      </PWAInstallButton>
    )}
    {isAuthenticated && (
      <HeaderButton onClick={handleLogout} theme={currentStyle}>
        <LogOut size={20} />
      </HeaderButton>
    )}
  </HeaderControls>
</Header>

{/* iOS PWA install guide */}
{showIOSGuide && (() => {
  const ua = navigator.userAgent;
  const isChromeiOS = /CriOS/.test(ua);
  const steps = isChromeiOS
    ? [
        { icon: '⋯', text: 'Tap the three-dot menu (⋯) in the top-right corner of Chrome' },
        { icon: '＋', text: 'Tap "Add to Home Screen"' },
        { icon: '✓',  text: 'Tap "Add" to confirm' },
      ]
    : [
        { icon: '↑', text: 'Tap the Share button (↑) at the bottom of Safari' },
        { icon: '＋', text: 'Scroll down and tap "Add to Home Screen"' },
        { icon: '✓',  text: 'Tap "Add" to confirm' },
      ];
  return (
    <PWAGuideBackdrop onClick={() => setShowIOSGuide(false)}>
      <PWAGuideCard theme={currentStyle} onClick={e => e.stopPropagation()}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'0.25rem' }}>
          <span style={{ fontWeight:700, fontSize:'1rem', color: currentStyle?.colors?.text || '#fff' }}>
            Add to Home Screen
          </span>
          <button onClick={() => setShowIOSGuide(false)} style={{ background:'none', border:'none', color: currentStyle?.colors?.text || '#fff', opacity:0.5, cursor:'pointer', fontSize:'1.25rem', lineHeight:1, padding:'0.25rem' }}>✕</button>
        </div>
        <p style={{ fontSize:'0.8rem', color:`${currentStyle?.colors?.text || '#fff'}80`, margin:'0 0 0.5rem' }}>
          {isChromeiOS ? 'Using Chrome on iPhone:' : 'Using Safari on iPhone:'}
        </p>
        {steps.map((s, i) => (
          <PWAGuideStep key={i}>
            <PWAGuideStepNum theme={currentStyle}>{i + 1}</PWAGuideStepNum>
            <span style={{ fontSize:'0.875rem', color: currentStyle?.colors?.text || '#fff', lineHeight:1.4 }}>{s.text}</span>
          </PWAGuideStep>
        ))}
      </PWAGuideCard>
    </PWAGuideBackdrop>
  );
})()}

{/* Instagram "open in browser" guide */}
{showInstagramGuide && (() => {
  const ua = navigator.userAgent;
  const isAndroid = /Android/.test(ua);
  return (
    <PWAGuideBackdrop onClick={() => setShowInstagramGuide(false)}>
      <PWAGuideCard theme={currentStyle} onClick={e => e.stopPropagation()}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'0.25rem' }}>
          <span style={{ fontWeight:700, fontSize:'1rem', color: currentStyle?.colors?.text || '#fff' }}>
            Open in {isAndroid ? 'Chrome' : 'Safari'} to Install
          </span>
          <button onClick={() => setShowInstagramGuide(false)} style={{ background:'none', border:'none', color: currentStyle?.colors?.text || '#fff', opacity:0.5, cursor:'pointer', fontSize:'1.25rem', lineHeight:1, padding:'0.25rem' }}>✕</button>
        </div>
        <p style={{ fontSize:'0.8rem', color:`${currentStyle?.colors?.text || '#fff'}80`, margin:'0 0 0.5rem' }}>
          Instagram's browser doesn't support app installation. Open the page in your default browser first:
        </p>
        <PWAGuideStep>
          <PWAGuideStepNum theme={currentStyle}>1</PWAGuideStepNum>
          <span style={{ fontSize:'0.875rem', color: currentStyle?.colors?.text || '#fff', lineHeight:1.4 }}>
            Tap the <strong>⋯</strong> menu in the top-right corner of this screen
          </span>
        </PWAGuideStep>
        <PWAGuideStep>
          <PWAGuideStepNum theme={currentStyle}>2</PWAGuideStepNum>
          <span style={{ fontSize:'0.875rem', color: currentStyle?.colors?.text || '#fff', lineHeight:1.4 }}>
            Tap <strong>"Open in {isAndroid ? 'Chrome' : 'Safari'}"</strong>
          </span>
        </PWAGuideStep>
        <PWAGuideStep>
          <PWAGuideStepNum theme={currentStyle}>3</PWAGuideStepNum>
          <span style={{ fontSize:'0.875rem', color: currentStyle?.colors?.text || '#fff', lineHeight:1.4 }}>
            {isAndroid
              ? 'Once in Chrome, tap the three-dot menu → "Add to Home screen"'
              : 'Once in Safari, tap the Share button (↑) → "Add to Home Screen"'}
          </span>
        </PWAGuideStep>
      </PWAGuideCard>
    </PWAGuideBackdrop>
  );
})()}

      <MainContent isAuthenticated={isAuthenticated} className="main-content-area">
  {/* Welcome Section - Compact */}
  <WelcomeSection theme={currentStyle}>
    {window.innerWidth > 768 ? (
      /* Desktop: Canvas Backdrop - Compact */
      <CanvasBackdrop 
        theme={currentStyle} 
        bgImage={currentBgImage}
      >
        <ContentOverlay theme={currentStyle}>
          {renderWelcomeContent()}
        </ContentOverlay>
      </CanvasBackdrop>
    ) : (
      /* Mobile: Simple content without canvas */
      <div style={{ paddingBottom: '0.5rem' }}>
        {renderWelcomeContent()}
      </div>
    )}
  </WelcomeSection>

  {/* Bottom Content Area - Immediately after welcome */}
  <BottomContent theme={currentStyle}>
  

  {/* Treasure Map — shown on both mobile and desktop now, in the slot that
      used to hold "Businesses Near You" (removed). Mobile previously had
      its own floating bottom-center orb (FloatingMapWrap, also removed) —
      this single block now covers both. */}
  <TreasureMapButton type="button" theme={currentStyle} onClick={handleOpenMap} style={{ margin: '0 auto 1.25rem' }}>
    <img src="/treasure-chest.png" alt="" style={{ width: 56, height: 56, objectFit: 'contain' }} />
    <span style={{
      fontSize: '1rem', fontWeight: 700, letterSpacing: '0.03em',
      fontFamily: "'Cinzel Decorative', serif",
      background: 'linear-gradient(135deg, #ffd700 0%, #ffd700 40%, #ffb900 60%, #ffd700 80%, #ffed4e 100%)',
      WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
      WebkitTextStroke: `0.5px ${currentStyle?.colors?.background || '#1a0f05'}`,
    }}>
      Treasure Map
    </span>
    <span style={{ fontSize: '0.78rem', color: currentStyle?.colors?.text || '#D4AF6A', opacity: 0.85 }}>
      {(() => {
        const locText = cityRegion ||
          (effectiveLocation?.city ? `${effectiveLocation.city}, ${effectiveLocation.region}` : null);
        return locText ? `${isIPLocation ? 'IP' : 'GPS'} · ${locText}` : 'Loading...';
      })()}
    </span>
  </TreasureMapButton>

  {/* Mobile Divider between location and tabs */}
  <div className="mobile-only" style={{
    height: '1px', 
    background: `linear-gradient(90deg, transparent 0%, ${currentStyle?.colors?.accent || '#800000'} 50%, transparent 100%)`,
  }} />

  {/* Tabs in normal flow at the top, sticking to the top once scrolled past
      (see TabContainer's $sticky styling) — same behavior for guests and
      logged-in users. */}
  <TabContainer
    theme={currentStyle}
    $sticky={true}
    $headerVisible={headerVisible}
    style={{
      '--tab-active-color': currentStyle?.colors?.accent || '#800000',
      '--tab-inactive-color': `${currentStyle?.colors?.accent || '#800000'}C9`,
    }}
    onTouchStart={(e) => e.stopPropagation()}
    onTouchMove={(e) => e.stopPropagation()}
    onTouchEnd={(e) => e.stopPropagation()}
  >
    {[
      { key: 'gigs',     label: 'Gigs',     Icon: Briefcase },
      { key: 'featured', label: 'Products', Icon: Package   },
      { key: 'services', label: 'Services', Icon: CogIcon   },
      { key: 'events',   label: 'Events',   Icon: Calendar  },
      { key: 'media',    label: 'Media',    Icon: UsersIcon },
    ].map(({ key, label, Icon }) => {
      const accent = currentStyle?.colors?.accent || '#800000';
      const isActive = activeTab === key;
      return (
        <Tab
          key={key}
          theme={currentStyle}
          active={isActive}
          $color={isActive ? accent : `${accent}C9`}
          onClick={() => setActiveTab(key)}
        >
          <Icon size={18} />
          {label}
        </Tab>
      );
    })}

  </TabContainer>

<FilterToggle theme={currentStyle} $isAuthenticated={isAuthenticated}>
  <FilterButton
    theme={currentStyle}
    active={followingFilter === 'public'}
    onClick={() => setFollowingFilter('public')}
    title="Public"
  >
    <Globe size={16} />
  </FilterButton>
  <FilterButton
    theme={currentStyle}
    active={followingFilter === 'following'}
    onClick={() => {
      if (!isAuthenticated) { setShowFollowingLoginPrompt(true); return; }
      setFollowingFilter('following');
    }}
    title="Following"
  >
    <UserCheck size={16} />
  </FilterButton>
</FilterToggle>


{showFollowingLoginPrompt && (
  <FollowingLoginPopover
    className="following-login-prompt-container"
    theme={currentStyle}
    onClick={() => { setShowFollowingLoginPrompt(false); handleGoogleSignIn(); }}
  >
    <img src="https://cdn.cdnlogo.com/logos/g/35/google-icon.svg" alt="Google" />
    Login to see followed shops
  </FollowingLoginPopover>
)}

  {/* Mobile Divider between location and tabs */}
  <div className="mobile-only" style={{ 
    height: '1px', 
    background: `linear-gradient(90deg, transparent 0%, ${currentStyle?.colors?.accent || '#800000'} 50%, transparent 100%)`,
  }} />

  {/* ✅ UPDATED: Collapsible Search Container with Toggle */}
  {(activeTab === 'featured' || activeTab === 'services' || activeTab === 'gigs') && (
    <div style={{ position: 'relative' }}>
      {/* Search Bar - Slides down from top */}
      {searchBarOpen && (
        <SearchContainer style={{
          marginTop: '0.5rem',
          marginBottom: '0.5rem',
          animation: 'slideDown 0.3s ease'
        }}>
          <SearchInputWrapper>
            <SearchInput
              type="text"
              placeholder={`Search nearby ${
                activeTab === 'featured' 
                  ? 'products' 
                  : 'services'
              }...`}
              value={getActiveSearchTerm()}
              onChange={(e) => setActiveSearchTerm(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              autoFocus
            />

            <SearchButtonGroup>
              {hasActiveSearchResults() && (
                <SearchButton 
                  onClick={handleClearSearch}
                  title="Clear search"
                  aria-label="Clear search"
                  type="button"
                >
                  <X size={18} />
                </SearchButton>
              )}

              {/* Close search button (replaces search button when open) */}
              <SearchButton 
                onClick={() => setSearchBarOpen(false)}
                title="Close search"
                aria-label="Close search"
                type="button"
              >
                <X size={18} />
              </SearchButton>
            </SearchButtonGroup>
          </SearchInputWrapper>
        </SearchContainer>
      )}
    </div>
  )}
              
              

          {/* Add spacing between search and content for mobile */}
          <div className="mobile-spacing" style={{ 
            display: window.innerWidth <= 768 ? 'block' : 'none', 
            height: '0.5rem' 
          }} />

            {/* Tab Content */}
            {visitedTabs.has('featured') && (
              <div ref={featuredTabRef} style={{ display: activeTab === 'featured' ? 'block' : 'none' }}>
                <ProductsTab
                  theme={currentStyle}
                  hasProductSearchResults={hasProductSearchResults}
                  productSearchResults={productSearchResults}
                  followedShops={followedShops}
                  followLoading={followLoading}
                  onItemClick={handleItemClick}
                  onLikeClick={handleLikeClick}
                  onFollowToggle={handleFollowToggle}
                  onAddToCart={handleCardOrderClick}
                  isAuthenticated={isAuthenticated}
                  catGridCols={catGridCols}
                  onSetCatCols={setCatCols}
                  onToggleSearch={() => setSearchBarOpen(prev => !prev)}
                  categories={categories}
                  collapsedSections={collapsedSections}
                  onToggleSection={toggleSection}
                  expandedCategories={expandedCategories}
                  onExpandCategory={expandCategory}
                  loading={loading}
                  previewCategories={previewCategories}
                />
              </div>
            )}

            {/* Services Tab — Providers only; In Demand moved to its own Gigs tab */}
            {visitedTabs.has('services') && (
              <div ref={servicesTabRef} style={{ display: activeTab === 'services' ? 'block' : 'none' }}>
                <ServicesTab
                  theme={currentStyle}
                  hasServiceSearchResults={hasServiceSearchResults}
                  serviceSearchResults={serviceSearchResults}
                  serviceSubTab="offer"
                  followedShops={followedShops}
                  followLoading={followLoading}
                  onItemClick={handleItemClick}
                  onLikeClick={handleLikeClick}
                  onFollowToggle={handleFollowToggle}
                  onAddToCart={handleCardOrderClick}
                  isAuthenticated={isAuthenticated}
                  catGridCols={catGridCols}
                  onSetCatCols={setCatCols}
                  onToggleSearch={() => setSearchBarOpen(prev => !prev)}
                  serviceCategories={serviceCategories}
                  collapsedSections={collapsedSections}
                  onToggleSection={toggleSection}
                  expandedCategories={expandedCategories}
                  onExpandCategory={expandCategory}
                  loading={loading}
                  previewServiceCategories={previewServiceCategories}
                />
              </div>
            )}

            {/* Gigs Tab — same renderer as Services, filtered to the "In Demand" side */}
            {visitedTabs.has('gigs') && (
              <div ref={gigsTabRef} style={{ display: activeTab === 'gigs' ? 'block' : 'none' }}>
                <ServicesTab
                  theme={currentStyle}
                  hasServiceSearchResults={hasServiceSearchResults}
                  serviceSearchResults={serviceSearchResults}
                  serviceSubTab="need"
                  followedShops={followedShops}
                  followLoading={followLoading}
                  onItemClick={handleItemClick}
                  onLikeClick={handleLikeClick}
                  onFollowToggle={handleFollowToggle}
                  onAddToCart={handleCardOrderClick}
                  isAuthenticated={isAuthenticated}
                  catGridCols={catGridCols}
                  onSetCatCols={setCatCols}
                  onToggleSearch={() => setSearchBarOpen(prev => !prev)}
                  serviceCategories={serviceCategories}
                  collapsedSections={collapsedSections}
                  onToggleSection={toggleSection}
                  expandedCategories={expandedCategories}
                  onExpandCategory={expandCategory}
                />
              </div>
            )}

{/* Events Tab */}
{visitedTabs.has('events') && (
  <div ref={eventsTabRef} style={{ display: activeTab === 'events' ? 'block' : 'none' }}>
    <EventsTab
      theme={currentStyle}
      eventPosts={eventPosts}
      eventsViewMode={eventsViewMode}
      onSetEventsViewMode={setEventsViewMode}
      expandedEventId={expandedEventId}
      onSetExpandedEventId={setExpandedEventId}
      followedShops={followedShops}
      followLoading={followLoading}
      onFollowToggle={handleFollowToggle}
      onCommunityPostLike={handleCommunityPostLike}
      onItemClick={handleItemClick}
      cartItems={cartItems}
      onSetCartItems={setCartItems}
      onSetShowCartDropdown={setShowCartDropdown}
      user={user}
      isAuthenticated={isAuthenticated}
      loadingEvents={loadingEvents}
    />
  </div>
)}
            {/* Media Tab */}
            {visitedTabs.has('media') && (
              <div ref={mediaTabRef} style={{ display: activeTab === 'media' ? 'block' : 'none' }}>
                <MediaTab
                  theme={currentStyle}
                  friendsPosts={friendsPosts}
                  userOwnPosts={userOwnPosts}
                  mediaViewMode={mediaViewMode}
                  onSetMediaViewMode={setMediaViewMode}
                  followedShops={followedShops}
                  followLoading={followLoading}
                  onFollowToggle={handleFollowToggle}
                  onCommunityPostLike={handleCommunityPostLike}
                  onItemClick={handleItemClick}
                  user={user}
                  isAuthenticated={isAuthenticated}
                  loadingFriends={loadingFriends}
                />
              </div>
            )}
          </BottomContent>
      </MainContent>

      {/* QR Code Overlay — shared by the KalKode QR and each shop's own QR */}
<QRCodeOverlay
  isOpen={!!qrOverlay}
  onClick={closeQRCode}
  theme={currentStyle}
>
  {qrOverlay && (
    <QRCodeContainer
      theme={currentStyle}
      isOpen={!!qrOverlay}
      onClick={(e) => e.stopPropagation()}
    >
      <QRCodeCloseButton
        onClick={closeQRCode}
        theme={currentStyle}
        aria-label="Close QR Code"
      >
        <X size={24} />
      </QRCodeCloseButton>

      <QRCodeTitle theme={currentStyle}>
        <QrCode size={22} style={{ verticalAlign: '-3px', marginRight: '0.4rem' }} />
        {qrOverlay.title}
      </QRCodeTitle>

      <QRCodeImageWrap>
        {qrOverlay.loading ? (
          <QRCodeSpinnerIcon theme={currentStyle} size={40} />
        ) : (
          <QRCodeImage
            src={qrOverlay.image || KodeQR}
            alt={`QR code for ${qrOverlay.title}`}
          />
        )}
      </QRCodeImageWrap>

      <QRCodeSubtext theme={currentStyle}>
        {qrOverlay.error
          ? "Couldn't load the QR code — try again in a moment."
          : qrOverlay.subtitle}
      </QRCodeSubtext>

      <QRCodeLinkButton theme={currentStyle} onClick={handleCopyQrLink}>
        {qrLinkCopied ? <Check size={15} /> : <Copy size={15} />}
        <span>{qrLinkCopied ? 'Link copied!' : qrOverlay.linkUrl.replace('https://', '')}</span>
      </QRCodeLinkButton>
    </QRCodeContainer>
  )}
</QRCodeOverlay>

{/* Guest order confirmation — no chat access for a no-login order, just this + an email */}
{guestOrderResult && (
  <div
    onClick={() => setGuestOrderResult(null)}
    style={{
      position: 'fixed', inset: 0, zIndex: 10000,
      background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: currentStyle?.colors?.surface || '#1a1a1a',
        border: `1px solid ${currentStyle?.colors?.accent || '#800000'}40`,
        borderRadius: 16, padding: '1.75rem 1.5rem', maxWidth: 360, width: '100%',
        textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}
    >
      {guestOrderResult.status === 'success' ? (
        <>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✅</div>
          <h3 style={{ margin: '0 0 0.5rem', color: currentStyle?.colors?.text || '#fff', fontSize: '1.1rem' }}>Order Confirmed</h3>
          <p style={{ margin: '0 0 0.25rem', color: `${currentStyle?.colors?.text || '#fff'}cc`, fontSize: '0.88rem' }}>
            {guestOrderResult.itemName}{guestOrderResult.total != null ? ` · $${parseFloat(guestOrderResult.total).toFixed(2)}` : ''}
          </p>
          <p style={{ margin: '0 0 1.25rem', color: `${currentStyle?.colors?.text || '#fff'}80`, fontSize: '0.78rem', lineHeight: 1.5 }}>
            {guestOrderResult.email
              ? `A confirmation with your order details is on its way to ${guestOrderResult.email}.`
              : 'The seller has your order and will reach out directly.'}
          </p>
        </>
      ) : (
        <>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>⚠️</div>
          <h3 style={{ margin: '0 0 0.5rem', color: currentStyle?.colors?.text || '#fff', fontSize: '1.1rem' }}>Order Failed</h3>
          <p style={{ margin: '0 0 1.25rem', color: `${currentStyle?.colors?.text || '#fff'}cc`, fontSize: '0.85rem' }}>
            {guestOrderResult.message}
          </p>
        </>
      )}
      <button
        onClick={() => setGuestOrderResult(null)}
        style={{
          width: '100%', padding: '0.6rem', background: currentStyle?.colors?.accent || '#800000',
          border: 'none', borderRadius: 10, color: '#fff', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer',
        }}
      >
        Done
      </button>
    </div>
  </div>
)}

      <ThemeDropdownContainer
  className="theme-dropdown-container"
  $isAuthenticated={isAuthenticated}
>
  <ThemeDropdownButton
    theme={currentStyle}
    onClick={() => setThemeDropdownOpen(!themeDropdownOpen)}
    $isOpen={themeDropdownOpen}
    $isPinned={isPinned}
  >
    {/* Refresh button on the left */}
    <span
      className="refresh-btn"
      onClick={(e) => {
        e.stopPropagation();
        refreshTheme();
      }}
      title="Shuffle theme"
    >
      <RefreshCw size={14} className={isRefreshing ? "spinning" : ""} />
    </span>
    
    <span className="style-name">{currentStyle.name}</span>
    
    <ChevronDown size={16} className="chevron" />
    
    {/* Pin button on the right */}
    <span 
      className="pin-btn"
      onClick={(e) => {
        e.stopPropagation();
        togglePinStyle();
      }}
      title={isPinned ? "Unpin theme" : "Pin theme"}
    >
      <Pin size={14} fill={isPinned ? currentStyle.colors.accent : "none"} />
    </span>
  </ThemeDropdownButton>

  <ThemeDropdownMenu
    theme={currentStyle}
    $isOpen={themeDropdownOpen}
  >
    {Object.values(WELCOME_STYLES).map((style) => (
      <ThemeMenuItem
        key={style.id}
        theme={currentStyle}
        $isActive={currentStyle.id === style.id}
        onClick={() => {
          setThemeDropdownOpen(false);
          startTransition(() => setCurrentStyle(style));
          if (isPinned) {
            localStorage.setItem('pinnedStyleId', style.id.toString());
          }
        }}
      >
        <span className="style-number">{style.id}</span>
        <span className="style-name">{style.name}</span>
        <div className="active-indicator" />
      </ThemeMenuItem>
    ))}
  </ThemeDropdownMenu>
</ThemeDropdownContainer>

      {zoomedItem && (
  <ZoomOverlay onClick={handleCloseZoom} theme={currentStyle}>
    <ZoomContainer
      theme={currentStyle}
      onClick={(e) => e.stopPropagation()}
      $isIOS={deviceInfo.isIOS}
      $restaurantOpen={restaurantPanelOpen}
      $isAndroid={deviceInfo.isAndroid}
      className="zoom-container"
      style={{
        transform: isSwipingItemCard ? `translateX(${itemCardSwipeOffset}px) rotateZ(${itemCardSwipeOffset * 0.02}deg)` : 'none',
        transition: isSwipingItemCard ? 'none' : 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
        opacity: isSwipingItemCard ? Math.max(0.7, 1 - Math.abs(itemCardSwipeOffset) / 500) : 1,
        overflowY: showZoomedOrderForm ? 'auto' : 'hidden',
      }}
    >
      {/* DESKTOP NAVIGATION - Top Button */}
      <DesktopNavigationButton
        className="top"
        theme={currentStyle}
        onClick={(e) => {
          e.stopPropagation();
          handlePrevItem();
        }}
        disabled={(() => {
          const allItems = getAllItemsFromCurrentTab();
          const currentIndex = allItems.findIndex(item => 
            item.id === zoomedItem?.id && item.shopId === zoomedItem?.shopId
          );
          return currentIndex === 0;
        })()}
        title="Previous item (↑)"
      >
        <ChevronUp size={24} />
      </DesktopNavigationButton>

      {/* KEYBOARD HINTS */}
      <KeyboardHint theme={currentStyle}>
        <kbd>↑</kbd><kbd>↓</kbd> Items • <kbd>←</kbd><kbd>→</kbd> Images • <kbd>ESC</kbd> Close
      </KeyboardHint>

      <ImageCarousel
  theme={currentStyle}
  currentIndex={currentImageIndex}
  $isMobile={deviceInfo.isMobile}
  className="image-carousel"
  style={showZoomedOrderForm ? { flex: '0 0 55vh', minHeight: '200px' } : {}}
>
  {/* Ride items: show interactive route map instead of image (not for Pro service offers — those use the booking form) */}
  {zoomedItem.jobType === 'rides' && zoomedItem.serviceTab !== 'offer' ? (
    <div style={{ width: '100%', height: '100%', position: 'relative' }} onClick={e => e.stopPropagation()}>
      <RideRouteMap item={zoomedItem} onClaim={handleDirectOrder} theme={currentStyle} />
    </div>
  ) : (
  <>
  <div className="image-track">
    {zoomedItem.images && zoomedItem.images.filter(Boolean).length > 0 ? (
      zoomedItem.images.filter(Boolean).map((media, index) => {
        // ✅ NEW: Check if it's a video
        const isVideo = (() => {
          if (!media) return false;
          // Check if it's an object with isVideo flag
          if (typeof media === 'object' && media.isVideo) return true;
          // Check if it's a string URL containing video indicators
          if (typeof media === 'string') {
            return media.includes('video-') || 
                   media.includes('%2Fvideo-') || 
                   media.includes('.mp4') || 
                   media.includes('.webm') || 
                   media.includes('.mov') ||
                   media.includes('clip-') ||        // ADD THIS
                   media.includes('%2Fclip-');        // ADD THIS (URL-encoded version)
          }
          return false;
        })();
        
        // Extract URL from object or use string directly
        const mediaSrc = typeof media === 'object' ? media.url : media;
        
        return (
          <div key={index} className="image-slide" style={{ position: 'relative' }}>
            {!isVideo && (
              <div style={{
                position: 'absolute',
                top: 0, left: 0,
                width: '100%', height: '100%',
                backgroundImage: `url(${zoomedItem.imageBlur?.[index] || mediaSrc})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                filter: 'blur(20px)',
                transform: 'scale(1.1)',
                opacity: 0.6,
                zIndex: 0,
              }} />
            )}
            {isVideo ? (
              <video
                src={mediaSrc}
                loop
                muted
                playsInline
                controls
                className="media-list-video"
                autoPlay
                style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'relative', zIndex: 1 }}
                onError={(e) => {
                  console.error('Video failed to load:', mediaSrc);
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <img
                src={mediaSrc}
                alt={`${zoomedItem.name} ${index + 1}`}
                decoding="async"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  objectPosition: 'center',
                  position: 'relative',
                  zIndex: 1,
                }}
                onError={(e) => { console.error('Image failed to load:', mediaSrc); }}
              />
            )}
          </div>
        );
      })
    ) : (
      <div className="image-slide">
        <div className="no-image">
          <Package size={40} />
          <p>No image</p>
        </div>
      </div>
    )}
  </div>
  
  
  {/* Rest of the carousel controls... */}
  {zoomedItem.images && zoomedItem.images.filter(Boolean).length > 1 && (
    <>
      <button 
        className="carousel-button prev"
        onClick={handlePrevImage}
        aria-label="Previous image"
        style={{ left: '1rem' }}
      >
        <ChevronLeft size={20} />
      </button>
      <button 
        className="carousel-button next"
        onClick={handleNextImage}
        aria-label="Next image"
        style={{ right: '1rem' }}
      >
        <ChevronRight size={20} />
      </button>
    </>
  )}
        
        {clusterItems.length > 1 && (
          <>
            <div style={{
    position: 'absolute',
    top: '1rem',
    right: '50%',
    transform: 'translateX(50%)',
    background: 'rgba(139, 90, 43, 0.95)',
    backdropFilter: 'blur(10px)',
    padding: '0.5rem 1rem',
    borderRadius: '20px',
    color: '#ffd700',
    fontSize: '0.9rem',
    fontWeight: '700',
    zIndex: 3,
    border: '2px solid #f4e4c1',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
  }}>
    🗺️ {currentClusterIndex + 1} / {clusterItems.length}
  </div>
          </>

)}
        
        {zoomedItem.images && zoomedItem.images.filter(Boolean).length > 1 && (
          <div className="carousel-dots">
            {zoomedItem.images.filter(Boolean).map((_, index) => (
              <button
                key={index}
                className="dot"
                style={{ opacity: index === currentImageIndex ? 1 : 0.3 }}
                onClick={() => setCurrentImageIndex(index)}
                aria-label={`Image ${index + 1}`}
              />
            ))}
          </div>
        )}
  </>
  )}

<MobileOverlayControls theme={currentStyle}>
  {/* Follow button - top left */}
  {isAuthenticated && zoomedItem.shopId && (
    <FollowButton
      onClick={(e) => {
        e.stopPropagation();
        handleFollowToggle(zoomedItem.shopId, e);
      }}
      theme={currentStyle}
      $isFollowing={followedShops.has(zoomedItem.shopId)}
      $isLoading={followLoading.has(zoomedItem.shopId)}
      disabled={followLoading.has(zoomedItem.shopId)}
      title={followedShops.has(zoomedItem.shopId) ? 'Following' : 'Follow'}
      style={{
        position: 'absolute',
        top: '1rem',
        left: '1rem',
        zIndex: 12
      }}
    >
      {followedShops.has(zoomedItem.shopId) ? (
        <CheckCircle size={16} />
      ) : (
        <PlusCircle size={16} />
      )}
    </FollowButton>
  )}

  {/* Shop info - top left (next to follow button) */}
  <OverlayStoreInfo
    theme={currentStyle}
    onClick={(e) => {
      e.stopPropagation();
      if (zoomedItem.shopId) {
        handleCloseZoom();
        navigate(`/shop/${zoomedItem.shopId}/view`);
      }
    }}
    style={{
      top: '1rem',
      left: isAuthenticated ? '3.5rem' : '1rem',
      bottom: 'auto',
      right: 'auto',
      zIndex: 12
    }}
  >
    <div className="shop-pfp">
      {zoomedItem.shopProfile ? (
        <img src={zoomedItem.shopProfile} alt={zoomedItem.shopName} loading="lazy" decoding="async" />
      ) : (
        <Store size={10} />
      )}
    </div>
    <span className="shop-name">{zoomedItem.shopName}</span>
  </OverlayStoreInfo>

  {/* Distance info - bottom right (hidden on media tab) */}
  {activeTab !== 'media' && formatItemLocation(zoomedItem) && (
    <OverlayDistanceInfo
      theme={currentStyle}
      style={{ bottom: '1rem', right: '1rem', top: 'auto', left: 'auto', zIndex: 11 }}
    >
      <Navigation size={12} />
      <span>{formatItemLocation(zoomedItem)}</span>
    </OverlayDistanceInfo>
  )}

  {/* City info - bottom left (hidden on media tab) */}
  {activeTab !== 'media' && zoomedItemCity && (
    <OverlayDistanceInfo
      theme={currentStyle}
      style={{ bottom: '1rem', left: '1rem', top: 'auto', right: 'auto', zIndex: 11 }}
    >
      <MapPin size={12} />
      <span>{zoomedItemCity}</span>
    </OverlayDistanceInfo>
  )}

  {/* Item name - center bottom */}
  {activeTab !== 'media' ? (
    <ItemNameOverlay
      theme={currentStyle}
      style={{
        bottom: '3.8rem',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        maxWidth: '80%',
      }}
    >
      <h4 className="item-name">{zoomedItem.name}</h4>
    </ItemNameOverlay>
  ) : (
    (zoomedItem.caption || zoomedItem.description) && (
      <ItemNameOverlay theme={currentStyle}>
        <span style={{ display: 'block', maxWidth: '90%', wordBreak: 'break-word' }}>{zoomedItem.caption || zoomedItem.description}</span>
      </ItemNameOverlay>
    )
  )}

  {/* Quantity control - bottom left (hidden on media tab and for ride items) */}
  {activeTab !== 'media' && !zoomedItem.jobType && (
    <OverlayQuantityControl 
      theme={currentStyle}
      style={{
        bottom: '1rem',
        left: '1rem',
        top: 'auto',
        right: 'auto',
        zIndex: 10
      }}
    >
      <button 
        onClick={() => adjustQuantity(1)}
        disabled={orderQuantity >= parseInt(zoomedItem.isService ? zoomedItem.slots : zoomedItem.quantity || 1)}
      >
        <Plus size={16} />
      </button>
      
      <div className="qty-display">
        {orderQuantity}
      </div>

      <button 
        onClick={() => adjustQuantity(-1)}
        disabled={orderQuantity <= 1}
      >
        <Minus size={16} />
      </button>
    </OverlayQuantityControl>
  )}

  {/* Info button — for job/ride items shows job details */}
  {activeTab !== 'media' && zoomedItem.jobType && (
    <InfoButton
      onClick={(e) => { e.stopPropagation(); setJobInfoPanelOpen(o => !o); setRestaurantPanelOpen(false); setInfoPanelOpen(false); }}
      theme={currentStyle}
      $isOpen={jobInfoPanelOpen}
      title="View details"
      style={{ bottom: '3.5rem', right: '1rem', top: 'auto', left: 'auto', zIndex: 11 }}
    >
      <Info size={16} />
    </InfoButton>
  )}

  {/* Single options button — shown for non-job items when description/options/add-ons exist */}
  {activeTab !== 'media' && !zoomedItem.jobType && (
    zoomedItem.description ||
    (zoomedItem.customOptions || []).filter(o => o?.trim()).length > 0 ||
    zoomedShopItems.length > 0 ||
    (zoomedItem.attributes || []).filter(a => a.values?.length > 0).length > 0
  ) && (
    <InfoButton
      onClick={(e) => { e.stopPropagation(); setRestaurantPanelOpen(o => !o); setInfoPanelOpen(false); setAttributesPanelOpen(false); }}
      theme={currentStyle}
      $isOpen={restaurantPanelOpen}
      title="Options & info"
      style={{ bottom: '3.5rem', right: '1rem', top: 'auto', left: 'auto', zIndex: 11 }}
    >
      <Settings size={16} />
    </InfoButton>
  )}

  {/* Share panel */}
  <SharePanel theme={currentStyle} $open={showSharePanel} onClick={e => e.stopPropagation()}>
    {(() => {
      const refId = user?.uid || 'shared';
      const itemUrl = `https://kalkode.com/shop/${zoomedItem.shopId}/view?item=${zoomedItem.id}&ref=${refId}`;
      const shareText = `Check out "${zoomedItem.name}" on KalKode`;
      const encodedUrl = encodeURIComponent(itemUrl);
      const encodedText = encodeURIComponent(shareText);

      // Native share — opens system share sheet on mobile, which lets users
      // pick Instagram / TikTok / Snapchat and directly create a post or story
      const nativeShare = async (type) => {
        if (navigator.share) {
          try {
            await navigator.share({ title: zoomedItem.name, text: `${shareText} — ${itemUrl}`, url: itemUrl });
            setShowSharePanel(false);
            return true;
          } catch (_) {}
        }
        return false;
      };

      // Instagram story deep-link (mobile browsers only)
      const instagramStory = () => {
        navigator.clipboard?.writeText(itemUrl);
        // Try app deep link first; falls back to web
        const deepLink = `instagram-stories://share?backgroundImage=${encodeURIComponent(zoomedItem.images?.[0] || '')}&contentURL=${encodedUrl}`;
        const fallback = 'https://www.instagram.com/';
        const start = Date.now();
        window.location.href = deepLink;
        setTimeout(() => { if (Date.now() - start < 2000) window.open(fallback, '_blank'); }, 1200);
        setShowSharePanel(false);
      };

      // Snapchat story deep-link
      const snapStory = () => {
        const deepLink = `snapchat://creativekit/story?attachmentUrl=${encodedUrl}`;
        const webFallback = `https://www.snapchat.com/create/story?attachmentUrl=${encodedUrl}`;
        const start = Date.now();
        window.location.href = deepLink;
        setTimeout(() => { if (Date.now() - start < 2000) window.open(webFallback, '_blank'); }, 1200);
        setShowSharePanel(false);
      };

      // TikTok — no deep link for pre-filled post; copy + open is the only option
      const tiktokShare = () => {
        navigator.clipboard?.writeText(`${shareText} ${itemUrl}`);
        window.open('https://www.tiktok.com/', '_blank');
        setShowSharePanel(false);
      };

      // Facebook sharer URL actually works and pre-fills the post
      const facebookPost = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, '_blank');
        setShowSharePanel(false);
      };

      const platforms = [
        {
          name: 'Instagram', color: '#E1306C',
          options: [
            { label: '✦ Post / Reel / Story', hint: '(opens share sheet)', action: () => nativeShare() },
            { label: 'Story deep-link', hint: '(mobile only)', action: instagramStory },
          ]
        },
        {
          name: 'TikTok', color: '#69C9D0',
          options: [
            { label: '✦ Post / Story', hint: '(opens share sheet)', action: () => nativeShare() },
            { label: 'Copy + open app', hint: '', action: tiktokShare },
          ]
        },
        {
          name: 'Snapchat', color: '#FFFC00',
          options: [
            { label: '✦ Story', hint: '(opens share sheet)', action: () => nativeShare() },
            { label: 'Story deep-link', hint: '(mobile only)', action: snapStory },
          ]
        },
        {
          name: 'Facebook', color: '#1877F2',
          options: [
            { label: 'Post (pre-filled)', hint: '', action: facebookPost },
            { label: '✦ Story / Reel', hint: '(opens share sheet)', action: () => nativeShare() },
          ]
        },
      ];

      return (
        <>
          {/* Native share — most effective on mobile */}
          <CopyLinkBtn
            onClick={() => nativeShare()}
            style={{ marginBottom: '0.5rem', background: 'rgba(255,255,255,0.08)', borderColor: 'rgba(255,255,255,0.2)' }}
          >
            <Share2 size={14} />
            Share via device (recommended)
          </CopyLinkBtn>

          {platforms.map(p => (
            <SharePlatformRow key={p.name}>
              <SharePlatformLabel theme={currentStyle} style={{ color: p.color }}>{p.name}</SharePlatformLabel>
              <ShareOptionRow>
                {p.options.map(o => (
                  <ShareOptionBtn
                    key={o.label}
                    onClick={o.action}
                    style={{ borderColor: `${p.color}40` }}
                    title={o.hint}
                  >
                    {o.label}
                  </ShareOptionBtn>
                ))}
              </ShareOptionRow>
            </SharePlatformRow>
          ))}

          <CopyLinkBtn onClick={() => {
            navigator.clipboard?.writeText(itemUrl);
            setLinkCopied(true);
            setTimeout(() => setLinkCopied(false), 2000);
          }}>
            {linkCopied ? <Check size={14} /> : <Copy size={14} />}
            {linkCopied ? 'Copied!' : 'Copy referral link'}
          </CopyLinkBtn>
        </>
      );
    })()}
  </SharePanel>

  {/* Share button */}
  <OverlayShareButton
    onClick={(e) => { e.stopPropagation(); setShowSharePanel(o => !o); }}
    theme={currentStyle}
    title="Share"
    style={{ right: '5rem', top: 'auto', left: 'auto', zIndex: 12 }}
  >
    <Share2 size={16} />
  </OverlayShareButton>

  {/* ✅ Like button - bottom right, below info button */}
  <OverlayLikeButton
    onClick={(e) => {
      e.stopPropagation();
      // Community posts/events (media & events tabs) carry contentUrl and have
      // no price — they need the post-liking path (different Firestore
      // location: communityPosts/{id}.engagement.likes, not the item engagement
      // subcollection), not the product/service handler.
      if (zoomedItem.contentUrl !== undefined) {
        handleCommunityPostLike(zoomedItem);
      } else {
        handleLikeClick(zoomedItem, isAuthenticated);
      }
    }}
    theme={currentStyle}
    $isLiked={zoomedItem.isLiked}
    title={zoomedItem.isLiked ? "Unlike" : "Like"}
    style={{
      bottom: '1rem',
      right: '1rem',
      top: 'auto',
      left: 'auto',
      zIndex: 11
    }}
  >
    <Heart size={18} />
    <span>{zoomedItem.likeCount || 0}</span>
  </OverlayLikeButton>

  {/* ✅ Order button - center bottom (hidden on media tab) */}
  {activeTab !== 'media' && (
    <OverlayOrderButton
      onClick={() => {
        if (zoomedItem.ctaStyle === 'signup' && zoomedItem.externalLink) {
          window.open(zoomedItem.externalLink, '_blank', 'noopener,noreferrer');
          return;
        }
        if (needsOrderForm(zoomedItem)) {
          setShowZoomedOrderForm(true);
          requestAnimationFrame(() => requestAnimationFrame(() => {
            formScrollRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }));
        } else if (isAuthenticated) {
          handleDirectOrder(zoomedItem, null);
        }
      }}
      disabled={
        (zoomedItem.isService ?
          (parseInt(zoomedItem.slots || 0) < 1 || orderQuantity > parseInt(zoomedItem.slots || 0)) :
          (parseInt(zoomedItem.quantity || 0) < 1 || orderQuantity > parseInt(zoomedItem.quantity || 0))
        ) || zoomedShopItems.some(s =>
          selectedSides.has(s.id) &&
          (s.customOptions || []).filter(o => o?.trim()).length > 0 &&
          !Object.values(sideItemOptions[s.id] || {}).some(q => q > 0)
        )
      }
      theme={currentStyle}
      style={{
        bottom: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        top: 'auto',
        right: 'auto',
        zIndex: 13
      }}
    >
      {(zoomedItem.isService ?
        parseInt(zoomedItem.slots || 0) :
        parseInt(zoomedItem.quantity || 0)) < 1 ? (
        <>
          <X size={14} />
          {zoomedItem.isService ? 'No Slots' : 'Out'}
        </>
      ) : zoomedItem.jobType === 'rides' ? (
        <>
          <ShoppingCart size={14} />
          <span className="price">
            Claim {zoomedItem.price ? ` · ${formatShopPrice(zoomedItem.price, zoomedItem.currency)}` : ''}
          </span>
        </>
      ) : zoomedItem.ctaStyle === 'signup' && zoomedItem.externalLink ? (
        <>
          <ShoppingCart size={14} />
          <span className="price">Sign Up</span>
        </>
      ) : (
        <>
          <ShoppingCart size={14} />
          <span className="price">
            {(() => {
              const isSvc = !!(zoomedItem.isService || zoomedItem.jobType || zoomedItem.serviceTab);
              // Services: once the fill-in form has computed a duration/date-aware total
              // (hourly × hours, daily × days, or flat), show that instead of a flat rate.
              if (isSvc && zoomedOrderTotal != null) {
                return formatShopPrice(zoomedOrderTotal, zoomedItem.currency);
              }
              const optQty = Object.values(selectedOptions).reduce((s, q) => s + q, 0);
              const mainQty = optQty > 0 ? optQty : orderQuantity;
              const mainTotal = parseFloat(zoomedItem.price || 0) * mainQty;
              const sidesTotal = [...selectedSides].reduce((sum, sideId) => {
                const si = zoomedShopItems.find(s => s.id === sideId);
                if (!si) return sum;
                const sideOpts = Object.fromEntries(Object.entries(sideItemOptions[sideId] || {}).filter(([, q]) => q > 0));
                const sideOptQty = Object.values(sideOpts).reduce((s, q) => s + q, 0);
                return sum + (parseFloat(si.price || 0) * (sideOptQty > 0 ? sideOptQty : 1));
              }, 0);
              const grandTotal = mainTotal + sidesTotal;
              const showCount = !isSvc && mainQty > 1 && selectedSides.size === 0;
              return `${showCount ? `${mainQty}× ` : ''}${formatShopPrice(grandTotal, zoomedItem.currency)}`;
            })()}
          </span>
        </>
      )}
    </OverlayOrderButton>
  )}

</MobileOverlayControls>
      </ImageCarousel>

      {/* Merged options panel — slides in below image when Info button is open */}
      {restaurantPanelOpen && (
        <div
          onClick={e => e.stopPropagation()}
          style={{
            maxHeight: '320px',
            overflow: 'auto',
            transition: 'max-height 0.35s ease',
            background: 'rgba(10,10,12,0.98)',
            borderTop: `1px solid ${currentStyle?.colors?.accent || '#800000'}35`,
            flexShrink: 0,
          }}
        >
          <div style={{ padding: '0.85rem 1rem', display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>

            {/* Description */}
            {zoomedItem.description && (
              <div>
                <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: currentStyle?.colors?.accent || '#800000', marginBottom: '0.35rem' }}>About</div>
                <div style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.5 }}>{zoomedItem.description}</div>
              </div>
            )}

            {/* Attributes (non-restaurant) */}
            {(zoomedItem.attributes || []).filter(a => a.values?.length > 0).length > 0 && zoomedItem.shopStoreType !== 'restaurant' && (
              <div>
                <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: currentStyle?.colors?.accent || '#800000', marginBottom: '0.4rem' }}>Select Options</div>
                {(zoomedItem.attributes || []).filter(a => a.values?.length > 0).map(attr => (
                  <div key={attr.name} style={{ marginBottom: '0.6rem' }}>
                    <div style={{ fontSize: '0.78rem', fontWeight: 600, color: 'rgba(255,255,255,0.75)', marginBottom: '0.3rem' }}>
                      {attr.name}
                      {selectedAttributes[attr.name] && (
                        <span style={{ marginLeft: '0.4rem', color: currentStyle?.colors?.accent || '#800000' }}>— {selectedAttributes[attr.name]}</span>
                      )}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
                      {attr.values.map(val => {
                        const selected = selectedAttributes[attr.name] === val;
                        const accent = currentStyle?.colors?.accent || '#800000';
                        return (
                          <button key={val}
                            onClick={() => setSelectedAttributes(prev => ({ ...prev, [attr.name]: prev[attr.name] === val ? '' : val }))}
                            style={{ padding: '0.3rem 0.75rem', borderRadius: '20px', fontSize: '0.82rem', cursor: 'pointer', border: selected ? `2px solid ${accent}` : '1px solid rgba(255,255,255,0.2)', background: selected ? `${accent}33` : 'rgba(255,255,255,0.05)', color: selected ? '#fff' : 'rgba(255,255,255,0.7)', fontWeight: selected ? 700 : 400, transition: 'all 0.15s' }}
                          >{val}</button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Custom options */}
            {(zoomedItem.customOptions || []).filter(o => o?.trim()).length > 0 && (
              <div>
                <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: currentStyle?.colors?.accent || '#800000', marginBottom: '0.35rem' }}>Options</div>
                {(zoomedItem.customOptions || []).filter(o => o?.trim()).map(opt => {
                  const qty = selectedOptions[opt] || 0;
                  const accent = currentStyle?.colors?.accent || '#800000';
                  return (
                    <div key={opt} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.28rem 0', fontSize: '0.88rem', color: '#fff' }}>
                      <span style={{ flex: 1 }}>{opt}</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                        <button onClick={() => setSelectedOptions(p => ({ ...p, [opt]: Math.max(0, (p[opt] || 0) - 1) }))}
                          style={{ width: 24, height: 24, borderRadius: '50%', border: `1px solid ${accent}60`, background: qty > 0 ? accent : 'transparent', color: '#fff', fontSize: '1rem', lineHeight: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>−</button>
                        <span style={{ minWidth: 16, textAlign: 'center', fontSize: '0.88rem' }}>{qty}</span>
                        <button onClick={() => setSelectedOptions(p => ({ ...p, [opt]: (p[opt] || 0) + 1 }))}
                          style={{ width: 24, height: 24, borderRadius: '50%', border: `1px solid ${accent}60`, background: accent, color: '#fff', fontSize: '1rem', lineHeight: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Add-on items */}
            {zoomedShopItems.length > 0 && (
              <div>
                <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: currentStyle?.colors?.accent || '#800000', marginBottom: '0.35rem' }}>{zoomedItem.shopStoreType === 'restaurant' ? 'Add Sides' : 'Add Items'}</div>
                {Object.entries(zoomedShopItems.reduce((acc, si) => { const c = si.category || 'Other'; if (!acc[c]) acc[c] = []; acc[c].push(si); return acc; }, {})).map(([cat, items]) => (
                  <div key={cat}>
                    <div style={{ fontSize: '0.68rem', opacity: 0.4, paddingLeft: '0.2rem', marginBottom: '0.1rem' }}>{cat}</div>
                    {items.map(si => {
                      const siOpts = (si.customOptions || []).filter(o => o?.trim());
                      return (
                        <div key={si.id}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.3rem 0', cursor: 'pointer', fontSize: '0.84rem', color: '#fff' }}>
                            <input type="checkbox" checked={selectedSides.has(si.id)}
                              onChange={() => {
                                setSelectedSides(prev => {
                                  const next = new Set(prev);
                                  if (next.has(si.id)) { next.delete(si.id); setSideItemOptions(p => { const n = { ...p }; delete n[si.id]; return n; }); }
                                  else { next.add(si.id); }
                                  return next;
                                });
                              }}
                              style={{ accentColor: currentStyle?.colors?.accent || '#800000' }} />
                            <span style={{ flex: 1 }}>{si.name}</span>
                            {si.price && <span style={{ opacity: 0.55, fontSize: '0.75rem' }}>+${parseFloat(si.price).toFixed(2)}</span>}
                            {selectedSides.has(si.id) && siOpts.length > 0 && !Object.values(sideItemOptions[si.id] || {}).some(q => q > 0) && (
                              <span style={{ fontSize: '0.68rem', color: '#ff6b6b', fontWeight: 600 }}>required</span>
                            )}
                          </label>
                          {selectedSides.has(si.id) && siOpts.length > 0 && (
                            <div style={{ paddingLeft: '1.6rem', marginBottom: '0.2rem' }}>
                              {siOpts.map(opt => {
                                const qty = (sideItemOptions[si.id] || {})[opt] || 0;
                                const accent = currentStyle?.colors?.accent || '#800000';
                                return (
                                  <div key={opt} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.15rem 0', fontSize: '0.8rem', color: '#fff' }}>
                                    <span style={{ flex: 1, opacity: qty > 0 ? 1 : 0.65 }}>{opt}</span>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                                      <button onClick={() => setSideItemOptions(p => ({ ...p, [si.id]: { ...(p[si.id] || {}), [opt]: Math.max(0, ((p[si.id] || {})[opt] || 0) - 1) } }))}
                                        style={{ width: 20, height: 20, borderRadius: '50%', border: `1px solid ${accent}60`, background: qty > 0 ? accent : 'transparent', color: '#fff', fontSize: '0.9rem', lineHeight: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>−</button>
                                      <span style={{ minWidth: 14, textAlign: 'center', fontSize: '0.8rem' }}>{qty}</span>
                                      <button onClick={() => setSideItemOptions(p => ({ ...p, [si.id]: { ...(p[si.id] || {}), [opt]: ((p[si.id] || {})[opt] || 0) + 1 } }))}
                                        style={{ width: 20, height: 20, borderRadius: '50%', border: `1px solid ${accent}60`, background: accent, color: '#fff', fontSize: '0.9rem', lineHeight: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            )}

            {/* Special instructions — shown when there are options/sides */}
            {((zoomedItem.customOptions || []).filter(o => o?.trim()).length > 0 || zoomedShopItems.length > 0) && (
              <div>
                <div style={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: currentStyle?.colors?.accent || '#800000', marginBottom: '0.25rem' }}>Special Instructions</div>
                <textarea placeholder="Allergies, preferences, notes… (max 150)" maxLength={150} value={specialInstructions}
                  onChange={e => setSpecialInstructions(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', background: 'rgba(255,255,255,0.06)', border: `1px solid ${currentStyle?.colors?.accent || '#800000'}30`, borderRadius: '6px', padding: '0.45rem 0.65rem', color: '#fff', fontSize: '0.8rem', resize: 'none', height: '56px' }}
                />
                <div style={{ fontSize: '0.68rem', opacity: 0.38, textAlign: 'right' }}>{specialInstructions.length}/150</div>
              </div>
            )}

          </div>
        </div>
      )}

      {/* Job / Ride info panel — slides in below image when info button is tapped */}
      {jobInfoPanelOpen && zoomedItem.jobType && (() => {
        const jt = zoomedItem.jobType;
        const accent = currentStyle?.colors?.accent || '#800000';
        const enc = encodeURIComponent;
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        const addr1 = s => s ? s.split(',')[0] : null;
        const fmtDT = v => { if (!v) return null; try { return new Date(v).toLocaleString([], { month:'short', day:'numeric', hour:'2-digit', minute:'2-digit' }); } catch { return null; } };
        const fmtD = v => { if (!v) return null; try { return new Date(v+'T00:00').toLocaleDateString([], { month:'short', day:'numeric', year:'numeric' }); } catch { return null; } };
        const haversine = (a, b) => { if (!a?.lat || !b?.lat) return null; const R=3958.8, dLat=(b.lat-a.lat)*Math.PI/180, dLng=(b.lng-a.lng)*Math.PI/180, s=Math.sin(dLat/2)**2+Math.cos(a.lat*Math.PI/180)*Math.cos(b.lat*Math.PI/180)*Math.sin(dLng/2)**2; return (2*R*Math.asin(Math.sqrt(s))).toFixed(1); };
        const routeUrl = (fromCoord, fromAddr, toCoord, toAddr) => { const f = fromCoord?.lat ? `${fromCoord.lat},${fromCoord.lng}` : enc(fromAddr||''); const t = toCoord?.lat ? `${toCoord.lat},${toCoord.lng}` : enc(toAddr||''); return isIOS ? `maps://maps.apple.com/?saddr=${f}&daddr=${t}&dirflg=d` : `https://www.google.com/maps/dir/?api=1&origin=${f}&destination=${t}&travelmode=driving`; };
        const placeUrl = addr => isIOS ? `maps://maps.apple.com/?q=${enc(addr)}` : `https://www.google.com/maps/search/?api=1&query=${enc(addr)}`;

        const JOB_LABELS = { moving:'Moving',delivery:'Delivery',home_repair:'Home Repair',cleaning:'Cleaning',handyman:'Handyman',beauty:'Beauty',tech:'Tech Help',pet_care:'Pet Care',tutoring:'Tutoring',events:'Events',other:'Job',rides:'Ride' };
        const JOB_ICONS = { moving:'📦',delivery:'🚚',home_repair:'🔧',cleaning:'🧹',handyman:'🛠️',beauty:'💇',tech:'💻',pet_care:'🐾',tutoring:'📚',events:'🎉',other:'💼',rides:'🚗' };

        const Row = ({ icon, label, value }) => value ? (
          <div style={{ display:'flex', gap:'0.6rem', alignItems:'flex-start', padding:'0.45rem 0', borderBottom:`1px solid rgba(255,255,255,0.06)` }}>
            <span style={{ fontSize:'1rem', flexShrink:0, width:'1.4rem', textAlign:'center' }}>{icon}</span>
            <div style={{ flex:1 }}>
              {label && <div style={{ fontSize:'0.65rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.05em', color:accent, marginBottom:'0.1rem', opacity:0.85 }}>{label}</div>}
              <div style={{ fontSize:'0.88rem', color:'rgba(255,255,255,0.9)', lineHeight:1.45 }}>{value}</div>
            </div>
          </div>
        ) : null;

        const RouteBlock = ({ fromAddr, toAddr, fromCoord, toCoord, navLabel }) => {
          const hasRoute = fromAddr || toAddr;
          if (!hasRoute) return null;
          const navHref = routeUrl(fromCoord, fromAddr, toCoord, toAddr);
          return (
            <div style={{ background:'rgba(255,255,255,0.05)', borderRadius:10, padding:'0.65rem 0.85rem', marginBottom:'0.5rem' }}>
              <div style={{ display:'flex', flexDirection:'column', gap:'0.3rem', marginBottom:'0.5rem' }}>
                {fromAddr && <div style={{ display:'flex', alignItems:'center', gap:'0.5rem', fontSize:'0.85rem', color:'rgba(255,255,255,0.88)' }}><span style={{ color:'#4ade80', fontSize:'0.55rem' }}>●</span><span>{addr1(fromAddr)}</span></div>}
                {fromAddr && toAddr && <div style={{ paddingLeft:'0.85rem', color:'rgba(255,255,255,0.2)', fontSize:'0.75rem' }}>↓</div>}
                {toAddr && <div style={{ display:'flex', alignItems:'center', gap:'0.5rem', fontSize:'0.85rem', color:'rgba(255,255,255,0.88)' }}><span style={{ color:'#f87171', fontSize:'0.55rem' }}>■</span><span>{addr1(toAddr)}</span></div>}
              </div>
              <a href={navHref} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()} style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'0.4rem', padding:'0.4rem 0.75rem', borderRadius:8, background:`${accent}22`, border:`1px solid ${accent}55`, color:accent, textDecoration:'none', fontSize:'0.78rem', fontWeight:700 }}>
                <Navigation size={12}/>{navLabel || 'Open in Maps'}
              </a>
            </div>
          );
        };

        const dist = (jt === 'rides' || jt === 'moving') ? haversine(zoomedItem.pickupCoordinates, zoomedItem.destinationCoordinates) : jt === 'delivery' ? haversine(zoomedItem.pickupCoordinates, zoomedItem.deliveryCoordinates) : null;

        return (
          <div onClick={e=>e.stopPropagation()} style={{ maxHeight:'360px', overflow:'auto', background:'rgba(10,10,12,0.98)', borderTop:`1px solid ${accent}35`, flexShrink:0 }}>
            <div style={{ padding:'0.9rem 1rem 1rem' }}>
              {/* Header */}
              <div style={{ display:'flex', alignItems:'center', gap:'0.5rem', marginBottom:'0.75rem', paddingBottom:'0.6rem', borderBottom:`1px solid rgba(255,255,255,0.1)` }}>
                <span style={{ fontSize:'1.2rem' }}>{JOB_ICONS[jt]}</span>
                <div>
                  <div style={{ fontSize:'1rem', fontWeight:700, color:'#fff', lineHeight:1.2 }}>{zoomedItem.name}</div>
                  <div style={{ fontSize:'0.72rem', color:accent, fontWeight:600, textTransform:'uppercase', letterSpacing:'0.04em' }}>{JOB_LABELS[jt]}</div>
                </div>
                {zoomedItem.price && <div style={{ marginLeft:'auto', fontSize:'1rem', fontWeight:800, color:'#4ade80' }}>${zoomedItem.price}{zoomedItem.serviceTab==='need' ? ' pay' : ''}</div>}
              </div>

              {/* Ride */}
              {jt === 'rides' && (<>
                <RouteBlock fromAddr={zoomedItem.pickupAddress} toAddr={zoomedItem.destinationAddress} fromCoord={zoomedItem.pickupCoordinates} toCoord={zoomedItem.destinationCoordinates} navLabel="Get Directions" />
                <Row icon="📅" label="Date & Time" value={fmtDT(zoomedItem.rideDateTime)} />
                <Row icon="🚗" label="Vehicle" value={({sedan:'Sedan',suv:'SUV',van:'Van / Minivan',limo:'Limousine',luxury:'Luxury',truck:'Pickup Truck',any:'Any Vehicle'})[zoomedItem.vehicleType] || (zoomedItem.vehicleType && zoomedItem.vehicleType !== 'any' ? zoomedItem.vehicleType : null)} />
                <Row icon="👥" label="Passengers" value={zoomedItem.passengers > 1 ? `${zoomedItem.passengers} passengers` : null} />
                <Row icon="🛣️" label="Distance" value={dist ? `~${dist} mi` : (zoomedItem.estimatedDistance ? `~${zoomedItem.estimatedDistance} mi` : null)} />
              </>)}

              {/* Moving */}
              {jt === 'moving' && (<>
                <RouteBlock fromAddr={zoomedItem.pickupAddress} toAddr={zoomedItem.destinationAddress} fromCoord={zoomedItem.pickupCoordinates} toCoord={zoomedItem.destinationCoordinates} navLabel="View Move Route" />
                <Row icon="📅" label="Move Date" value={fmtD(zoomedItem.moveDate)} />
                <Row icon="📦" label="Load Size" value={({small:'Small (few boxes)',moderate:'Moderate (1-BR)',large:'Large (2–3 BR)','full-house':'Full house'})[zoomedItem.estimatedLoad]} />
                <Row icon="🛣️" label="Distance" value={dist ? `~${dist} mi` : null} />
                {zoomedItem.hasHeavyItems && <Row icon="🏋️" label="Note" value="Has heavy / special items" />}
                {zoomedItem.packingHelp && <Row icon="📦" label="Note" value="Packing help needed" />}
              </>)}

              {/* Delivery */}
              {jt === 'delivery' && (<>
                <RouteBlock fromAddr={zoomedItem.pickupAddress} toAddr={zoomedItem.deliveryAddress} fromCoord={zoomedItem.pickupCoordinates} toCoord={zoomedItem.deliveryCoordinates} navLabel="View Delivery Route" />
                <Row icon="⏰" label="Deliver By" value={fmtDT(zoomedItem.deliveryByDateTime)} />
                <Row icon="📏" label="Item Size" value={({small:'Small (bag/envelope)',medium:'Medium (box)',large:'Large (furniture)',oversized:'Oversized'})[zoomedItem.itemSize]} />
                <Row icon="📦" label="Item" value={zoomedItem.itemDescription} />
                {zoomedItem.fragile && <Row icon="⚠️" label="Note" value="Fragile — handle with care" />}
              </>)}

              {/* Home Repair */}
              {jt === 'home_repair' && (<>
                <Row icon="📍" label="Location" value={addr1(zoomedItem.serviceAddress)} />
                <Row icon="📅" label="Date & Time" value={fmtDT(zoomedItem.serviceDateTime)} />
                <Row icon="🔨" label="Scope" value={({minor:'Minor fix',moderate:'Moderate work',major:'Major work'})[zoomedItem.jobScope]} />
                <Row icon="⚡" label="Urgency" value={({asap:'ASAP','within-week':'Within a week'})[zoomedItem.urgency] || (zoomedItem.urgency === 'flexible' ? null : zoomedItem.urgency)} />
                <Row icon="🔑" label="Access" value={zoomedItem.accessInstructions} />
                {zoomedItem.materialsIncluded && <Row icon="✅" label="Materials" value="Materials included" />}
              </>)}

              {/* Cleaning */}
              {jt === 'cleaning' && (<>
                <Row icon="📍" label="Location" value={addr1(zoomedItem.serviceAddress)} />
                <Row icon="📅" label="Date & Time" value={fmtDT(zoomedItem.serviceDateTime)} />
                <Row icon="🏠" label="Property" value={`${({house:'House',apartment:'Apartment',office:'Office',commercial:'Commercial'})[zoomedItem.propertyType] || ''}${zoomedItem.bedrooms ? ` · ${zoomedItem.bedrooms} bed` : ''}${zoomedItem.bathrooms ? ` / ${zoomedItem.bathrooms} bath` : ''}`} />
                <Row icon="🔁" label="Frequency" value={({weekly:'Weekly','bi-weekly':'Bi-weekly',monthly:'Monthly'})[zoomedItem.frequency] || (zoomedItem.frequency === 'one-time' ? null : zoomedItem.frequency)} />
                <Row icon="🧴" label="Supplies" value={({provider:'Supplies included',client:'Client provides supplies',both:'Supplies shared'})[zoomedItem.suppliesProvided]} />
              </>)}

              {/* Handyman */}
              {jt === 'handyman' && (<>
                <Row icon="📍" label="Location" value={addr1(zoomedItem.serviceAddress)} />
                <Row icon="📅" label="Date & Time" value={fmtDT(zoomedItem.serviceDateTime)} />
                <Row icon="⚡" label="Urgency" value={({asap:'ASAP','within-week':'Within a week'})[zoomedItem.urgency] || (zoomedItem.urgency === 'flexible' ? null : zoomedItem.urgency)} />
                <Row icon="⏱️" label="Est. Duration" value={zoomedItem.estimatedHours ? `~${zoomedItem.estimatedHours} hr${zoomedItem.estimatedHours > 1 ? 's' : ''}` : null} />
                {zoomedItem.toolsProvided && <Row icon="🧰" label="Tools" value="Tools included" />}
              </>)}

              {/* Beauty */}
              {jt === 'beauty' && (<>
                <Row icon="✂️" label="Service" value={({haircut:'Haircut',coloring:'Hair Coloring',styling:'Styling',nails:'Nails',pedicure:'Pedicure',makeup:'Makeup',waxing:'Waxing',lashes:'Lashes / Brows',other:'Other'})[zoomedItem.beautyServiceType]} />
                <Row icon="📍" label="Location" value={({'home-visit':'Home Visit (I come to you)',studio:'Studio / Salon','client-home':'Your Location'})[zoomedItem.serviceLocation]} />
                <Row icon="📅" label="Date & Time" value={fmtDT(zoomedItem.serviceDateTime)} />
                <Row icon="⏱️" label="Duration" value={zoomedItem.duration ? `~${zoomedItem.duration} hr${zoomedItem.duration > 1 ? 's' : ''}` : null} />
              </>)}

              {/* Tech */}
              {jt === 'tech' && (<>
                <Row icon="💻" label="Device" value={`${({laptop:'Laptop',desktop:'Desktop',phone:'Smartphone',tablet:'Tablet','smart-home':'Smart Home',network:'Network',other:'Device'})[zoomedItem.deviceType] || ''}${zoomedItem.os && zoomedItem.os !== 'other' ? ` · ${zoomedItem.os.toUpperCase()}` : ''}`} />
                <Row icon="🔧" label="Service Mode" value={({'in-person':'In-person',remote:'Remote / Online',either:'In-person or remote'})[zoomedItem.serviceMode]} />
                <Row icon="⚡" label="Urgency" value={({asap:'ASAP','within-week':'Within a week'})[zoomedItem.urgency] || (zoomedItem.urgency === 'flexible' ? null : zoomedItem.urgency)} />
                {zoomedItem.serviceMode !== 'remote' && <Row icon="📍" label="Location" value={addr1(zoomedItem.serviceAddress)} />}
              </>)}

              {/* Pet Care */}
              {jt === 'pet_care' && (<>
                <Row icon={({dog:'🐶',cat:'🐱',bird:'🐦',reptile:'🦎',other:'🐾'})[zoomedItem.petType]||'🐾'} label="Pet" value={zoomedItem.petBreed || ({dog:'Dog',cat:'Cat',bird:'Bird',reptile:'Reptile',other:'Pet'})[zoomedItem.petType]} />
                <Row icon="🛠️" label="Service" value={({walking:'Dog Walking',sitting:'Pet Sitting',boarding:'Boarding',grooming:'Grooming',training:'Training','vet-transport':'Vet Transport'})[zoomedItem.petServiceType]} />
                <Row icon="📅" label="Date & Time" value={fmtDT(zoomedItem.serviceDateTime)} />
                <Row icon="⏱️" label="Duration" value={zoomedItem.serviceDuration ? `${zoomedItem.serviceDuration} hr${zoomedItem.serviceDuration > 1 ? 's' : ''}` : null} />
                <Row icon="⚠️" label="Special Needs" value={zoomedItem.specialNeeds} />
              </>)}

              {/* Tutoring */}
              {jt === 'tutoring' && (<>
                <Row icon="📖" label="Subject" value={zoomedItem.subject} />
                <Row icon="🎓" label="Grade Level" value={({elementary:'Elementary',middle:'Middle School',high:'High School',college:'College',adult:'Adult Learner'})[zoomedItem.gradeLevel]} />
                <Row icon="💻" label="Session Mode" value={({'in-person':'In-person',online:'Online',either:'In-person or Online'})[zoomedItem.sessionMode]} />
                <Row icon="⏱️" label="Session Length" value={({'30min':'30 minutes','1hr':'1 hour','2hr':'2 hours',custom:'Custom'})[zoomedItem.sessionDuration]} />
                <Row icon="🗓️" label="Availability" value={zoomedItem.preferredSchedule} />
              </>)}

              {/* Events */}
              {jt === 'events' && (<>
                <Row icon="🎊" label="Event Type" value={({birthday:'Birthday',wedding:'Wedding',corporate:'Corporate Event',graduation:'Graduation',babyshower:'Baby Shower',other:'Special Event'})[zoomedItem.eventType]} />
                <Row icon="📍" label="Venue" value={zoomedItem.eventAddress} />
                <Row icon="📅" label="Event Date" value={fmtD(zoomedItem.eventDate)} />
                <Row icon="👥" label="Guests" value={zoomedItem.guestCount ? `${zoomedItem.guestCount} guests` : null} />
                <Row icon="⏱️" label="Duration" value={zoomedItem.eventDuration ? `${zoomedItem.eventDuration} hrs` : null} />
                {(zoomedItem.servicesNeeded?.length > 0) && <Row icon="🛎️" label="Services Needed" value={zoomedItem.servicesNeeded.map(s => ({catering:'Catering',photography:'Photography',videography:'Videography',setup:'Setup',cleanup:'Cleanup',entertainment:'Entertainment',decoration:'Decoration',security:'Security'})[s]||s).join(', ')} />}
                {zoomedItem.eventAddress && <div style={{ marginTop:'0.4rem' }}><a href={placeUrl(zoomedItem.eventAddress)} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()} style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:'0.4rem', padding:'0.4rem 0.75rem', borderRadius:8, background:`${accent}22`, border:`1px solid ${accent}55`, color:accent, textDecoration:'none', fontSize:'0.78rem', fontWeight:700 }}><Navigation size={12}/>View Venue on Map</a></div>}
              </>)}

              {/* Other */}
              {jt === 'other' && (<>
                <Row icon="📍" label="Location" value={addr1(zoomedItem.serviceAddress)} />
                <Row icon="📅" label="Date & Time" value={fmtDT(zoomedItem.serviceDateTime)} />
                <Row icon="⚡" label="Urgency" value={({asap:'ASAP','within-week':'Within a week'})[zoomedItem.urgency] || (zoomedItem.urgency === 'flexible' ? null : zoomedItem.urgency)} />
                <Row icon="⏱️" label="Duration" value={zoomedItem.estimatedDuration} />
              </>)}

              {/* Description */}
              {zoomedItem.description && (
                <div style={{ marginTop:'0.6rem', paddingTop:'0.6rem', borderTop:`1px solid rgba(255,255,255,0.08)` }}>
                  <div style={{ fontSize:'0.65rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.05em', color:accent, marginBottom:'0.35rem', opacity:0.85 }}>Details</div>
                  <div style={{ fontSize:'0.88rem', color:'rgba(255,255,255,0.82)', lineHeight:1.55 }}>{zoomedItem.description}</div>
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Order form — appended below image, ZoomContainer scrolls to it */}
      <div ref={formScrollRef}>
        <OrderFormPanel
          mode="inline"
          item={zoomedItem}
          isAuthenticated={isAuthenticated}
          visible={showZoomedOrderForm}
          onClose={() => setShowZoomedOrderForm(false)}
          onSubmit={(formData) => handleDirectOrder(zoomedItem, formData)}
          onTotalChange={setZoomedOrderTotal}
          onGuestSubmit={(formData) => handleGuestOrder(zoomedItem, formData)}
          guestCheckoutFields={zoomedItem?.shopGuestCheckoutFields}
          onGoogleSubmit={() => {
            setShowZoomedOrderForm(false);
            handleGoogleSignIn();
          }}
          theme={currentStyle}
        />
      </div>

      {/* DESKTOP NAVIGATION - Bottom Button (position:fixed — outside flex flow) */}
      <DesktopNavigationButton
        className="bottom"
        theme={currentStyle}
        onClick={(e) => {
          e.stopPropagation();
          handleNextItem();
        }}
        disabled={(() => {
          const allItems = getAllItemsFromCurrentTab();
          const currentIndex = allItems.findIndex(item =>
            item.id === zoomedItem?.id && item.shopId === zoomedItem?.shopId
          );
          return currentIndex === allItems.length - 1;
        })()}
        title="Next item (↓)"
      >
        <ChevronDown size={24} />
      </DesktopNavigationButton>

      
    </ZoomContainer>
  </ZoomOverlay>
)}
      {/* Chat Overlay */}
      <ChatOverlay isOpen={chatOpen} onClick={handleCloseChat} />
      
      {selectedChatItem && (
        <OrderChat
          isOpen={chatOpen}
          onClose={handleCloseChat}
          item={selectedChatItem}
          shopId={selectedChatItem.shopId}
          shopName={selectedChatItem.shopName}
          theme={currentStyle}
        />
      )}

      {/* Shop Items Overlay */}
      {shopOverlay && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 9000,
            background: 'rgba(0,0,0,0.88)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
          onClick={e => { if (e.target === e.currentTarget) setShopOverlay(null); }}
        >
          {/* Header */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '1rem 1.25rem',
            background: `${currentStyle?.colors?.surface || '#1e1e2e'}ee`,
            borderBottom: `1px solid ${currentStyle?.colors?.accent || '#6366f1'}30`,
            flexShrink: 0,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              {shopOverlay.shopProfilePicture && (
                <img
                  src={typeof shopOverlay.shopProfilePicture === 'string' ? shopOverlay.shopProfilePicture : shopOverlay.shopProfilePicture?.preview}
                  alt={shopOverlay.shopName}
                  style={{ width: '38px', height: '38px', borderRadius: '50%', objectFit: 'cover', border: `2px solid ${currentStyle?.colors?.accent || '#6366f1'}50` }}
                />
              )}
              <div>
                <div style={{ fontWeight: '700', fontSize: '1rem', color: currentStyle?.colors?.text || '#fff', fontFamily: currentStyle?.fonts?.body }}>
                  {shopOverlay.shopName}
                </div>
                {shopOverlay.shopDescription && (
                  <div style={{ fontSize: '0.75rem', color: currentStyle?.colors?.text || '#fff', opacity: 0.55, fontFamily: currentStyle?.fonts?.body }}>
                    {shopOverlay.shopDescription}
                  </div>
                )}
              </div>
            </div>
            <button
              onClick={() => setShopOverlay(null)}
              style={{
                background: `${currentStyle?.colors?.accent || '#6366f1'}22`,
                border: `1px solid ${currentStyle?.colors?.accent || '#6366f1'}40`,
                color: currentStyle?.colors?.text || '#fff',
                borderRadius: '50%', width: '36px', height: '36px',
                cursor: 'pointer', fontSize: '1.1rem', fontWeight: '700',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              ✕
            </button>
          </div>

          {/* Scroll wrapper — fills all space below header, scrolls independently */}
          <div style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'scroll',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
          }}>
            {/* Grid expands freely — NOT constrained to window height */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: window.innerWidth <= 768 ? 'repeat(2, 1fr)' : 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: window.innerWidth <= 480 ? '0.5rem' : '0.75rem',
              padding: '1rem',
              paddingBottom: '3rem',
            }}>
              {shopOverlay.items.map(item => (
                <FeaturedItem
                  key={item.id}
                  item={{ ...item, isFollowing: followedShops.has(item.shopId), isFollowLoading: followLoading.has(item.shopId) }}
                  theme={currentStyle}
                  onItemClick={(clicked) => { setShopOverlay(null); handleItemClick(clicked); }}
                  onLikeClick={handleLikeClick}
                  onFollowToggle={handleFollowToggle}
                  columns={window.innerWidth <= 768 ? 2 : 3}
                  onAddToCart={(cartItem) => {
                    if ((cartItem.customOptions || []).filter(o => o?.trim()).length > 0) {
                      handleItemClick(cartItem);
                      setTimeout(() => setRestaurantPanelOpen(true), 350);
                      return;
                    }
                    const existingItem = cartItems.find(ci => ci.id === cartItem.id && ci.shopId === cartItem.shopId);
                    if (existingItem) {
                      setCartItems(cartItems.map(ci => ci.id === cartItem.id && ci.shopId === cartItem.shopId ? { ...ci, cartQuantity: ci.cartQuantity + 1 } : ci));
                    } else {
                      setCartItems([...cartItems, { ...cartItem, cartQuantity: 1 }]);
                    }
                    setShowCartDropdown(true);
                  }}
                  isAuthenticated={isAuthenticated}
                  showTopBar={false}
                  showDistance={false}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <TreasureMap
  isOpen={mapOpen}
  onClose={() => setMapOpen(false)}
  items={allMapProducts}
  services={allMapServices}
  userLocation={effectiveLocation}
  theme={currentStyle}
  onItemClick={handleItemClick}
  onLikeClick={handleLikeClick}
  isAuthenticated={isAuthenticated}
  onRequestLocation={handleMapGPSUpdate} // ✅ Use new GPS handler
/>

{/* Loading spinner replaced by skeleton cards inside ProductsTab */}

{/* Brand name modal */}
{showBrandModal && (
  <div
    onClick={() => setShowBrandModal(false)}
    style={{
      position: 'fixed', inset: 0, zIndex: 9000,
      background: 'rgba(0,0,0,0.65)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      animation: 'fadeIn 0.18s ease',
      padding: '1rem',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: currentStyle?.colors?.backdropColor || 'rgba(15,15,30,0.97)',
        border: `1px solid ${currentStyle?.colors?.accent || '#800000'}40`,
        borderRadius: 18,
        padding: '2rem 1.75rem 1.75rem',
        width: '100%', maxWidth: 380,
        boxShadow: `0 24px 60px rgba(0,0,0,0.6), 0 0 0 1px ${currentStyle?.colors?.accent || '#800000'}20`,
        animation: 'slideUp 0.2s cubic-bezier(0.34,1.56,0.64,1)',
        display: 'flex', flexDirection: 'column', gap: '1rem',
      }}
    >
      {/* Logo upload + title */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.65rem' }}>
        {/* Logo circle */}
        <label htmlFor="brand-logo-input" style={{ cursor: 'pointer', display: 'block' }}>
          <div style={{
            width: 80, height: 80, borderRadius: '50%',
            border: `2.5px dashed ${currentStyle?.colors?.accent || '#800000'}`,
            background: brandLogoPreview ? 'transparent' : `${currentStyle?.colors?.accent || '#800000'}12`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            overflow: 'hidden', position: 'relative',
            transition: 'border-color 0.2s, background 0.2s',
          }}>
            {brandLogoPreview
              ? <img src={brandLogoPreview} alt="Logo preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              : <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={currentStyle?.colors?.accent || '#800000'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                  <circle cx="12" cy="13" r="4"/>
                </svg>
            }
            {/* Hover overlay */}
            <div style={{
              position: 'absolute', inset: 0, borderRadius: '50%',
              background: 'rgba(0,0,0,0.35)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              opacity: brandLogoPreview ? 0 : 0,
              transition: 'opacity 0.2s',
            }} className="logo-hover-overlay" />
          </div>
          <input
            id="brand-logo-input"
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={e => {
              const file = e.target.files?.[0];
              if (!file) return;
              setBrandLogoFile(file);
              const url = URL.createObjectURL(file);
              if (brandLogoPreview) URL.revokeObjectURL(brandLogoPreview);
              setBrandLogoPreview(url);
            }}
          />
        </label>
        <div style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.35)' }}>Logo <span style={{ opacity: 0.6 }}>(optional)</span></div>
        <div style={{ fontFamily: currentStyle?.fonts?.heading || 'inherit', fontSize: '1.05rem', fontWeight: 700, color: currentStyle?.colors?.accent || '#fff' }}>
          Brand Name:
        </div>
      </div>

      {/* Input */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
        <input
          autoFocus={window.innerWidth > 768}
          type="text"
          placeholder="e.g. Htown Kitchen"
          value={brandNameInput}
          maxLength={50}
          onChange={e => { setBrandNameInput(e.target.value); setBrandNameError(''); }}
          onKeyDown={e => { if (e.key === 'Enter') handleBrandNameSubmit(); }}
          style={{
            background: 'rgba(255,255,255,0.06)',
            border: `1.5px solid ${brandNameError ? '#f87171' : brandNameInput.trim() ? (currentStyle?.colors?.accent || '#800000') + '80' : 'rgba(255,255,255,0.12)'}`,
            borderRadius: 10,
            padding: '0.75rem 1rem',
            fontSize: '0.95rem',
            color: '#fff',
            outline: 'none',
            width: '100%',
            boxSizing: 'border-box',
            transition: 'border-color 0.2s',
            fontFamily: currentStyle?.fonts?.body || 'inherit',
          }}
        />
        {brandNameInput.trim() && !brandNameError && (
          <div style={{ fontSize: '0.72rem', color: 'rgba(255,255,255,0.3)' }}>
            @{brandNameInput.trim().toLowerCase().replace(/[^a-z0-9]/g, '') || '…'}
          </div>
        )}
        {brandNameError && (
          <div style={{ fontSize: '0.76rem', color: '#f87171', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
            ⚠ {brandNameError}
          </div>
        )}
      </div>

      {/* Save with Google button */}
      <button
        onClick={handleBrandNameSubmit}
        disabled={brandNameChecking}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem',
          background: brandNameChecking
            ? 'rgba(255,255,255,0.07)'
            : `linear-gradient(135deg, ${currentStyle?.colors?.accent || '#800000'}, ${currentStyle?.colors?.accent || '#800000'}cc)`,
          border: 'none', borderRadius: 10, padding: '0.8rem 1.25rem',
          color: '#fff', fontSize: '0.9rem', fontWeight: 700, cursor: brandNameChecking ? 'not-allowed' : 'pointer',
          opacity: brandNameChecking ? 0.5 : 1,
          transition: 'all 0.2s',
          width: '100%',
        }}
      >
        {brandNameChecking ? (
          <>Checking name…</>
        ) : (
          <>
            <img src="https://cdn.cdnlogo.com/logos/g/35/google-icon.svg" alt="Google" style={{ width: 18, height: 18 }} />
            {brandNameInput.trim() ? 'Save with Google' : 'Continue with Google'}
          </>
        )}
      </button>

      <button
        onClick={() => setShowBrandModal(false)}
        style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.3)', fontSize: '0.78rem', cursor: 'pointer', textAlign: 'center', padding: 0 }}
      >
        Cancel
      </button>
    </div>
  </div>
)}

{showGuestInfoModal && pendingGuestOrder && (
  <GuestInfoModal
    isOpen={showGuestInfoModal}
    onClose={() => {
      setShowGuestInfoModal(false);
      setPendingGuestOrder(null);
    }}
    onSubmit={handleGuestInfoSubmit}
    theme={currentStyle}
    item={zoomedItem}
  />
)}

{/* Footer */}
<Footer theme={currentStyle} $isAuthenticated={isAuthenticated}>
  <FooterContent>
    <FooterSection theme={currentStyle}>
      <h4>Contact</h4>
      <ContactLinks theme={currentStyle}>
        <a href="mailto:kalskode@gmail.com">
          <Mail size={18} />
          kalskode@gmail.com
        </a>
        <a href="https://www.instagram.com/kalskode/" target="_blank" rel="noopener noreferrer">
          <Instagram size={18} />
          Instagram
        </a>
      </ContactLinks>
    </FooterSection>
    
    <FooterSection theme={currentStyle}>
      <LegalLinks theme={currentStyle}>
        <button onClick={() => setShowTerms(true)}>
          Terms of Service
        </button>
        <button onClick={() => setShowTerms(true)}>
          Privacy Policy
        </button>
      </LegalLinks>
    </FooterSection>
  </FooterContent>
  
  <Copyright theme={currentStyle}>
    © {new Date().getFullYear()} KalKode. All rights reserved.
  </Copyright>
</Footer>


{/* Terms of Service Modal */}
<TermsOverlay isOpen={showTerms} onClick={() => setShowTerms(false)}>
  <TermsContainer theme={currentStyle} onClick={(e) => e.stopPropagation()}>
    <TermsHeader theme={currentStyle}>
      <h2>Terms of Service & Privacy Policy</h2>
      <button onClick={() => setShowTerms(false)} aria-label="Close">
        <X size={24} />
      </button>
    </TermsHeader>
    <TermsContent theme={currentStyle}>
      <h1>🌐 KalKode — Terms of Service</h1>
      <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>
      
      <p>Welcome to KalKode, a platform designed for neighbors, local communities, and businesses to list items, services, jobs, and events for local trade and connection.</p>
      
      <p>By accessing or using KalKode ("Platform," "Service"), you ("User") agree to be bound by these Terms of Service ("Terms"). If you do not agree, do not use KalKode.</p>
      
      <h2>1. Definitions</h2>
      <ul>
        <li><strong>"User"</strong> — Any individual or entity using the platform.</li>
        <li><strong>"Personal User"</strong> — A non-business user accessing free or low-volume features.</li>
        <li><strong>"Business User"</strong> — A user operating a shop, service, or event with higher activity (subject to business-tier pricing).</li>
        <li><strong>"Listing"</strong> — Any item, service, job, or event posted to KalKode.</li>
        <li><strong>"Content"</strong> — Any text, photo, video, or data posted by a user.</li>
        <li><strong>"KalKode" / "We" / "Our"</strong> — The company operating the platform.</li>
      </ul>
      
      <h2>2. Eligibility</h2>
      <p>You must:</p>
      <ul>
        <li>Be at least 18 years old, or the legal age in your jurisdiction.</li>
        <li>Have the authority to enter into a contract if representing a business.</li>
        <li>Use the platform in compliance with all local, national, and international laws.</li>
      </ul>
      <p>Users under 18 may not create accounts or use services involving payments, trading, or meetups.</p>
      
      <h2>3. Description of Services</h2>
      <p>KalKode provides:</p>
      <ul>
        <li>A local listing platform for goods, rentals, services, and events.</li>
        <li>Communication tools between users.</li>
        <li>Navigation/map-based discovery and local pickup coordination.</li>
        <li>Optional business tools for shops and organizations.</li>
      </ul>
      <p>KalKode is not a party to transactions between users and does not own, inspect, or guarantee any items or services.</p>
      
      <h2>4. Account Registration and Security</h2>
      <p>Users agree to:</p>
      <ul>
        <li>Provide accurate and updated information.</li>
        <li>Maintain the confidentiality of passwords and devices.</li>
        <li>Notify us immediately of unauthorized activity.</li>
      </ul>
      <p>KalKode may suspend or terminate accounts for: Fraud, Abuse, Dangerous or illegal conduct, or Violations of these Terms.</p>
      
      <h2>5. Acceptable Use & Community Rules</h2>
      <p>Users must NOT:</p>
      <ul>
        <li>List illegal, hazardous, stolen, or regulated goods.</li>
        <li>Post offensive, hateful, explicit, or harmful content.</li>
        <li>Harass, scam, or mislead other users.</li>
        <li>Circumvent fees or platform systems.</li>
        <li>Engage in dangerous acts, unsafe meetups, or prohibited services.</li>
      </ul>
      <p>Users agree to follow KalKode's Prohibited Items List and Community Guidelines.</p>
      
      <h2>6. User Listings</h2>
      <p>Users are responsible for:</p>
      <ul>
        <li>Accuracy of item descriptions</li>
        <li>Pricing</li>
        <li>Delivery or pickup arrangements</li>
        <li>Legal compliance in their region</li>
        <li>Safety of any tools, rentals, or activities offered</li>
      </ul>
      <p>KalKode does not verify listings unless explicitly stated.</p>
      
      <h2>7. Payments, Fees & Subscription Tiers</h2>
      <p>KalKode offers:</p>
      <ul>
        <li><strong>Personal Tier:</strong> Free for take off use, one-time fee ($100–$200) after certain listing/sales thresholds</li>
        <li><strong>Business Tier:</strong> Subscription ($400–$1000 annually depending on features)</li>
      </ul>
      <p>All transactions are processed through Stripe or another compliant provider. Users are responsible for payment fees, local taxes, and reporting their own income. KalKode does not hold or store payment card information.</p>
      
      <h2>11. Disclaimers & Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, KalKode is not liable for:</p>
      <ul>
        <li>Loss or damage from user transactions</li>
        <li>Errors in listings</li>
        <li>Identity fraud by other users</li>
        <li>Personal injury during meetups or events</li>
        <li>Downtime or technical errors</li>
        <li>Indirect, incidental, punitive, or consequential damages</li>
      </ul>
      <p>Your sole remedy is to discontinue using the platform.</p>
      
      <h2>14. Governing Law</h2>
      <p>Because KalKode operates internationally:</p>
      <ul>
        <li>For U.S. users → U.S. federal law + user's home state law applies</li>
        <li>For EU users → GDPR compliance applies</li>
        <li>For all others → Local governing laws plus international standards apply</li>
      </ul>
      
      <h1>🔒 KalKode Privacy Policy</h1>
      
      <h2>1. Information We Collect</h2>
      <h3>A. Information You Provide</h3>
      <ul>
        <li>Name, email, phone</li>
        <li>Address or general location</li>
        <li>Listing content</li>
        <li>Messages and communications</li>
        <li>Payment details (processed by Stripe, not stored by KalKode)</li>
      </ul>
      
      <h3>B. Automatically Collected</h3>
      <ul>
        <li>Device and browser information</li>
        <li>IP address</li>
        <li>Cookies and analytics data</li>
        <li>Location data (if enabled)</li>
      </ul>
      
      <h2>2. How We Use Your Data</h2>
      <p>To:</p>
      <ul>
        <li>Operate the marketplace</li>
        <li>Process transactions</li>
        <li>Show local listings based on proximity</li>
        <li>Improve platform performance</li>
        <li>Prevent fraud and abuse</li>
        <li>Communicate important updates</li>
        <li>Comply with legal requirements</li>
      </ul>
      <p>Marketing messages are optional & can be disabled.</p>
      
      <h2>4. How We Share Information</h2>
      <p>We may share with:</p>
      <ul>
        <li><strong>Other Users:</strong> only what is needed to transact</li>
        <li><strong>Service Providers:</strong> Stripe, hosting, SMS/email tools</li>
        <li><strong>Law Enforcement:</strong> when legally required</li>
        <li><strong>Analytics tools:</strong> anonymized whenever possible</li>
      </ul>
      <p><strong>We never sell personal data.</strong></p>
      
      <h2>9. User Rights</h2>
      <h3>EU Users (GDPR):</h3>
      <ul>
        <li>Access</li>
        <li>Rectification</li>
        <li>Erasure</li>
        <li>Portability</li>
        <li>Restriction</li>
        <li>Objection</li>
        <li>Withdraw consent</li>
      </ul>
      
      <h3>U.S. Users & California (CCPA):</h3>
      <ul>
        <li>Right to know what data is collected</li>
        <li>Right to delete</li>
        <li>Right to opt-out of data selling (we do not sell)</li>
        <li>Right to non-discrimination</li>
      </ul>
      
      <h2>11. Contact Information</h2>
      <p>For privacy questions or data requests:</p>
      <p><strong>Email:</strong> KalTheKode@gmail.com</p>
      
      <h2>🚫 Prohibited Items</h2>
      <p>Users may NOT list:</p>
      <ul>
        <li>Illegal or Restricted Items (drugs, stolen goods, firearms, explosives, hazardous materials)</li>
        <li>Healthcare & Personal Safety items requiring certification</li>
        <li>Items promoting violence or hate</li>
        <li>High-Risk Services without proper licensing</li>
        <li>Endangered species or animals prohibited by local law</li>
      </ul>
      
      <h2>🌱 Community Guidelines</h2>
      <p>Users must:</p>
      <ul>
        <li>Treat others with respect</li>
        <li>Show up for events or cancel respectfully</li>
        <li>Describe items accurately</li>
        <li>Meet in safe, public places</li>
        <li>Avoid spam, scams, and harassment</li>
        <li>Report suspicious activity</li>
        <li>Follow local laws and regulations</li>
      </ul>
    </TermsContent>
  </TermsContainer>
</TermsOverlay>

    {/* Sign-in prompt overlay — shown when arriving from an invitation email link */}
    {showSignInPrompt && !isAuthenticated && (
      <div
        onClick={() => setShowSignInPrompt(false)}
        style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          background: 'rgba(0,0,0,0.75)',
          backdropFilter: 'blur(6px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '1rem'
        }}
      >
        <div
          onClick={e => e.stopPropagation()}
          style={{
            background: '#1a1a1a',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: '20px',
            padding: '2.5rem 2rem',
            maxWidth: '380px',
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 24px 60px rgba(0,0,0,0.5)'
          }}
        >
          <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>🏪</div>
          <h2 style={{ margin: '0 0 0.5rem', color: '#fff', fontSize: '1.3rem', fontWeight: 700 }}>
            {inviteShopName ? `You've been added to ${inviteShopName}` : "You've been added to a store"}
          </h2>
          <p style={{ margin: '0 0 2rem', color: 'rgba(255,255,255,0.55)', fontSize: '0.9rem', lineHeight: 1.6 }}>
            Sign in with Google to activate your access and start managing the store.
          </p>
          <button
            onClick={() => { setShowSignInPrompt(false); handleGoogleSignIn(); }}
            disabled={authLoading}
            style={{
              width: '100%',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem',
              padding: '0.9rem 1.5rem',
              background: '#fff',
              color: '#333',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: authLoading ? 'not-allowed' : 'pointer',
              opacity: authLoading ? 0.6 : 1,
              transition: 'opacity 0.2s'
            }}
          >
            <img src="https://cdn.cdnlogo.com/logos/g/35/google-icon.svg" alt="Google" style={{ width: 22, height: 22 }} />
            {authLoading ? 'Signing in…' : 'Sign in with Google'}
          </button>
          <button
            onClick={() => setShowSignInPrompt(false)}
            style={{ marginTop: '1rem', background: 'none', border: 'none', color: 'rgba(255,255,255,0.35)', fontSize: '0.8rem', cursor: 'pointer' }}
          >
            Dismiss
          </button>
        </div>
      </div>
    )}

    </PageContainer>
  );
};

class WelcomePageErrorBoundary extends React.Component {
  state = { hasError: false };
  
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  
  componentDidCatch(error, errorInfo) {
    console.error('WelcomePage error:', error, errorInfo);
  }
  
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '2rem', 
          textAlign: 'center',
          color: 'white' 
        }}>
          <h2>Something went wrong</h2>
          <button onClick={() => window.location.reload()}>
            Reload Page
          </button>
        </div>
      );
    }
    
    return this.props.children;
  }
}

// Wrap export
export default function WelcomePageWithBoundary() {
  return (
    <WelcomePageErrorBoundary>
      <WelcomePage />
    </WelcomePageErrorBoundary>
  );
}